/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type ApplicationAccessGrantedOrganizationsAggregateInput = {
  AND?: Array<ApplicationAccessGrantedOrganizationsAggregateInput> | null | undefined;
  NOT?: ApplicationAccessGrantedOrganizationsAggregateInput | null | undefined;
  OR?: Array<ApplicationAccessGrantedOrganizationsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: OrganizationConnectWhere | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsConnectionWhere = {
  AND?: Array<ApplicationAccessGrantedOrganizationsConnectionWhere> | null | undefined;
  NOT?: ApplicationAccessGrantedOrganizationsConnectionWhere | null | undefined;
  OR?: Array<ApplicationAccessGrantedOrganizationsConnectionWhere> | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ApplicationAccessGrantedOrganizationsDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: ApplicationAccessGrantedOrganizationsConnectionWhere | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: ApplicationAccessGrantedOrganizationsConnectionWhere | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsFieldInput = {
  connect?: Array<ApplicationAccessGrantedOrganizationsConnectFieldInput> | null | undefined;
  create?: Array<ApplicationAccessGrantedOrganizationsCreateFieldInput> | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput = {
  AND?: Array<ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput> | null | undefined;
  NOT?: ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput | null | undefined;
  OR?: Array<ApplicationAccessGrantedOrganizationsNodeAggregationWhereInput> | null | undefined;
  address1_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address1_AVERAGE_LENGTH_GT?: number | null | undefined;
  address1_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address1_AVERAGE_LENGTH_LT?: number | null | undefined;
  address1_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address1_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address1_LONGEST_LENGTH_GT?: number | null | undefined;
  address1_LONGEST_LENGTH_GTE?: number | null | undefined;
  address1_LONGEST_LENGTH_LT?: number | null | undefined;
  address1_LONGEST_LENGTH_LTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address1_SHORTEST_LENGTH_GT?: number | null | undefined;
  address1_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_LT?: number | null | undefined;
  address1_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address2_AVERAGE_LENGTH_GT?: number | null | undefined;
  address2_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_LT?: number | null | undefined;
  address2_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address2_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address2_LONGEST_LENGTH_GT?: number | null | undefined;
  address2_LONGEST_LENGTH_GTE?: number | null | undefined;
  address2_LONGEST_LENGTH_LT?: number | null | undefined;
  address2_LONGEST_LENGTH_LTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address2_SHORTEST_LENGTH_GT?: number | null | undefined;
  address2_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_LT?: number | null | undefined;
  address2_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address3_AVERAGE_LENGTH_GT?: number | null | undefined;
  address3_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_LT?: number | null | undefined;
  address3_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address3_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address3_LONGEST_LENGTH_GT?: number | null | undefined;
  address3_LONGEST_LENGTH_GTE?: number | null | undefined;
  address3_LONGEST_LENGTH_LT?: number | null | undefined;
  address3_LONGEST_LENGTH_LTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address3_SHORTEST_LENGTH_GT?: number | null | undefined;
  address3_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_LT?: number | null | undefined;
  address3_SHORTEST_LENGTH_LTE?: number | null | undefined;
  city_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  city_AVERAGE_LENGTH_GT?: number | null | undefined;
  city_AVERAGE_LENGTH_GTE?: number | null | undefined;
  city_AVERAGE_LENGTH_LT?: number | null | undefined;
  city_AVERAGE_LENGTH_LTE?: number | null | undefined;
  city_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  city_LONGEST_LENGTH_GT?: number | null | undefined;
  city_LONGEST_LENGTH_GTE?: number | null | undefined;
  city_LONGEST_LENGTH_LT?: number | null | undefined;
  city_LONGEST_LENGTH_LTE?: number | null | undefined;
  city_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  city_SHORTEST_LENGTH_GT?: number | null | undefined;
  city_SHORTEST_LENGTH_GTE?: number | null | undefined;
  city_SHORTEST_LENGTH_LT?: number | null | undefined;
  city_SHORTEST_LENGTH_LTE?: number | null | undefined;
  country_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  country_AVERAGE_LENGTH_GT?: number | null | undefined;
  country_AVERAGE_LENGTH_GTE?: number | null | undefined;
  country_AVERAGE_LENGTH_LT?: number | null | undefined;
  country_AVERAGE_LENGTH_LTE?: number | null | undefined;
  country_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  country_LONGEST_LENGTH_GT?: number | null | undefined;
  country_LONGEST_LENGTH_GTE?: number | null | undefined;
  country_LONGEST_LENGTH_LT?: number | null | undefined;
  country_LONGEST_LENGTH_LTE?: number | null | undefined;
  country_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  country_SHORTEST_LENGTH_GT?: number | null | undefined;
  country_SHORTEST_LENGTH_GTE?: number | null | undefined;
  country_SHORTEST_LENGTH_LT?: number | null | undefined;
  country_SHORTEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  region_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  region_AVERAGE_LENGTH_GT?: number | null | undefined;
  region_AVERAGE_LENGTH_GTE?: number | null | undefined;
  region_AVERAGE_LENGTH_LT?: number | null | undefined;
  region_AVERAGE_LENGTH_LTE?: number | null | undefined;
  region_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  region_LONGEST_LENGTH_GT?: number | null | undefined;
  region_LONGEST_LENGTH_GTE?: number | null | undefined;
  region_LONGEST_LENGTH_LT?: number | null | undefined;
  region_LONGEST_LENGTH_LTE?: number | null | undefined;
  region_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  region_SHORTEST_LENGTH_GT?: number | null | undefined;
  region_SHORTEST_LENGTH_GTE?: number | null | undefined;
  region_SHORTEST_LENGTH_LT?: number | null | undefined;
  region_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_LONGEST_LENGTH_GT?: number | null | undefined;
  timezone_LONGEST_LENGTH_GTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_LT?: number | null | undefined;
  timezone_LONGEST_LENGTH_LTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsUpdateConnectionInput = {
  node?: OrganizationUpdateInput | null | undefined;
};

export type ApplicationAccessGrantedOrganizationsUpdateFieldInput = {
  connect?: Array<ApplicationAccessGrantedOrganizationsConnectFieldInput> | null | undefined;
  create?: Array<ApplicationAccessGrantedOrganizationsCreateFieldInput> | null | undefined;
  delete?: Array<ApplicationAccessGrantedOrganizationsDeleteFieldInput> | null | undefined;
  disconnect?: Array<ApplicationAccessGrantedOrganizationsDisconnectFieldInput> | null | undefined;
  update?: ApplicationAccessGrantedOrganizationsUpdateConnectionInput | null | undefined;
  where?: ApplicationAccessGrantedOrganizationsConnectionWhere | null | undefined;
};

export type ApplicationAccessGrantedProfilesAggregateInput = {
  AND?: Array<ApplicationAccessGrantedProfilesAggregateInput> | null | undefined;
  NOT?: ApplicationAccessGrantedProfilesAggregateInput | null | undefined;
  OR?: Array<ApplicationAccessGrantedProfilesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: ApplicationAccessGrantedProfilesNodeAggregationWhereInput | null | undefined;
};

export type ApplicationAccessGrantedProfilesConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: ProfileConnectWhere | null | undefined;
};

export type ApplicationAccessGrantedProfilesConnectionWhere = {
  AND?: Array<ApplicationAccessGrantedProfilesConnectionWhere> | null | undefined;
  NOT?: ApplicationAccessGrantedProfilesConnectionWhere | null | undefined;
  OR?: Array<ApplicationAccessGrantedProfilesConnectionWhere> | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type ApplicationAccessGrantedProfilesCreateFieldInput = {
  node: ProfileCreateInput;
};

export type ApplicationAccessGrantedProfilesDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: ApplicationAccessGrantedProfilesConnectionWhere | null | undefined;
};

export type ApplicationAccessGrantedProfilesDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: ApplicationAccessGrantedProfilesConnectionWhere | null | undefined;
};

export type ApplicationAccessGrantedProfilesFieldInput = {
  connect?: Array<ApplicationAccessGrantedProfilesConnectFieldInput> | null | undefined;
  create?: Array<ApplicationAccessGrantedProfilesCreateFieldInput> | null | undefined;
};

export type ApplicationAccessGrantedProfilesNodeAggregationWhereInput = {
  AND?: Array<ApplicationAccessGrantedProfilesNodeAggregationWhereInput> | null | undefined;
  NOT?: ApplicationAccessGrantedProfilesNodeAggregationWhereInput | null | undefined;
  OR?: Array<ApplicationAccessGrantedProfilesNodeAggregationWhereInput> | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_LONGEST_LENGTH_GT?: number | null | undefined;
  firstName_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_LT?: number | null | undefined;
  firstName_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_LONGEST_LENGTH_GT?: number | null | undefined;
  lastName_LONGEST_LENGTH_GTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_LT?: number | null | undefined;
  lastName_LONGEST_LENGTH_LTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_LONGEST_LENGTH_GT?: number | null | undefined;
  salutation_LONGEST_LENGTH_GTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_LT?: number | null | undefined;
  salutation_LONGEST_LENGTH_LTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_LONGEST_LENGTH_GT?: number | null | undefined;
  shortName_LONGEST_LENGTH_GTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_LT?: number | null | undefined;
  shortName_LONGEST_LENGTH_LTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  title_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  title_AVERAGE_LENGTH_GT?: number | null | undefined;
  title_AVERAGE_LENGTH_GTE?: number | null | undefined;
  title_AVERAGE_LENGTH_LT?: number | null | undefined;
  title_AVERAGE_LENGTH_LTE?: number | null | undefined;
  title_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  title_LONGEST_LENGTH_GT?: number | null | undefined;
  title_LONGEST_LENGTH_GTE?: number | null | undefined;
  title_LONGEST_LENGTH_LT?: number | null | undefined;
  title_LONGEST_LENGTH_LTE?: number | null | undefined;
  title_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  title_SHORTEST_LENGTH_GT?: number | null | undefined;
  title_SHORTEST_LENGTH_GTE?: number | null | undefined;
  title_SHORTEST_LENGTH_LT?: number | null | undefined;
  title_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosAccepted_MAX_EQUAL?: string | null | undefined;
  tosAccepted_MAX_GT?: string | null | undefined;
  tosAccepted_MAX_GTE?: string | null | undefined;
  tosAccepted_MAX_LT?: string | null | undefined;
  tosAccepted_MAX_LTE?: string | null | undefined;
  tosAccepted_MIN_EQUAL?: string | null | undefined;
  tosAccepted_MIN_GT?: string | null | undefined;
  tosAccepted_MIN_GTE?: string | null | undefined;
  tosAccepted_MIN_LT?: string | null | undefined;
  tosAccepted_MIN_LTE?: string | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ApplicationAccessGrantedProfilesUpdateConnectionInput = {
  node?: ProfileUpdateInput | null | undefined;
};

export type ApplicationAccessGrantedProfilesUpdateFieldInput = {
  connect?: Array<ApplicationAccessGrantedProfilesConnectFieldInput> | null | undefined;
  create?: Array<ApplicationAccessGrantedProfilesCreateFieldInput> | null | undefined;
  delete?: Array<ApplicationAccessGrantedProfilesDeleteFieldInput> | null | undefined;
  disconnect?: Array<ApplicationAccessGrantedProfilesDisconnectFieldInput> | null | undefined;
  update?: ApplicationAccessGrantedProfilesUpdateConnectionInput | null | undefined;
  where?: ApplicationAccessGrantedProfilesConnectionWhere | null | undefined;
};

export type ApplicationCreateInput = {
  accessGrantedOrganizations?: ApplicationAccessGrantedOrganizationsFieldInput | null | undefined;
  accessGrantedProfiles?: ApplicationAccessGrantedProfilesFieldInput | null | undefined;
  clientId: string | number;
  licensedOrganizations?: ApplicationLicensedOrganizationsFieldInput | null | undefined;
  name: string;
  uri?: string | null | undefined;
};

export type ApplicationLicensedOrganizationsAggregateInput = {
  AND?: Array<ApplicationLicensedOrganizationsAggregateInput> | null | undefined;
  NOT?: ApplicationLicensedOrganizationsAggregateInput | null | undefined;
  OR?: Array<ApplicationLicensedOrganizationsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: LicensePropertiesAggregationWhereInput | null | undefined;
  node?: ApplicationLicensedOrganizationsNodeAggregationWhereInput | null | undefined;
};

export type ApplicationLicensedOrganizationsConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge?: LicensePropertiesCreateInput | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: OrganizationConnectWhere | null | undefined;
};

export type ApplicationLicensedOrganizationsConnectionWhere = {
  AND?: Array<ApplicationLicensedOrganizationsConnectionWhere> | null | undefined;
  NOT?: ApplicationLicensedOrganizationsConnectionWhere | null | undefined;
  OR?: Array<ApplicationLicensedOrganizationsConnectionWhere> | null | undefined;
  edge?: LicensePropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: LicensePropertiesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type ApplicationLicensedOrganizationsCreateFieldInput = {
  edge?: LicensePropertiesCreateInput | null | undefined;
  node: OrganizationCreateInput;
};

export type ApplicationLicensedOrganizationsDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: ApplicationLicensedOrganizationsConnectionWhere | null | undefined;
};

export type ApplicationLicensedOrganizationsDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: ApplicationLicensedOrganizationsConnectionWhere | null | undefined;
};

export type ApplicationLicensedOrganizationsFieldInput = {
  connect?: Array<ApplicationLicensedOrganizationsConnectFieldInput> | null | undefined;
  create?: Array<ApplicationLicensedOrganizationsCreateFieldInput> | null | undefined;
};

export type ApplicationLicensedOrganizationsNodeAggregationWhereInput = {
  AND?: Array<ApplicationLicensedOrganizationsNodeAggregationWhereInput> | null | undefined;
  NOT?: ApplicationLicensedOrganizationsNodeAggregationWhereInput | null | undefined;
  OR?: Array<ApplicationLicensedOrganizationsNodeAggregationWhereInput> | null | undefined;
  address1_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address1_AVERAGE_LENGTH_GT?: number | null | undefined;
  address1_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address1_AVERAGE_LENGTH_LT?: number | null | undefined;
  address1_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address1_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address1_LONGEST_LENGTH_GT?: number | null | undefined;
  address1_LONGEST_LENGTH_GTE?: number | null | undefined;
  address1_LONGEST_LENGTH_LT?: number | null | undefined;
  address1_LONGEST_LENGTH_LTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address1_SHORTEST_LENGTH_GT?: number | null | undefined;
  address1_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_LT?: number | null | undefined;
  address1_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address2_AVERAGE_LENGTH_GT?: number | null | undefined;
  address2_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_LT?: number | null | undefined;
  address2_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address2_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address2_LONGEST_LENGTH_GT?: number | null | undefined;
  address2_LONGEST_LENGTH_GTE?: number | null | undefined;
  address2_LONGEST_LENGTH_LT?: number | null | undefined;
  address2_LONGEST_LENGTH_LTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address2_SHORTEST_LENGTH_GT?: number | null | undefined;
  address2_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_LT?: number | null | undefined;
  address2_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address3_AVERAGE_LENGTH_GT?: number | null | undefined;
  address3_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_LT?: number | null | undefined;
  address3_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address3_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address3_LONGEST_LENGTH_GT?: number | null | undefined;
  address3_LONGEST_LENGTH_GTE?: number | null | undefined;
  address3_LONGEST_LENGTH_LT?: number | null | undefined;
  address3_LONGEST_LENGTH_LTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address3_SHORTEST_LENGTH_GT?: number | null | undefined;
  address3_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_LT?: number | null | undefined;
  address3_SHORTEST_LENGTH_LTE?: number | null | undefined;
  city_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  city_AVERAGE_LENGTH_GT?: number | null | undefined;
  city_AVERAGE_LENGTH_GTE?: number | null | undefined;
  city_AVERAGE_LENGTH_LT?: number | null | undefined;
  city_AVERAGE_LENGTH_LTE?: number | null | undefined;
  city_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  city_LONGEST_LENGTH_GT?: number | null | undefined;
  city_LONGEST_LENGTH_GTE?: number | null | undefined;
  city_LONGEST_LENGTH_LT?: number | null | undefined;
  city_LONGEST_LENGTH_LTE?: number | null | undefined;
  city_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  city_SHORTEST_LENGTH_GT?: number | null | undefined;
  city_SHORTEST_LENGTH_GTE?: number | null | undefined;
  city_SHORTEST_LENGTH_LT?: number | null | undefined;
  city_SHORTEST_LENGTH_LTE?: number | null | undefined;
  country_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  country_AVERAGE_LENGTH_GT?: number | null | undefined;
  country_AVERAGE_LENGTH_GTE?: number | null | undefined;
  country_AVERAGE_LENGTH_LT?: number | null | undefined;
  country_AVERAGE_LENGTH_LTE?: number | null | undefined;
  country_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  country_LONGEST_LENGTH_GT?: number | null | undefined;
  country_LONGEST_LENGTH_GTE?: number | null | undefined;
  country_LONGEST_LENGTH_LT?: number | null | undefined;
  country_LONGEST_LENGTH_LTE?: number | null | undefined;
  country_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  country_SHORTEST_LENGTH_GT?: number | null | undefined;
  country_SHORTEST_LENGTH_GTE?: number | null | undefined;
  country_SHORTEST_LENGTH_LT?: number | null | undefined;
  country_SHORTEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  region_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  region_AVERAGE_LENGTH_GT?: number | null | undefined;
  region_AVERAGE_LENGTH_GTE?: number | null | undefined;
  region_AVERAGE_LENGTH_LT?: number | null | undefined;
  region_AVERAGE_LENGTH_LTE?: number | null | undefined;
  region_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  region_LONGEST_LENGTH_GT?: number | null | undefined;
  region_LONGEST_LENGTH_GTE?: number | null | undefined;
  region_LONGEST_LENGTH_LT?: number | null | undefined;
  region_LONGEST_LENGTH_LTE?: number | null | undefined;
  region_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  region_SHORTEST_LENGTH_GT?: number | null | undefined;
  region_SHORTEST_LENGTH_GTE?: number | null | undefined;
  region_SHORTEST_LENGTH_LT?: number | null | undefined;
  region_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_LONGEST_LENGTH_GT?: number | null | undefined;
  timezone_LONGEST_LENGTH_GTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_LT?: number | null | undefined;
  timezone_LONGEST_LENGTH_LTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ApplicationLicensedOrganizationsUpdateConnectionInput = {
  edge?: LicensePropertiesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type ApplicationLicensedOrganizationsUpdateFieldInput = {
  connect?: Array<ApplicationLicensedOrganizationsConnectFieldInput> | null | undefined;
  create?: Array<ApplicationLicensedOrganizationsCreateFieldInput> | null | undefined;
  delete?: Array<ApplicationLicensedOrganizationsDeleteFieldInput> | null | undefined;
  disconnect?: Array<ApplicationLicensedOrganizationsDisconnectFieldInput> | null | undefined;
  update?: ApplicationLicensedOrganizationsUpdateConnectionInput | null | undefined;
  where?: ApplicationLicensedOrganizationsConnectionWhere | null | undefined;
};

export type ApplicationUpdateInput = {
  accessGrantedOrganizations?:
    | Array<ApplicationAccessGrantedOrganizationsUpdateFieldInput>
    | null
    | undefined;
  accessGrantedProfiles?:
    | Array<ApplicationAccessGrantedProfilesUpdateFieldInput>
    | null
    | undefined;
  clientId?: string | number | null | undefined;
  licensedOrganizations?:
    | Array<ApplicationLicensedOrganizationsUpdateFieldInput>
    | null
    | undefined;
  name?: string | null | undefined;
  uri?: string | null | undefined;
};

export type ApplicationWhere = {
  AND?: Array<ApplicationWhere> | null | undefined;
  NOT?: ApplicationWhere | null | undefined;
  OR?: Array<ApplicationWhere> | null | undefined;
  /** @deprecated Use `accessGrantedOrganizations_SOME` instead. */
  accessGrantedOrganizations?: OrganizationWhere | null | undefined;
  accessGrantedOrganizationsAggregate?:
    | ApplicationAccessGrantedOrganizationsAggregateInput
    | null
    | undefined;
  /** @deprecated Use `accessGrantedOrganizationsConnection_SOME` instead. */
  accessGrantedOrganizationsConnection?:
    | ApplicationAccessGrantedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where all of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_ALL?:
    | ApplicationAccessGrantedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where none of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_NONE?:
    | ApplicationAccessGrantedOrganizationsConnectionWhere
    | null
    | undefined;
  /** @deprecated Use `accessGrantedOrganizationsConnection_NONE` instead. */
  accessGrantedOrganizationsConnection_NOT?:
    | ApplicationAccessGrantedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where one of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_SINGLE?:
    | ApplicationAccessGrantedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where some of the related ApplicationAccessGrantedOrganizationsConnections match this filter */
  accessGrantedOrganizationsConnection_SOME?:
    | ApplicationAccessGrantedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where all of the related Organizations match this filter */
  accessGrantedOrganizations_ALL?: OrganizationWhere | null | undefined;
  /** Return Applications where none of the related Organizations match this filter */
  accessGrantedOrganizations_NONE?: OrganizationWhere | null | undefined;
  /** @deprecated Use `accessGrantedOrganizations_NONE` instead. */
  accessGrantedOrganizations_NOT?: OrganizationWhere | null | undefined;
  /** Return Applications where one of the related Organizations match this filter */
  accessGrantedOrganizations_SINGLE?: OrganizationWhere | null | undefined;
  /** Return Applications where some of the related Organizations match this filter */
  accessGrantedOrganizations_SOME?: OrganizationWhere | null | undefined;
  /** @deprecated Use `accessGrantedProfiles_SOME` instead. */
  accessGrantedProfiles?: ProfileWhere | null | undefined;
  accessGrantedProfilesAggregate?:
    | ApplicationAccessGrantedProfilesAggregateInput
    | null
    | undefined;
  /** @deprecated Use `accessGrantedProfilesConnection_SOME` instead. */
  accessGrantedProfilesConnection?:
    | ApplicationAccessGrantedProfilesConnectionWhere
    | null
    | undefined;
  /** Return Applications where all of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_ALL?:
    | ApplicationAccessGrantedProfilesConnectionWhere
    | null
    | undefined;
  /** Return Applications where none of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_NONE?:
    | ApplicationAccessGrantedProfilesConnectionWhere
    | null
    | undefined;
  /** @deprecated Use `accessGrantedProfilesConnection_NONE` instead. */
  accessGrantedProfilesConnection_NOT?:
    | ApplicationAccessGrantedProfilesConnectionWhere
    | null
    | undefined;
  /** Return Applications where one of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_SINGLE?:
    | ApplicationAccessGrantedProfilesConnectionWhere
    | null
    | undefined;
  /** Return Applications where some of the related ApplicationAccessGrantedProfilesConnections match this filter */
  accessGrantedProfilesConnection_SOME?:
    | ApplicationAccessGrantedProfilesConnectionWhere
    | null
    | undefined;
  /** Return Applications where all of the related Profiles match this filter */
  accessGrantedProfiles_ALL?: ProfileWhere | null | undefined;
  /** Return Applications where none of the related Profiles match this filter */
  accessGrantedProfiles_NONE?: ProfileWhere | null | undefined;
  /** @deprecated Use `accessGrantedProfiles_NONE` instead. */
  accessGrantedProfiles_NOT?: ProfileWhere | null | undefined;
  /** Return Applications where one of the related Profiles match this filter */
  accessGrantedProfiles_SINGLE?: ProfileWhere | null | undefined;
  /** Return Applications where some of the related Profiles match this filter */
  accessGrantedProfiles_SOME?: ProfileWhere | null | undefined;
  clientId?: string | number | null | undefined;
  clientId_CONTAINS?: string | number | null | undefined;
  clientId_ENDS_WITH?: string | number | null | undefined;
  clientId_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_STARTS_WITH?: string | number | null | undefined;
  clientId_STARTS_WITH?: string | number | null | undefined;
  /** @deprecated Use `licensedOrganizations_SOME` instead. */
  licensedOrganizations?: OrganizationWhere | null | undefined;
  licensedOrganizationsAggregate?:
    | ApplicationLicensedOrganizationsAggregateInput
    | null
    | undefined;
  /** @deprecated Use `licensedOrganizationsConnection_SOME` instead. */
  licensedOrganizationsConnection?:
    | ApplicationLicensedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where all of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_ALL?:
    | ApplicationLicensedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where none of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_NONE?:
    | ApplicationLicensedOrganizationsConnectionWhere
    | null
    | undefined;
  /** @deprecated Use `licensedOrganizationsConnection_NONE` instead. */
  licensedOrganizationsConnection_NOT?:
    | ApplicationLicensedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where one of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_SINGLE?:
    | ApplicationLicensedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where some of the related ApplicationLicensedOrganizationsConnections match this filter */
  licensedOrganizationsConnection_SOME?:
    | ApplicationLicensedOrganizationsConnectionWhere
    | null
    | undefined;
  /** Return Applications where all of the related Organizations match this filter */
  licensedOrganizations_ALL?: OrganizationWhere | null | undefined;
  /** Return Applications where none of the related Organizations match this filter */
  licensedOrganizations_NONE?: OrganizationWhere | null | undefined;
  /** @deprecated Use `licensedOrganizations_NONE` instead. */
  licensedOrganizations_NOT?: OrganizationWhere | null | undefined;
  /** Return Applications where one of the related Organizations match this filter */
  licensedOrganizations_SINGLE?: OrganizationWhere | null | undefined;
  /** Return Applications where some of the related Organizations match this filter */
  licensedOrganizations_SOME?: OrganizationWhere | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  uri?: string | null | undefined;
  uri_CONTAINS?: string | null | undefined;
  uri_ENDS_WITH?: string | null | undefined;
  uri_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uri_NOT_STARTS_WITH?: string | null | undefined;
  uri_STARTS_WITH?: string | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
};

export type AuthClientCreateInput = {
  clientId: string | number;
  clientName?: string | null | undefined;
  clientSecret?: string | null | undefined;
  grantTypes: Array<string>;
  idTokenSignedResponseAlg?: string | null | undefined;
  logoUri?: string | null | undefined;
  policyUri?: string | null | undefined;
  postLogoutRedirectUris?: Array<string> | null | undefined;
  redirectUris?: Array<string> | null | undefined;
  responseTypes: Array<string>;
  scope?: string | null | undefined;
  tksExtensionConsentOptional?: boolean | null | undefined;
  tksExtensionLicenseOptional?: boolean | null | undefined;
  tksExtensionPkceOptional?: boolean | null | undefined;
  tokenEndpointAuthMethod: string;
  tosUri?: string | null | undefined;
};

export type AuthClientUpdateInput = {
  clientName?: string | null | undefined;
  clientSecret?: string | null | undefined;
  grantTypes?: Array<string> | null | undefined;
  idTokenSignedResponseAlg?: string | null | undefined;
  logoUri?: string | null | undefined;
  policyUri?: string | null | undefined;
  postLogoutRedirectUris?: Array<string> | null | undefined;
  redirectUris?: Array<string> | null | undefined;
  responseTypes?: Array<string> | null | undefined;
  scope?: string | null | undefined;
  tksExtensionConsentOptional?: boolean | null | undefined;
  tksExtensionLicenseOptional?: boolean | null | undefined;
  tksExtensionPkceOptional?: boolean | null | undefined;
  tokenEndpointAuthMethod?: string | null | undefined;
  tosUri?: string | null | undefined;
};

export type CollaborationPropertiesAggregationWhereInput = {
  AND?: Array<CollaborationPropertiesAggregationWhereInput> | null | undefined;
  NOT?: CollaborationPropertiesAggregationWhereInput | null | undefined;
  OR?: Array<CollaborationPropertiesAggregationWhereInput> | null | undefined;
  sourceOrganization_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  sourceOrganization_AVERAGE_LENGTH_GT?: number | null | undefined;
  sourceOrganization_AVERAGE_LENGTH_GTE?: number | null | undefined;
  sourceOrganization_AVERAGE_LENGTH_LT?: number | null | undefined;
  sourceOrganization_AVERAGE_LENGTH_LTE?: number | null | undefined;
  sourceOrganization_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  sourceOrganization_LONGEST_LENGTH_GT?: number | null | undefined;
  sourceOrganization_LONGEST_LENGTH_GTE?: number | null | undefined;
  sourceOrganization_LONGEST_LENGTH_LT?: number | null | undefined;
  sourceOrganization_LONGEST_LENGTH_LTE?: number | null | undefined;
  sourceOrganization_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  sourceOrganization_SHORTEST_LENGTH_GT?: number | null | undefined;
  sourceOrganization_SHORTEST_LENGTH_GTE?: number | null | undefined;
  sourceOrganization_SHORTEST_LENGTH_LT?: number | null | undefined;
  sourceOrganization_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type CollaborationPropertiesCreateInput = {
  sourceOrganization?: string | null | undefined;
  status: CollaborationStatus;
};

export type CollaborationPropertiesUpdateInput = {
  sourceOrganization?: string | null | undefined;
  status?: CollaborationStatus | null | undefined;
};

export type CollaborationPropertiesWhere = {
  AND?: Array<CollaborationPropertiesWhere> | null | undefined;
  NOT?: CollaborationPropertiesWhere | null | undefined;
  OR?: Array<CollaborationPropertiesWhere> | null | undefined;
  sourceOrganization?: string | null | undefined;
  sourceOrganization_CONTAINS?: string | null | undefined;
  sourceOrganization_ENDS_WITH?: string | null | undefined;
  sourceOrganization_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sourceOrganization_NOT_STARTS_WITH?: string | null | undefined;
  sourceOrganization_STARTS_WITH?: string | null | undefined;
  status?: CollaborationStatus | null | undefined;
  status_IN?: Array<CollaborationStatus> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: CollaborationStatus | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: Array<CollaborationStatus> | null | undefined;
};

export type CollaborationStatus =
  | "COLLABORATION"
  | "COLLABORATION_CANCELLED"
  | "NO_COLLABORATION"
  | "NO_COLLABORATION_POSSIBLE"
  | "PENDING";

export type FederatedClientConnectWhere = {
  node: FederatedClientWhere;
};

export type FederatedClientCreateInput = {
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  customIdClaims?: Array<string> | null | undefined;
  issuer: string;
  label: string;
  name: string;
  responseTypes: Array<string>;
};

export type FederatedClientPropertiesAggregationWhereInput = {
  AND?: Array<FederatedClientPropertiesAggregationWhereInput> | null | undefined;
  NOT?: FederatedClientPropertiesAggregationWhereInput | null | undefined;
  OR?: Array<FederatedClientPropertiesAggregationWhereInput> | null | undefined;
  birthdate_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  birthdate_AVERAGE_LENGTH_GT?: number | null | undefined;
  birthdate_AVERAGE_LENGTH_GTE?: number | null | undefined;
  birthdate_AVERAGE_LENGTH_LT?: number | null | undefined;
  birthdate_AVERAGE_LENGTH_LTE?: number | null | undefined;
  birthdate_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  birthdate_LONGEST_LENGTH_GT?: number | null | undefined;
  birthdate_LONGEST_LENGTH_GTE?: number | null | undefined;
  birthdate_LONGEST_LENGTH_LT?: number | null | undefined;
  birthdate_LONGEST_LENGTH_LTE?: number | null | undefined;
  birthdate_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  birthdate_SHORTEST_LENGTH_GT?: number | null | undefined;
  birthdate_SHORTEST_LENGTH_GTE?: number | null | undefined;
  birthdate_SHORTEST_LENGTH_LT?: number | null | undefined;
  birthdate_SHORTEST_LENGTH_LTE?: number | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  familyName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  familyName_AVERAGE_LENGTH_GT?: number | null | undefined;
  familyName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  familyName_AVERAGE_LENGTH_LT?: number | null | undefined;
  familyName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  familyName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  familyName_LONGEST_LENGTH_GT?: number | null | undefined;
  familyName_LONGEST_LENGTH_GTE?: number | null | undefined;
  familyName_LONGEST_LENGTH_LT?: number | null | undefined;
  familyName_LONGEST_LENGTH_LTE?: number | null | undefined;
  familyName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  familyName_SHORTEST_LENGTH_GT?: number | null | undefined;
  familyName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  familyName_SHORTEST_LENGTH_LT?: number | null | undefined;
  familyName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  gender_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  gender_AVERAGE_LENGTH_GT?: number | null | undefined;
  gender_AVERAGE_LENGTH_GTE?: number | null | undefined;
  gender_AVERAGE_LENGTH_LT?: number | null | undefined;
  gender_AVERAGE_LENGTH_LTE?: number | null | undefined;
  gender_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  gender_LONGEST_LENGTH_GT?: number | null | undefined;
  gender_LONGEST_LENGTH_GTE?: number | null | undefined;
  gender_LONGEST_LENGTH_LT?: number | null | undefined;
  gender_LONGEST_LENGTH_LTE?: number | null | undefined;
  gender_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  gender_SHORTEST_LENGTH_GT?: number | null | undefined;
  gender_SHORTEST_LENGTH_GTE?: number | null | undefined;
  gender_SHORTEST_LENGTH_LT?: number | null | undefined;
  gender_SHORTEST_LENGTH_LTE?: number | null | undefined;
  givenName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  givenName_AVERAGE_LENGTH_GT?: number | null | undefined;
  givenName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  givenName_AVERAGE_LENGTH_LT?: number | null | undefined;
  givenName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  givenName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  givenName_LONGEST_LENGTH_GT?: number | null | undefined;
  givenName_LONGEST_LENGTH_GTE?: number | null | undefined;
  givenName_LONGEST_LENGTH_LT?: number | null | undefined;
  givenName_LONGEST_LENGTH_LTE?: number | null | undefined;
  givenName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  givenName_SHORTEST_LENGTH_GT?: number | null | undefined;
  givenName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  givenName_SHORTEST_LENGTH_LT?: number | null | undefined;
  givenName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  picture_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  picture_AVERAGE_LENGTH_GT?: number | null | undefined;
  picture_AVERAGE_LENGTH_GTE?: number | null | undefined;
  picture_AVERAGE_LENGTH_LT?: number | null | undefined;
  picture_AVERAGE_LENGTH_LTE?: number | null | undefined;
  picture_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  picture_LONGEST_LENGTH_GT?: number | null | undefined;
  picture_LONGEST_LENGTH_GTE?: number | null | undefined;
  picture_LONGEST_LENGTH_LT?: number | null | undefined;
  picture_LONGEST_LENGTH_LTE?: number | null | undefined;
  picture_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  picture_SHORTEST_LENGTH_GT?: number | null | undefined;
  picture_SHORTEST_LENGTH_GTE?: number | null | undefined;
  picture_SHORTEST_LENGTH_LT?: number | null | undefined;
  picture_SHORTEST_LENGTH_LTE?: number | null | undefined;
  preferred_username_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  preferred_username_AVERAGE_LENGTH_GT?: number | null | undefined;
  preferred_username_AVERAGE_LENGTH_GTE?: number | null | undefined;
  preferred_username_AVERAGE_LENGTH_LT?: number | null | undefined;
  preferred_username_AVERAGE_LENGTH_LTE?: number | null | undefined;
  preferred_username_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  preferred_username_LONGEST_LENGTH_GT?: number | null | undefined;
  preferred_username_LONGEST_LENGTH_GTE?: number | null | undefined;
  preferred_username_LONGEST_LENGTH_LT?: number | null | undefined;
  preferred_username_LONGEST_LENGTH_LTE?: number | null | undefined;
  preferred_username_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  preferred_username_SHORTEST_LENGTH_GT?: number | null | undefined;
  preferred_username_SHORTEST_LENGTH_GTE?: number | null | undefined;
  preferred_username_SHORTEST_LENGTH_LT?: number | null | undefined;
  preferred_username_SHORTEST_LENGTH_LTE?: number | null | undefined;
  sub_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  sub_AVERAGE_LENGTH_GT?: number | null | undefined;
  sub_AVERAGE_LENGTH_GTE?: number | null | undefined;
  sub_AVERAGE_LENGTH_LT?: number | null | undefined;
  sub_AVERAGE_LENGTH_LTE?: number | null | undefined;
  sub_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  sub_LONGEST_LENGTH_GT?: number | null | undefined;
  sub_LONGEST_LENGTH_GTE?: number | null | undefined;
  sub_LONGEST_LENGTH_LT?: number | null | undefined;
  sub_LONGEST_LENGTH_LTE?: number | null | undefined;
  sub_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  sub_SHORTEST_LENGTH_GT?: number | null | undefined;
  sub_SHORTEST_LENGTH_GTE?: number | null | undefined;
  sub_SHORTEST_LENGTH_LT?: number | null | undefined;
  sub_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type FederatedClientPropertiesCreateInput = {
  birthdate?: string | null | undefined;
  customId?: Array<string> | null | undefined;
  email: string;
  emailVerified: boolean;
  familyName?: string | null | undefined;
  gender?: string | null | undefined;
  givenName?: string | null | undefined;
  locale?: string | null | undefined;
  name?: string | null | undefined;
  picture?: string | null | undefined;
  preferred_username?: string | null | undefined;
  sub?: string | null | undefined;
};

export type FederatedClientPropertiesUpdateInput = {
  birthdate?: string | null | undefined;
  customId?: Array<string> | null | undefined;
  customId_POP?: number | null | undefined;
  customId_PUSH?: Array<string> | null | undefined;
  email?: string | null | undefined;
  emailVerified?: boolean | null | undefined;
  familyName?: string | null | undefined;
  gender?: string | null | undefined;
  givenName?: string | null | undefined;
  locale?: string | null | undefined;
  name?: string | null | undefined;
  picture?: string | null | undefined;
  preferred_username?: string | null | undefined;
  sub?: string | null | undefined;
};

export type FederatedClientPropertiesWhere = {
  AND?: Array<FederatedClientPropertiesWhere> | null | undefined;
  NOT?: FederatedClientPropertiesWhere | null | undefined;
  OR?: Array<FederatedClientPropertiesWhere> | null | undefined;
  birthdate?: string | null | undefined;
  birthdate_CONTAINS?: string | null | undefined;
  birthdate_ENDS_WITH?: string | null | undefined;
  birthdate_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthdate_NOT_STARTS_WITH?: string | null | undefined;
  birthdate_STARTS_WITH?: string | null | undefined;
  customId?: Array<string> | null | undefined;
  customId_INCLUDES?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customId_NOT?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customId_NOT_INCLUDES?: string | null | undefined;
  email?: string | null | undefined;
  emailVerified?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailVerified_NOT?: boolean | null | undefined;
  email_CONTAINS?: string | null | undefined;
  email_ENDS_WITH?: string | null | undefined;
  email_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: string | null | undefined;
  email_STARTS_WITH?: string | null | undefined;
  familyName?: string | null | undefined;
  familyName_CONTAINS?: string | null | undefined;
  familyName_ENDS_WITH?: string | null | undefined;
  familyName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  familyName_NOT_STARTS_WITH?: string | null | undefined;
  familyName_STARTS_WITH?: string | null | undefined;
  gender?: string | null | undefined;
  gender_CONTAINS?: string | null | undefined;
  gender_ENDS_WITH?: string | null | undefined;
  gender_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_STARTS_WITH?: string | null | undefined;
  gender_STARTS_WITH?: string | null | undefined;
  givenName?: string | null | undefined;
  givenName_CONTAINS?: string | null | undefined;
  givenName_ENDS_WITH?: string | null | undefined;
  givenName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenName_NOT_STARTS_WITH?: string | null | undefined;
  givenName_STARTS_WITH?: string | null | undefined;
  locale?: string | null | undefined;
  locale_CONTAINS?: string | null | undefined;
  locale_ENDS_WITH?: string | null | undefined;
  locale_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: string | null | undefined;
  locale_STARTS_WITH?: string | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  picture?: string | null | undefined;
  picture_CONTAINS?: string | null | undefined;
  picture_ENDS_WITH?: string | null | undefined;
  picture_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  picture_NOT_STARTS_WITH?: string | null | undefined;
  picture_STARTS_WITH?: string | null | undefined;
  preferred_username?: string | null | undefined;
  preferred_username_CONTAINS?: string | null | undefined;
  preferred_username_ENDS_WITH?: string | null | undefined;
  preferred_username_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferred_username_NOT_STARTS_WITH?: string | null | undefined;
  preferred_username_STARTS_WITH?: string | null | undefined;
  sub?: string | null | undefined;
  sub_CONTAINS?: string | null | undefined;
  sub_ENDS_WITH?: string | null | undefined;
  sub_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sub_NOT_STARTS_WITH?: string | null | undefined;
  sub_STARTS_WITH?: string | null | undefined;
};

export type FederatedClientUpdateInput = {
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  customIdClaims?: Array<string> | null | undefined;
  customIdClaims_POP?: number | null | undefined;
  customIdClaims_PUSH?: Array<string> | null | undefined;
  issuer?: string | null | undefined;
  label?: string | null | undefined;
  name?: string | null | undefined;
  responseTypes?: Array<string> | null | undefined;
  responseTypes_POP?: number | null | undefined;
  responseTypes_PUSH?: Array<string> | null | undefined;
};

export type FederatedClientWhere = {
  AND?: Array<FederatedClientWhere> | null | undefined;
  NOT?: FederatedClientWhere | null | undefined;
  OR?: Array<FederatedClientWhere> | null | undefined;
  clientId?: string | null | undefined;
  clientId_CONTAINS?: string | null | undefined;
  clientId_ENDS_WITH?: string | null | undefined;
  clientId_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientId_NOT_STARTS_WITH?: string | null | undefined;
  clientId_STARTS_WITH?: string | null | undefined;
  clientSecret?: string | null | undefined;
  clientSecret_CONTAINS?: string | null | undefined;
  clientSecret_ENDS_WITH?: string | null | undefined;
  clientSecret_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  clientSecret_NOT_STARTS_WITH?: string | null | undefined;
  clientSecret_STARTS_WITH?: string | null | undefined;
  customIdClaims?: Array<string> | null | undefined;
  customIdClaims_INCLUDES?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customIdClaims_NOT?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  customIdClaims_NOT_INCLUDES?: string | null | undefined;
  issuer?: string | null | undefined;
  issuer_CONTAINS?: string | null | undefined;
  issuer_ENDS_WITH?: string | null | undefined;
  issuer_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  issuer_NOT_STARTS_WITH?: string | null | undefined;
  issuer_STARTS_WITH?: string | null | undefined;
  label?: string | null | undefined;
  label_CONTAINS?: string | null | undefined;
  label_ENDS_WITH?: string | null | undefined;
  label_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  label_NOT_STARTS_WITH?: string | null | undefined;
  label_STARTS_WITH?: string | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  responseTypes?: Array<string> | null | undefined;
  responseTypes_INCLUDES?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  responseTypes_NOT?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  responseTypes_NOT_INCLUDES?: string | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
};

export type GroupConnectInput = {
  incomingRoles?: GroupIncomingRolesConnectInput | null | undefined;
  organization?: GroupOrganizationConnectFieldInput | null | undefined;
  profiles?: Array<GroupProfilesConnectFieldInput> | null | undefined;
  properties?: Array<GroupPropertiesConnectFieldInput> | null | undefined;
};

export type GroupConnectWhere = {
  node: GroupWhere;
};

export type GroupCreateInput = {
  incomingRoles?: GroupIncomingRolesCreateInput | null | undefined;
  name: string;
  organization?: GroupOrganizationFieldInput | null | undefined;
  profiles?: GroupProfilesFieldInput | null | undefined;
  properties?: GroupPropertiesFieldInput | null | undefined;
  publicVisible?: boolean | null | undefined;
};

export type GroupDeleteInput = {
  incomingRoles?: GroupIncomingRolesDeleteInput | null | undefined;
  organization?: GroupOrganizationDeleteFieldInput | null | undefined;
  profiles?: Array<GroupProfilesDeleteFieldInput> | null | undefined;
  properties?: Array<GroupPropertiesDeleteFieldInput> | null | undefined;
};

export type GroupDisconnectInput = {
  incomingRoles?: GroupIncomingRolesDisconnectInput | null | undefined;
  organization?: GroupOrganizationDisconnectFieldInput | null | undefined;
  profiles?: Array<GroupProfilesDisconnectFieldInput> | null | undefined;
  properties?: Array<GroupPropertiesDisconnectFieldInput> | null | undefined;
};

export type GroupIncomingRolesConnectInput = {
  Group?: Array<GroupIncomingRolesGroupConnectFieldInput> | null | undefined;
  Organization?: Array<GroupIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  Profile?: Array<GroupIncomingRolesProfileConnectFieldInput> | null | undefined;
  User?: Array<GroupIncomingRolesUserConnectFieldInput> | null | undefined;
};

export type GroupIncomingRolesConnectionWhere = {
  Group?: GroupIncomingRolesGroupConnectionWhere | null | undefined;
  Organization?: GroupIncomingRolesOrganizationConnectionWhere | null | undefined;
  Profile?: GroupIncomingRolesProfileConnectionWhere | null | undefined;
  User?: GroupIncomingRolesUserConnectionWhere | null | undefined;
};

export type GroupIncomingRolesCreateInput = {
  Group?: GroupIncomingRolesGroupFieldInput | null | undefined;
  Organization?: GroupIncomingRolesOrganizationFieldInput | null | undefined;
  Profile?: GroupIncomingRolesProfileFieldInput | null | undefined;
  User?: GroupIncomingRolesUserFieldInput | null | undefined;
};

export type GroupIncomingRolesDeleteInput = {
  Group?: Array<GroupIncomingRolesGroupDeleteFieldInput> | null | undefined;
  Organization?: Array<GroupIncomingRolesOrganizationDeleteFieldInput> | null | undefined;
  Profile?: Array<GroupIncomingRolesProfileDeleteFieldInput> | null | undefined;
  User?: Array<GroupIncomingRolesUserDeleteFieldInput> | null | undefined;
};

export type GroupIncomingRolesDisconnectInput = {
  Group?: Array<GroupIncomingRolesGroupDisconnectFieldInput> | null | undefined;
  Organization?: Array<GroupIncomingRolesOrganizationDisconnectFieldInput> | null | undefined;
  Profile?: Array<GroupIncomingRolesProfileDisconnectFieldInput> | null | undefined;
  User?: Array<GroupIncomingRolesUserDisconnectFieldInput> | null | undefined;
};

export type GroupIncomingRolesGroupConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: GroupConnectWhere | null | undefined;
};

export type GroupIncomingRolesGroupConnectionWhere = {
  AND?: Array<GroupIncomingRolesGroupConnectionWhere> | null | undefined;
  NOT?: GroupIncomingRolesGroupConnectionWhere | null | undefined;
  OR?: Array<GroupIncomingRolesGroupConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type GroupIncomingRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type GroupIncomingRolesGroupDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: GroupIncomingRolesGroupConnectionWhere | null | undefined;
};

export type GroupIncomingRolesGroupDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: GroupIncomingRolesGroupConnectionWhere | null | undefined;
};

export type GroupIncomingRolesGroupFieldInput = {
  connect?: Array<GroupIncomingRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesGroupCreateFieldInput> | null | undefined;
};

export type GroupIncomingRolesGroupUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: GroupUpdateInput | null | undefined;
};

export type GroupIncomingRolesGroupUpdateFieldInput = {
  connect?: Array<GroupIncomingRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesGroupCreateFieldInput> | null | undefined;
  delete?: Array<GroupIncomingRolesGroupDeleteFieldInput> | null | undefined;
  disconnect?: Array<GroupIncomingRolesGroupDisconnectFieldInput> | null | undefined;
  update?: GroupIncomingRolesGroupUpdateConnectionInput | null | undefined;
  where?: GroupIncomingRolesGroupConnectionWhere | null | undefined;
};

export type GroupIncomingRolesOrganizationConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: OrganizationConnectWhere | null | undefined;
};

export type GroupIncomingRolesOrganizationConnectionWhere = {
  AND?: Array<GroupIncomingRolesOrganizationConnectionWhere> | null | undefined;
  NOT?: GroupIncomingRolesOrganizationConnectionWhere | null | undefined;
  OR?: Array<GroupIncomingRolesOrganizationConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type GroupIncomingRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type GroupIncomingRolesOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: GroupIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type GroupIncomingRolesOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: GroupIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type GroupIncomingRolesOrganizationFieldInput = {
  connect?: Array<GroupIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesOrganizationCreateFieldInput> | null | undefined;
};

export type GroupIncomingRolesOrganizationUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type GroupIncomingRolesOrganizationUpdateFieldInput = {
  connect?: Array<GroupIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesOrganizationCreateFieldInput> | null | undefined;
  delete?: Array<GroupIncomingRolesOrganizationDeleteFieldInput> | null | undefined;
  disconnect?: Array<GroupIncomingRolesOrganizationDisconnectFieldInput> | null | undefined;
  update?: GroupIncomingRolesOrganizationUpdateConnectionInput | null | undefined;
  where?: GroupIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type GroupIncomingRolesProfileConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: ProfileConnectWhere | null | undefined;
};

export type GroupIncomingRolesProfileConnectionWhere = {
  AND?: Array<GroupIncomingRolesProfileConnectionWhere> | null | undefined;
  NOT?: GroupIncomingRolesProfileConnectionWhere | null | undefined;
  OR?: Array<GroupIncomingRolesProfileConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type GroupIncomingRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type GroupIncomingRolesProfileDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: GroupIncomingRolesProfileConnectionWhere | null | undefined;
};

export type GroupIncomingRolesProfileDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: GroupIncomingRolesProfileConnectionWhere | null | undefined;
};

export type GroupIncomingRolesProfileFieldInput = {
  connect?: Array<GroupIncomingRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesProfileCreateFieldInput> | null | undefined;
};

export type GroupIncomingRolesProfileUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: ProfileUpdateInput | null | undefined;
};

export type GroupIncomingRolesProfileUpdateFieldInput = {
  connect?: Array<GroupIncomingRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesProfileCreateFieldInput> | null | undefined;
  delete?: Array<GroupIncomingRolesProfileDeleteFieldInput> | null | undefined;
  disconnect?: Array<GroupIncomingRolesProfileDisconnectFieldInput> | null | undefined;
  update?: GroupIncomingRolesProfileUpdateConnectionInput | null | undefined;
  where?: GroupIncomingRolesProfileConnectionWhere | null | undefined;
};

export type GroupIncomingRolesUpdateInput = {
  Group?: Array<GroupIncomingRolesGroupUpdateFieldInput> | null | undefined;
  Organization?: Array<GroupIncomingRolesOrganizationUpdateFieldInput> | null | undefined;
  Profile?: Array<GroupIncomingRolesProfileUpdateFieldInput> | null | undefined;
  User?: Array<GroupIncomingRolesUserUpdateFieldInput> | null | undefined;
};

export type GroupIncomingRolesUserConnectFieldInput = {
  connect?: Array<UserConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: UserConnectWhere | null | undefined;
};

export type GroupIncomingRolesUserConnectionWhere = {
  AND?: Array<GroupIncomingRolesUserConnectionWhere> | null | undefined;
  NOT?: GroupIncomingRolesUserConnectionWhere | null | undefined;
  OR?: Array<GroupIncomingRolesUserConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type GroupIncomingRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type GroupIncomingRolesUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: GroupIncomingRolesUserConnectionWhere | null | undefined;
};

export type GroupIncomingRolesUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: GroupIncomingRolesUserConnectionWhere | null | undefined;
};

export type GroupIncomingRolesUserFieldInput = {
  connect?: Array<GroupIncomingRolesUserConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesUserCreateFieldInput> | null | undefined;
};

export type GroupIncomingRolesUserUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: UserUpdateInput | null | undefined;
};

export type GroupIncomingRolesUserUpdateFieldInput = {
  connect?: Array<GroupIncomingRolesUserConnectFieldInput> | null | undefined;
  create?: Array<GroupIncomingRolesUserCreateFieldInput> | null | undefined;
  delete?: Array<GroupIncomingRolesUserDeleteFieldInput> | null | undefined;
  disconnect?: Array<GroupIncomingRolesUserDisconnectFieldInput> | null | undefined;
  update?: GroupIncomingRolesUserUpdateConnectionInput | null | undefined;
  where?: GroupIncomingRolesUserConnectionWhere | null | undefined;
};

export type GroupOrganizationAggregateInput = {
  AND?: Array<GroupOrganizationAggregateInput> | null | undefined;
  NOT?: GroupOrganizationAggregateInput | null | undefined;
  OR?: Array<GroupOrganizationAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: GroupOrganizationNodeAggregationWhereInput | null | undefined;
};

export type GroupOrganizationConnectFieldInput = {
  connect?: OrganizationConnectInput | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: OrganizationConnectWhere | null | undefined;
};

export type GroupOrganizationConnectionWhere = {
  AND?: Array<GroupOrganizationConnectionWhere> | null | undefined;
  NOT?: GroupOrganizationConnectionWhere | null | undefined;
  OR?: Array<GroupOrganizationConnectionWhere> | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type GroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type GroupOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: GroupOrganizationConnectionWhere | null | undefined;
};

export type GroupOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: GroupOrganizationConnectionWhere | null | undefined;
};

export type GroupOrganizationFieldInput = {
  connect?: GroupOrganizationConnectFieldInput | null | undefined;
  create?: GroupOrganizationCreateFieldInput | null | undefined;
};

export type GroupOrganizationNodeAggregationWhereInput = {
  AND?: Array<GroupOrganizationNodeAggregationWhereInput> | null | undefined;
  NOT?: GroupOrganizationNodeAggregationWhereInput | null | undefined;
  OR?: Array<GroupOrganizationNodeAggregationWhereInput> | null | undefined;
  address1_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address1_AVERAGE_LENGTH_GT?: number | null | undefined;
  address1_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address1_AVERAGE_LENGTH_LT?: number | null | undefined;
  address1_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address1_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address1_LONGEST_LENGTH_GT?: number | null | undefined;
  address1_LONGEST_LENGTH_GTE?: number | null | undefined;
  address1_LONGEST_LENGTH_LT?: number | null | undefined;
  address1_LONGEST_LENGTH_LTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address1_SHORTEST_LENGTH_GT?: number | null | undefined;
  address1_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_LT?: number | null | undefined;
  address1_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address2_AVERAGE_LENGTH_GT?: number | null | undefined;
  address2_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_LT?: number | null | undefined;
  address2_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address2_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address2_LONGEST_LENGTH_GT?: number | null | undefined;
  address2_LONGEST_LENGTH_GTE?: number | null | undefined;
  address2_LONGEST_LENGTH_LT?: number | null | undefined;
  address2_LONGEST_LENGTH_LTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address2_SHORTEST_LENGTH_GT?: number | null | undefined;
  address2_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_LT?: number | null | undefined;
  address2_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address3_AVERAGE_LENGTH_GT?: number | null | undefined;
  address3_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_LT?: number | null | undefined;
  address3_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address3_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address3_LONGEST_LENGTH_GT?: number | null | undefined;
  address3_LONGEST_LENGTH_GTE?: number | null | undefined;
  address3_LONGEST_LENGTH_LT?: number | null | undefined;
  address3_LONGEST_LENGTH_LTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address3_SHORTEST_LENGTH_GT?: number | null | undefined;
  address3_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_LT?: number | null | undefined;
  address3_SHORTEST_LENGTH_LTE?: number | null | undefined;
  city_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  city_AVERAGE_LENGTH_GT?: number | null | undefined;
  city_AVERAGE_LENGTH_GTE?: number | null | undefined;
  city_AVERAGE_LENGTH_LT?: number | null | undefined;
  city_AVERAGE_LENGTH_LTE?: number | null | undefined;
  city_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  city_LONGEST_LENGTH_GT?: number | null | undefined;
  city_LONGEST_LENGTH_GTE?: number | null | undefined;
  city_LONGEST_LENGTH_LT?: number | null | undefined;
  city_LONGEST_LENGTH_LTE?: number | null | undefined;
  city_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  city_SHORTEST_LENGTH_GT?: number | null | undefined;
  city_SHORTEST_LENGTH_GTE?: number | null | undefined;
  city_SHORTEST_LENGTH_LT?: number | null | undefined;
  city_SHORTEST_LENGTH_LTE?: number | null | undefined;
  country_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  country_AVERAGE_LENGTH_GT?: number | null | undefined;
  country_AVERAGE_LENGTH_GTE?: number | null | undefined;
  country_AVERAGE_LENGTH_LT?: number | null | undefined;
  country_AVERAGE_LENGTH_LTE?: number | null | undefined;
  country_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  country_LONGEST_LENGTH_GT?: number | null | undefined;
  country_LONGEST_LENGTH_GTE?: number | null | undefined;
  country_LONGEST_LENGTH_LT?: number | null | undefined;
  country_LONGEST_LENGTH_LTE?: number | null | undefined;
  country_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  country_SHORTEST_LENGTH_GT?: number | null | undefined;
  country_SHORTEST_LENGTH_GTE?: number | null | undefined;
  country_SHORTEST_LENGTH_LT?: number | null | undefined;
  country_SHORTEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  region_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  region_AVERAGE_LENGTH_GT?: number | null | undefined;
  region_AVERAGE_LENGTH_GTE?: number | null | undefined;
  region_AVERAGE_LENGTH_LT?: number | null | undefined;
  region_AVERAGE_LENGTH_LTE?: number | null | undefined;
  region_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  region_LONGEST_LENGTH_GT?: number | null | undefined;
  region_LONGEST_LENGTH_GTE?: number | null | undefined;
  region_LONGEST_LENGTH_LT?: number | null | undefined;
  region_LONGEST_LENGTH_LTE?: number | null | undefined;
  region_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  region_SHORTEST_LENGTH_GT?: number | null | undefined;
  region_SHORTEST_LENGTH_GTE?: number | null | undefined;
  region_SHORTEST_LENGTH_LT?: number | null | undefined;
  region_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_LONGEST_LENGTH_GT?: number | null | undefined;
  timezone_LONGEST_LENGTH_GTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_LT?: number | null | undefined;
  timezone_LONGEST_LENGTH_LTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type GroupOrganizationUpdateConnectionInput = {
  node?: OrganizationUpdateInput | null | undefined;
};

export type GroupOrganizationUpdateFieldInput = {
  connect?: GroupOrganizationConnectFieldInput | null | undefined;
  create?: GroupOrganizationCreateFieldInput | null | undefined;
  delete?: GroupOrganizationDeleteFieldInput | null | undefined;
  disconnect?: GroupOrganizationDisconnectFieldInput | null | undefined;
  update?: GroupOrganizationUpdateConnectionInput | null | undefined;
  where?: GroupOrganizationConnectionWhere | null | undefined;
};

export type GroupProfilesAggregateInput = {
  AND?: Array<GroupProfilesAggregateInput> | null | undefined;
  NOT?: GroupProfilesAggregateInput | null | undefined;
  OR?: Array<GroupProfilesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: GroupProfilesNodeAggregationWhereInput | null | undefined;
};

export type GroupProfilesConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: ProfileConnectWhere | null | undefined;
};

export type GroupProfilesConnectionWhere = {
  AND?: Array<GroupProfilesConnectionWhere> | null | undefined;
  NOT?: GroupProfilesConnectionWhere | null | undefined;
  OR?: Array<GroupProfilesConnectionWhere> | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type GroupProfilesCreateFieldInput = {
  node: ProfileCreateInput;
};

export type GroupProfilesDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: GroupProfilesConnectionWhere | null | undefined;
};

export type GroupProfilesDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: GroupProfilesConnectionWhere | null | undefined;
};

export type GroupProfilesFieldInput = {
  connect?: Array<GroupProfilesConnectFieldInput> | null | undefined;
  create?: Array<GroupProfilesCreateFieldInput> | null | undefined;
};

export type GroupProfilesNodeAggregationWhereInput = {
  AND?: Array<GroupProfilesNodeAggregationWhereInput> | null | undefined;
  NOT?: GroupProfilesNodeAggregationWhereInput | null | undefined;
  OR?: Array<GroupProfilesNodeAggregationWhereInput> | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_LONGEST_LENGTH_GT?: number | null | undefined;
  firstName_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_LT?: number | null | undefined;
  firstName_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_LONGEST_LENGTH_GT?: number | null | undefined;
  lastName_LONGEST_LENGTH_GTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_LT?: number | null | undefined;
  lastName_LONGEST_LENGTH_LTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_LONGEST_LENGTH_GT?: number | null | undefined;
  salutation_LONGEST_LENGTH_GTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_LT?: number | null | undefined;
  salutation_LONGEST_LENGTH_LTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_LONGEST_LENGTH_GT?: number | null | undefined;
  shortName_LONGEST_LENGTH_GTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_LT?: number | null | undefined;
  shortName_LONGEST_LENGTH_LTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  title_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  title_AVERAGE_LENGTH_GT?: number | null | undefined;
  title_AVERAGE_LENGTH_GTE?: number | null | undefined;
  title_AVERAGE_LENGTH_LT?: number | null | undefined;
  title_AVERAGE_LENGTH_LTE?: number | null | undefined;
  title_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  title_LONGEST_LENGTH_GT?: number | null | undefined;
  title_LONGEST_LENGTH_GTE?: number | null | undefined;
  title_LONGEST_LENGTH_LT?: number | null | undefined;
  title_LONGEST_LENGTH_LTE?: number | null | undefined;
  title_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  title_SHORTEST_LENGTH_GT?: number | null | undefined;
  title_SHORTEST_LENGTH_GTE?: number | null | undefined;
  title_SHORTEST_LENGTH_LT?: number | null | undefined;
  title_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosAccepted_MAX_EQUAL?: string | null | undefined;
  tosAccepted_MAX_GT?: string | null | undefined;
  tosAccepted_MAX_GTE?: string | null | undefined;
  tosAccepted_MAX_LT?: string | null | undefined;
  tosAccepted_MAX_LTE?: string | null | undefined;
  tosAccepted_MIN_EQUAL?: string | null | undefined;
  tosAccepted_MIN_GT?: string | null | undefined;
  tosAccepted_MIN_GTE?: string | null | undefined;
  tosAccepted_MIN_LT?: string | null | undefined;
  tosAccepted_MIN_LTE?: string | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type GroupProfilesUpdateConnectionInput = {
  node?: ProfileUpdateInput | null | undefined;
};

export type GroupProfilesUpdateFieldInput = {
  connect?: Array<GroupProfilesConnectFieldInput> | null | undefined;
  create?: Array<GroupProfilesCreateFieldInput> | null | undefined;
  delete?: Array<GroupProfilesDeleteFieldInput> | null | undefined;
  disconnect?: Array<GroupProfilesDisconnectFieldInput> | null | undefined;
  update?: GroupProfilesUpdateConnectionInput | null | undefined;
  where?: GroupProfilesConnectionWhere | null | undefined;
};

export type GroupPropertiesAggregateInput = {
  AND?: Array<GroupPropertiesAggregateInput> | null | undefined;
  NOT?: GroupPropertiesAggregateInput | null | undefined;
  OR?: Array<GroupPropertiesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: PropertiesScopeAggregationWhereInput | null | undefined;
  node?: GroupPropertiesNodeAggregationWhereInput | null | undefined;
};

export type GroupPropertiesConnectFieldInput = {
  connect?: Array<PropertyConnectInput> | null | undefined;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: PropertyConnectWhere | null | undefined;
};

export type GroupPropertiesConnectionWhere = {
  AND?: Array<GroupPropertiesConnectionWhere> | null | undefined;
  NOT?: GroupPropertiesConnectionWhere | null | undefined;
  OR?: Array<GroupPropertiesConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: PropertyWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: PropertyWhere | null | undefined;
};

export type GroupPropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type GroupPropertiesDeleteFieldInput = {
  delete?: PropertyDeleteInput | null | undefined;
  where?: GroupPropertiesConnectionWhere | null | undefined;
};

export type GroupPropertiesDisconnectFieldInput = {
  disconnect?: PropertyDisconnectInput | null | undefined;
  where?: GroupPropertiesConnectionWhere | null | undefined;
};

export type GroupPropertiesFieldInput = {
  connect?: Array<GroupPropertiesConnectFieldInput> | null | undefined;
  create?: Array<GroupPropertiesCreateFieldInput> | null | undefined;
};

export type GroupPropertiesNodeAggregationWhereInput = {
  AND?: Array<GroupPropertiesNodeAggregationWhereInput> | null | undefined;
  NOT?: GroupPropertiesNodeAggregationWhereInput | null | undefined;
  OR?: Array<GroupPropertiesNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  value_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  value_AVERAGE_LENGTH_GT?: number | null | undefined;
  value_AVERAGE_LENGTH_GTE?: number | null | undefined;
  value_AVERAGE_LENGTH_LT?: number | null | undefined;
  value_AVERAGE_LENGTH_LTE?: number | null | undefined;
  value_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  value_LONGEST_LENGTH_GT?: number | null | undefined;
  value_LONGEST_LENGTH_GTE?: number | null | undefined;
  value_LONGEST_LENGTH_LT?: number | null | undefined;
  value_LONGEST_LENGTH_LTE?: number | null | undefined;
  value_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  value_SHORTEST_LENGTH_GT?: number | null | undefined;
  value_SHORTEST_LENGTH_GTE?: number | null | undefined;
  value_SHORTEST_LENGTH_LT?: number | null | undefined;
  value_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type GroupPropertiesUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: PropertyUpdateInput | null | undefined;
};

export type GroupPropertiesUpdateFieldInput = {
  connect?: Array<GroupPropertiesConnectFieldInput> | null | undefined;
  create?: Array<GroupPropertiesCreateFieldInput> | null | undefined;
  delete?: Array<GroupPropertiesDeleteFieldInput> | null | undefined;
  disconnect?: Array<GroupPropertiesDisconnectFieldInput> | null | undefined;
  update?: GroupPropertiesUpdateConnectionInput | null | undefined;
  where?: GroupPropertiesConnectionWhere | null | undefined;
};

export type GroupUpdateInput = {
  incomingRoles?: GroupIncomingRolesUpdateInput | null | undefined;
  name?: string | null | undefined;
  organization?: GroupOrganizationUpdateFieldInput | null | undefined;
  profiles?: Array<GroupProfilesUpdateFieldInput> | null | undefined;
  properties?: Array<GroupPropertiesUpdateFieldInput> | null | undefined;
  publicVisible?: boolean | null | undefined;
};

export type GroupWhere = {
  AND?: Array<GroupWhere> | null | undefined;
  NOT?: GroupWhere | null | undefined;
  OR?: Array<GroupWhere> | null | undefined;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: GroupIncomingRolesConnectionWhere | null | undefined;
  /** Return Groups where all of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: GroupIncomingRolesConnectionWhere | null | undefined;
  /** Return Groups where none of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: GroupIncomingRolesConnectionWhere | null | undefined;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: GroupIncomingRolesConnectionWhere | null | undefined;
  /** Return Groups where one of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: GroupIncomingRolesConnectionWhere | null | undefined;
  /** Return Groups where some of the related GroupIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: GroupIncomingRolesConnectionWhere | null | undefined;
  /** Return Groups where all of the related RoleTargets match this filter */
  incomingRoles_ALL?: RoleTargetWhere | null | undefined;
  /** Return Groups where none of the related RoleTargets match this filter */
  incomingRoles_NONE?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: RoleTargetWhere | null | undefined;
  /** Return Groups where one of the related RoleTargets match this filter */
  incomingRoles_SINGLE?: RoleTargetWhere | null | undefined;
  /** Return Groups where some of the related RoleTargets match this filter */
  incomingRoles_SOME?: RoleTargetWhere | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  organization?: OrganizationWhere | null | undefined;
  organizationAggregate?: GroupOrganizationAggregateInput | null | undefined;
  organizationConnection?: GroupOrganizationConnectionWhere | null | undefined;
  organizationConnection_NOT?: GroupOrganizationConnectionWhere | null | undefined;
  organization_NOT?: OrganizationWhere | null | undefined;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: ProfileWhere | null | undefined;
  profilesAggregate?: GroupProfilesAggregateInput | null | undefined;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: GroupProfilesConnectionWhere | null | undefined;
  /** Return Groups where all of the related GroupProfilesConnections match this filter */
  profilesConnection_ALL?: GroupProfilesConnectionWhere | null | undefined;
  /** Return Groups where none of the related GroupProfilesConnections match this filter */
  profilesConnection_NONE?: GroupProfilesConnectionWhere | null | undefined;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: GroupProfilesConnectionWhere | null | undefined;
  /** Return Groups where one of the related GroupProfilesConnections match this filter */
  profilesConnection_SINGLE?: GroupProfilesConnectionWhere | null | undefined;
  /** Return Groups where some of the related GroupProfilesConnections match this filter */
  profilesConnection_SOME?: GroupProfilesConnectionWhere | null | undefined;
  /** Return Groups where all of the related Profiles match this filter */
  profiles_ALL?: ProfileWhere | null | undefined;
  /** Return Groups where none of the related Profiles match this filter */
  profiles_NONE?: ProfileWhere | null | undefined;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: ProfileWhere | null | undefined;
  /** Return Groups where one of the related Profiles match this filter */
  profiles_SINGLE?: ProfileWhere | null | undefined;
  /** Return Groups where some of the related Profiles match this filter */
  profiles_SOME?: ProfileWhere | null | undefined;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: PropertyWhere | null | undefined;
  propertiesAggregate?: GroupPropertiesAggregateInput | null | undefined;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: GroupPropertiesConnectionWhere | null | undefined;
  /** Return Groups where all of the related GroupPropertiesConnections match this filter */
  propertiesConnection_ALL?: GroupPropertiesConnectionWhere | null | undefined;
  /** Return Groups where none of the related GroupPropertiesConnections match this filter */
  propertiesConnection_NONE?: GroupPropertiesConnectionWhere | null | undefined;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: GroupPropertiesConnectionWhere | null | undefined;
  /** Return Groups where one of the related GroupPropertiesConnections match this filter */
  propertiesConnection_SINGLE?: GroupPropertiesConnectionWhere | null | undefined;
  /** Return Groups where some of the related GroupPropertiesConnections match this filter */
  propertiesConnection_SOME?: GroupPropertiesConnectionWhere | null | undefined;
  /** Return Groups where all of the related Properties match this filter */
  properties_ALL?: PropertyWhere | null | undefined;
  /** Return Groups where none of the related Properties match this filter */
  properties_NONE?: PropertyWhere | null | undefined;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: PropertyWhere | null | undefined;
  /** Return Groups where one of the related Properties match this filter */
  properties_SINGLE?: PropertyWhere | null | undefined;
  /** Return Groups where some of the related Properties match this filter */
  properties_SOME?: PropertyWhere | null | undefined;
  publicVisible?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicVisible_NOT?: boolean | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
};

export type LicensePropertiesAggregationWhereInput = {
  AND?: Array<LicensePropertiesAggregationWhereInput> | null | undefined;
  NOT?: LicensePropertiesAggregationWhereInput | null | undefined;
  OR?: Array<LicensePropertiesAggregationWhereInput> | null | undefined;
  notAfter_MAX_EQUAL?: string | null | undefined;
  notAfter_MAX_GT?: string | null | undefined;
  notAfter_MAX_GTE?: string | null | undefined;
  notAfter_MAX_LT?: string | null | undefined;
  notAfter_MAX_LTE?: string | null | undefined;
  notAfter_MIN_EQUAL?: string | null | undefined;
  notAfter_MIN_GT?: string | null | undefined;
  notAfter_MIN_GTE?: string | null | undefined;
  notAfter_MIN_LT?: string | null | undefined;
  notAfter_MIN_LTE?: string | null | undefined;
  notBefore_MAX_EQUAL?: string | null | undefined;
  notBefore_MAX_GT?: string | null | undefined;
  notBefore_MAX_GTE?: string | null | undefined;
  notBefore_MAX_LT?: string | null | undefined;
  notBefore_MAX_LTE?: string | null | undefined;
  notBefore_MIN_EQUAL?: string | null | undefined;
  notBefore_MIN_GT?: string | null | undefined;
  notBefore_MIN_GTE?: string | null | undefined;
  notBefore_MIN_LT?: string | null | undefined;
  notBefore_MIN_LTE?: string | null | undefined;
  tecartContractId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContractId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContractId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContractId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContractId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContractId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContractId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContractId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContractId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContractId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContractId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContractId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContractId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContractId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContractId_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type LicensePropertiesCreateInput = {
  licensedModules?: Array<string> | null | undefined;
  notAfter?: string | null | undefined;
  notBefore?: string | null | undefined;
  tecartContractId?: string | null | undefined;
};

export type LicensePropertiesUpdateInput = {
  licensedModules?: Array<string> | null | undefined;
  licensedModules_POP?: number | null | undefined;
  licensedModules_PUSH?: Array<string> | null | undefined;
  notAfter?: string | null | undefined;
  notBefore?: string | null | undefined;
  tecartContractId?: string | null | undefined;
};

export type LicensePropertiesWhere = {
  AND?: Array<LicensePropertiesWhere> | null | undefined;
  NOT?: LicensePropertiesWhere | null | undefined;
  OR?: Array<LicensePropertiesWhere> | null | undefined;
  licensedModules?: Array<string> | null | undefined;
  licensedModules_INCLUDES?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT_INCLUDES?: string | null | undefined;
  notAfter?: string | null | undefined;
  notAfter_GT?: string | null | undefined;
  notAfter_GTE?: string | null | undefined;
  notAfter_IN?: Array<string | null | undefined> | null | undefined;
  notAfter_LT?: string | null | undefined;
  notAfter_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notAfter_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notAfter_NOT_IN?: Array<string | null | undefined> | null | undefined;
  notBefore?: string | null | undefined;
  notBefore_GT?: string | null | undefined;
  notBefore_GTE?: string | null | undefined;
  notBefore_IN?: Array<string | null | undefined> | null | undefined;
  notBefore_LT?: string | null | undefined;
  notBefore_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notBefore_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notBefore_NOT_IN?: Array<string | null | undefined> | null | undefined;
  tecartContractId?: string | null | undefined;
  tecartContractId_CONTAINS?: string | null | undefined;
  tecartContractId_ENDS_WITH?: string | null | undefined;
  tecartContractId_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContractId_NOT_STARTS_WITH?: string | null | undefined;
  tecartContractId_STARTS_WITH?: string | null | undefined;
};

export type OrganizationCollaboratesWithAggregateInput = {
  AND?: Array<OrganizationCollaboratesWithAggregateInput> | null | undefined;
  NOT?: OrganizationCollaboratesWithAggregateInput | null | undefined;
  OR?: Array<OrganizationCollaboratesWithAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: CollaborationPropertiesAggregationWhereInput | null | undefined;
  node?: OrganizationCollaboratesWithNodeAggregationWhereInput | null | undefined;
};

export type OrganizationCollaboratesWithConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge: CollaborationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: OrganizationConnectWhere | null | undefined;
};

export type OrganizationCollaboratesWithConnectionWhere = {
  AND?: Array<OrganizationCollaboratesWithConnectionWhere> | null | undefined;
  NOT?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
  OR?: Array<OrganizationCollaboratesWithConnectionWhere> | null | undefined;
  edge?: CollaborationPropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: CollaborationPropertiesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type OrganizationCollaboratesWithCreateFieldInput = {
  edge: CollaborationPropertiesCreateInput;
  node: OrganizationCreateInput;
};

export type OrganizationCollaboratesWithDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
};

export type OrganizationCollaboratesWithDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
};

export type OrganizationCollaboratesWithFieldInput = {
  connect?: Array<OrganizationCollaboratesWithConnectFieldInput> | null | undefined;
  create?: Array<OrganizationCollaboratesWithCreateFieldInput> | null | undefined;
};

export type OrganizationCollaboratesWithNodeAggregationWhereInput = {
  AND?: Array<OrganizationCollaboratesWithNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationCollaboratesWithNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationCollaboratesWithNodeAggregationWhereInput> | null | undefined;
  address1_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address1_AVERAGE_LENGTH_GT?: number | null | undefined;
  address1_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address1_AVERAGE_LENGTH_LT?: number | null | undefined;
  address1_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address1_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address1_LONGEST_LENGTH_GT?: number | null | undefined;
  address1_LONGEST_LENGTH_GTE?: number | null | undefined;
  address1_LONGEST_LENGTH_LT?: number | null | undefined;
  address1_LONGEST_LENGTH_LTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address1_SHORTEST_LENGTH_GT?: number | null | undefined;
  address1_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_LT?: number | null | undefined;
  address1_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address2_AVERAGE_LENGTH_GT?: number | null | undefined;
  address2_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_LT?: number | null | undefined;
  address2_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address2_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address2_LONGEST_LENGTH_GT?: number | null | undefined;
  address2_LONGEST_LENGTH_GTE?: number | null | undefined;
  address2_LONGEST_LENGTH_LT?: number | null | undefined;
  address2_LONGEST_LENGTH_LTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address2_SHORTEST_LENGTH_GT?: number | null | undefined;
  address2_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_LT?: number | null | undefined;
  address2_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address3_AVERAGE_LENGTH_GT?: number | null | undefined;
  address3_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_LT?: number | null | undefined;
  address3_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address3_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address3_LONGEST_LENGTH_GT?: number | null | undefined;
  address3_LONGEST_LENGTH_GTE?: number | null | undefined;
  address3_LONGEST_LENGTH_LT?: number | null | undefined;
  address3_LONGEST_LENGTH_LTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address3_SHORTEST_LENGTH_GT?: number | null | undefined;
  address3_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_LT?: number | null | undefined;
  address3_SHORTEST_LENGTH_LTE?: number | null | undefined;
  city_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  city_AVERAGE_LENGTH_GT?: number | null | undefined;
  city_AVERAGE_LENGTH_GTE?: number | null | undefined;
  city_AVERAGE_LENGTH_LT?: number | null | undefined;
  city_AVERAGE_LENGTH_LTE?: number | null | undefined;
  city_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  city_LONGEST_LENGTH_GT?: number | null | undefined;
  city_LONGEST_LENGTH_GTE?: number | null | undefined;
  city_LONGEST_LENGTH_LT?: number | null | undefined;
  city_LONGEST_LENGTH_LTE?: number | null | undefined;
  city_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  city_SHORTEST_LENGTH_GT?: number | null | undefined;
  city_SHORTEST_LENGTH_GTE?: number | null | undefined;
  city_SHORTEST_LENGTH_LT?: number | null | undefined;
  city_SHORTEST_LENGTH_LTE?: number | null | undefined;
  country_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  country_AVERAGE_LENGTH_GT?: number | null | undefined;
  country_AVERAGE_LENGTH_GTE?: number | null | undefined;
  country_AVERAGE_LENGTH_LT?: number | null | undefined;
  country_AVERAGE_LENGTH_LTE?: number | null | undefined;
  country_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  country_LONGEST_LENGTH_GT?: number | null | undefined;
  country_LONGEST_LENGTH_GTE?: number | null | undefined;
  country_LONGEST_LENGTH_LT?: number | null | undefined;
  country_LONGEST_LENGTH_LTE?: number | null | undefined;
  country_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  country_SHORTEST_LENGTH_GT?: number | null | undefined;
  country_SHORTEST_LENGTH_GTE?: number | null | undefined;
  country_SHORTEST_LENGTH_LT?: number | null | undefined;
  country_SHORTEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  region_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  region_AVERAGE_LENGTH_GT?: number | null | undefined;
  region_AVERAGE_LENGTH_GTE?: number | null | undefined;
  region_AVERAGE_LENGTH_LT?: number | null | undefined;
  region_AVERAGE_LENGTH_LTE?: number | null | undefined;
  region_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  region_LONGEST_LENGTH_GT?: number | null | undefined;
  region_LONGEST_LENGTH_GTE?: number | null | undefined;
  region_LONGEST_LENGTH_LT?: number | null | undefined;
  region_LONGEST_LENGTH_LTE?: number | null | undefined;
  region_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  region_SHORTEST_LENGTH_GT?: number | null | undefined;
  region_SHORTEST_LENGTH_GTE?: number | null | undefined;
  region_SHORTEST_LENGTH_LT?: number | null | undefined;
  region_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_LONGEST_LENGTH_GT?: number | null | undefined;
  timezone_LONGEST_LENGTH_GTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_LT?: number | null | undefined;
  timezone_LONGEST_LENGTH_LTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationCollaboratesWithUpdateConnectionInput = {
  edge?: CollaborationPropertiesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type OrganizationCollaboratesWithUpdateFieldInput = {
  connect?: Array<OrganizationCollaboratesWithConnectFieldInput> | null | undefined;
  create?: Array<OrganizationCollaboratesWithCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationCollaboratesWithDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationCollaboratesWithDisconnectFieldInput> | null | undefined;
  update?: OrganizationCollaboratesWithUpdateConnectionInput | null | undefined;
  where?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
};

export type OrganizationConnectInput = {
  collaboratesWith?: Array<OrganizationCollaboratesWithConnectFieldInput> | null | undefined;
  federatedClient?: Array<OrganizationFederatedClientConnectFieldInput> | null | undefined;
  groups?: Array<OrganizationGroupsConnectFieldInput> | null | undefined;
  incomingRoles?: OrganizationIncomingRolesConnectInput | null | undefined;
  profiles?: Array<OrganizationProfilesConnectFieldInput> | null | undefined;
  properties?: Array<OrganizationPropertiesConnectFieldInput> | null | undefined;
  shadowProfileGroups?: Array<OrganizationShadowProfileGroupsConnectFieldInput> | null | undefined;
  shadowsProfilesTo?: Array<OrganizationShadowsProfilesToConnectFieldInput> | null | undefined;
};

export type OrganizationConnectWhere = {
  node: OrganizationWhere;
};

export type OrganizationCreateInput = {
  address1?: string | null | undefined;
  address2?: string | null | undefined;
  address3?: string | null | undefined;
  city?: string | null | undefined;
  collaboratesWith?: OrganizationCollaboratesWithFieldInput | null | undefined;
  country?: string | null | undefined;
  federatedClient?: OrganizationFederatedClientFieldInput | null | undefined;
  groups?: OrganizationGroupsFieldInput | null | undefined;
  imprintHtml?: string | null | undefined;
  incomingRoles?: OrganizationIncomingRolesCreateInput | null | undefined;
  locale: string;
  name: string;
  privacyHtml?: string | null | undefined;
  profiles?: OrganizationProfilesFieldInput | null | undefined;
  properties?: OrganizationPropertiesFieldInput | null | undefined;
  region?: string | null | undefined;
  shadowProfileGroups?: OrganizationShadowProfileGroupsFieldInput | null | undefined;
  shadowsProfilesTo?: OrganizationShadowsProfilesToFieldInput | null | undefined;
  tecartContactId?: string | null | undefined;
  timezone: string;
  tosHtml?: string | null | undefined;
  tosVersion?: string | null | undefined;
  zipCode?: string | null | undefined;
};

export type OrganizationDeleteInput = {
  collaboratesWith?: Array<OrganizationCollaboratesWithDeleteFieldInput> | null | undefined;
  federatedClient?: Array<OrganizationFederatedClientDeleteFieldInput> | null | undefined;
  groups?: Array<OrganizationGroupsDeleteFieldInput> | null | undefined;
  incomingRoles?: OrganizationIncomingRolesDeleteInput | null | undefined;
  profiles?: Array<OrganizationProfilesDeleteFieldInput> | null | undefined;
  properties?: Array<OrganizationPropertiesDeleteFieldInput> | null | undefined;
  shadowProfileGroups?: Array<OrganizationShadowProfileGroupsDeleteFieldInput> | null | undefined;
  shadowsProfilesTo?: Array<OrganizationShadowsProfilesToDeleteFieldInput> | null | undefined;
};

export type OrganizationDisconnectInput = {
  collaboratesWith?: Array<OrganizationCollaboratesWithDisconnectFieldInput> | null | undefined;
  federatedClient?: Array<OrganizationFederatedClientDisconnectFieldInput> | null | undefined;
  groups?: Array<OrganizationGroupsDisconnectFieldInput> | null | undefined;
  incomingRoles?: OrganizationIncomingRolesDisconnectInput | null | undefined;
  profiles?: Array<OrganizationProfilesDisconnectFieldInput> | null | undefined;
  properties?: Array<OrganizationPropertiesDisconnectFieldInput> | null | undefined;
  shadowProfileGroups?:
    | Array<OrganizationShadowProfileGroupsDisconnectFieldInput>
    | null
    | undefined;
  shadowsProfilesTo?: Array<OrganizationShadowsProfilesToDisconnectFieldInput> | null | undefined;
};

export type OrganizationFederatedClientAggregateInput = {
  AND?: Array<OrganizationFederatedClientAggregateInput> | null | undefined;
  NOT?: OrganizationFederatedClientAggregateInput | null | undefined;
  OR?: Array<OrganizationFederatedClientAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: OrganizationFederatedClientNodeAggregationWhereInput | null | undefined;
};

export type OrganizationFederatedClientConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: FederatedClientConnectWhere | null | undefined;
};

export type OrganizationFederatedClientConnectionWhere = {
  AND?: Array<OrganizationFederatedClientConnectionWhere> | null | undefined;
  NOT?: OrganizationFederatedClientConnectionWhere | null | undefined;
  OR?: Array<OrganizationFederatedClientConnectionWhere> | null | undefined;
  node?: FederatedClientWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: FederatedClientWhere | null | undefined;
};

export type OrganizationFederatedClientCreateFieldInput = {
  node: FederatedClientCreateInput;
};

export type OrganizationFederatedClientDeleteFieldInput = {
  where?: OrganizationFederatedClientConnectionWhere | null | undefined;
};

export type OrganizationFederatedClientDisconnectFieldInput = {
  where?: OrganizationFederatedClientConnectionWhere | null | undefined;
};

export type OrganizationFederatedClientFieldInput = {
  connect?: Array<OrganizationFederatedClientConnectFieldInput> | null | undefined;
  create?: Array<OrganizationFederatedClientCreateFieldInput> | null | undefined;
};

export type OrganizationFederatedClientNodeAggregationWhereInput = {
  AND?: Array<OrganizationFederatedClientNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationFederatedClientNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationFederatedClientNodeAggregationWhereInput> | null | undefined;
  clientId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  clientId_AVERAGE_LENGTH_GT?: number | null | undefined;
  clientId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  clientId_AVERAGE_LENGTH_LT?: number | null | undefined;
  clientId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  clientId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  clientId_LONGEST_LENGTH_GT?: number | null | undefined;
  clientId_LONGEST_LENGTH_GTE?: number | null | undefined;
  clientId_LONGEST_LENGTH_LT?: number | null | undefined;
  clientId_LONGEST_LENGTH_LTE?: number | null | undefined;
  clientId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  clientId_SHORTEST_LENGTH_GT?: number | null | undefined;
  clientId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  clientId_SHORTEST_LENGTH_LT?: number | null | undefined;
  clientId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_GT?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_GTE?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_LT?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_LTE?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_GT?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_GTE?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_LT?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_LTE?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_GT?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_GTE?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_LT?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_LTE?: number | null | undefined;
  issuer_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  issuer_AVERAGE_LENGTH_GT?: number | null | undefined;
  issuer_AVERAGE_LENGTH_GTE?: number | null | undefined;
  issuer_AVERAGE_LENGTH_LT?: number | null | undefined;
  issuer_AVERAGE_LENGTH_LTE?: number | null | undefined;
  issuer_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  issuer_LONGEST_LENGTH_GT?: number | null | undefined;
  issuer_LONGEST_LENGTH_GTE?: number | null | undefined;
  issuer_LONGEST_LENGTH_LT?: number | null | undefined;
  issuer_LONGEST_LENGTH_LTE?: number | null | undefined;
  issuer_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  issuer_SHORTEST_LENGTH_GT?: number | null | undefined;
  issuer_SHORTEST_LENGTH_GTE?: number | null | undefined;
  issuer_SHORTEST_LENGTH_LT?: number | null | undefined;
  issuer_SHORTEST_LENGTH_LTE?: number | null | undefined;
  label_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  label_AVERAGE_LENGTH_GT?: number | null | undefined;
  label_AVERAGE_LENGTH_GTE?: number | null | undefined;
  label_AVERAGE_LENGTH_LT?: number | null | undefined;
  label_AVERAGE_LENGTH_LTE?: number | null | undefined;
  label_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  label_LONGEST_LENGTH_GT?: number | null | undefined;
  label_LONGEST_LENGTH_GTE?: number | null | undefined;
  label_LONGEST_LENGTH_LT?: number | null | undefined;
  label_LONGEST_LENGTH_LTE?: number | null | undefined;
  label_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  label_SHORTEST_LENGTH_GT?: number | null | undefined;
  label_SHORTEST_LENGTH_GTE?: number | null | undefined;
  label_SHORTEST_LENGTH_LT?: number | null | undefined;
  label_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationFederatedClientUpdateConnectionInput = {
  node?: FederatedClientUpdateInput | null | undefined;
};

export type OrganizationFederatedClientUpdateFieldInput = {
  connect?: Array<OrganizationFederatedClientConnectFieldInput> | null | undefined;
  create?: Array<OrganizationFederatedClientCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationFederatedClientDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationFederatedClientDisconnectFieldInput> | null | undefined;
  update?: OrganizationFederatedClientUpdateConnectionInput | null | undefined;
  where?: OrganizationFederatedClientConnectionWhere | null | undefined;
};

export type OrganizationGroupsAggregateInput = {
  AND?: Array<OrganizationGroupsAggregateInput> | null | undefined;
  NOT?: OrganizationGroupsAggregateInput | null | undefined;
  OR?: Array<OrganizationGroupsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: OrganizationGroupsNodeAggregationWhereInput | null | undefined;
};

export type OrganizationGroupsConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: GroupConnectWhere | null | undefined;
};

export type OrganizationGroupsConnectionWhere = {
  AND?: Array<OrganizationGroupsConnectionWhere> | null | undefined;
  NOT?: OrganizationGroupsConnectionWhere | null | undefined;
  OR?: Array<OrganizationGroupsConnectionWhere> | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type OrganizationGroupsCreateFieldInput = {
  node: GroupCreateInput;
};

export type OrganizationGroupsDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: OrganizationGroupsConnectionWhere | null | undefined;
};

export type OrganizationGroupsDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: OrganizationGroupsConnectionWhere | null | undefined;
};

export type OrganizationGroupsFieldInput = {
  connect?: Array<OrganizationGroupsConnectFieldInput> | null | undefined;
  create?: Array<OrganizationGroupsCreateFieldInput> | null | undefined;
};

export type OrganizationGroupsNodeAggregationWhereInput = {
  AND?: Array<OrganizationGroupsNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationGroupsNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationGroupsNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationGroupsUpdateConnectionInput = {
  node?: GroupUpdateInput | null | undefined;
};

export type OrganizationGroupsUpdateFieldInput = {
  connect?: Array<OrganizationGroupsConnectFieldInput> | null | undefined;
  create?: Array<OrganizationGroupsCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationGroupsDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationGroupsDisconnectFieldInput> | null | undefined;
  update?: OrganizationGroupsUpdateConnectionInput | null | undefined;
  where?: OrganizationGroupsConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesConnectInput = {
  Group?: Array<OrganizationIncomingRolesGroupConnectFieldInput> | null | undefined;
  Organization?: Array<OrganizationIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  Profile?: Array<OrganizationIncomingRolesProfileConnectFieldInput> | null | undefined;
  User?: Array<OrganizationIncomingRolesUserConnectFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesConnectionWhere = {
  Group?: OrganizationIncomingRolesGroupConnectionWhere | null | undefined;
  Organization?: OrganizationIncomingRolesOrganizationConnectionWhere | null | undefined;
  Profile?: OrganizationIncomingRolesProfileConnectionWhere | null | undefined;
  User?: OrganizationIncomingRolesUserConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesCreateInput = {
  Group?: OrganizationIncomingRolesGroupFieldInput | null | undefined;
  Organization?: OrganizationIncomingRolesOrganizationFieldInput | null | undefined;
  Profile?: OrganizationIncomingRolesProfileFieldInput | null | undefined;
  User?: OrganizationIncomingRolesUserFieldInput | null | undefined;
};

export type OrganizationIncomingRolesDeleteInput = {
  Group?: Array<OrganizationIncomingRolesGroupDeleteFieldInput> | null | undefined;
  Organization?: Array<OrganizationIncomingRolesOrganizationDeleteFieldInput> | null | undefined;
  Profile?: Array<OrganizationIncomingRolesProfileDeleteFieldInput> | null | undefined;
  User?: Array<OrganizationIncomingRolesUserDeleteFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesDisconnectInput = {
  Group?: Array<OrganizationIncomingRolesGroupDisconnectFieldInput> | null | undefined;
  Organization?:
    | Array<OrganizationIncomingRolesOrganizationDisconnectFieldInput>
    | null
    | undefined;
  Profile?: Array<OrganizationIncomingRolesProfileDisconnectFieldInput> | null | undefined;
  User?: Array<OrganizationIncomingRolesUserDisconnectFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesGroupConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: GroupConnectWhere | null | undefined;
};

export type OrganizationIncomingRolesGroupConnectionWhere = {
  AND?: Array<OrganizationIncomingRolesGroupConnectionWhere> | null | undefined;
  NOT?: OrganizationIncomingRolesGroupConnectionWhere | null | undefined;
  OR?: Array<OrganizationIncomingRolesGroupConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type OrganizationIncomingRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type OrganizationIncomingRolesGroupDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: OrganizationIncomingRolesGroupConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesGroupDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: OrganizationIncomingRolesGroupConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesGroupFieldInput = {
  connect?: Array<OrganizationIncomingRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesGroupCreateFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesGroupUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: GroupUpdateInput | null | undefined;
};

export type OrganizationIncomingRolesGroupUpdateFieldInput = {
  connect?: Array<OrganizationIncomingRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesGroupCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationIncomingRolesGroupDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationIncomingRolesGroupDisconnectFieldInput> | null | undefined;
  update?: OrganizationIncomingRolesGroupUpdateConnectionInput | null | undefined;
  where?: OrganizationIncomingRolesGroupConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesOrganizationConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: OrganizationConnectWhere | null | undefined;
};

export type OrganizationIncomingRolesOrganizationConnectionWhere = {
  AND?: Array<OrganizationIncomingRolesOrganizationConnectionWhere> | null | undefined;
  NOT?: OrganizationIncomingRolesOrganizationConnectionWhere | null | undefined;
  OR?: Array<OrganizationIncomingRolesOrganizationConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type OrganizationIncomingRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type OrganizationIncomingRolesOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: OrganizationIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: OrganizationIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesOrganizationFieldInput = {
  connect?: Array<OrganizationIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesOrganizationCreateFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesOrganizationUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type OrganizationIncomingRolesOrganizationUpdateFieldInput = {
  connect?: Array<OrganizationIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesOrganizationCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationIncomingRolesOrganizationDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationIncomingRolesOrganizationDisconnectFieldInput> | null | undefined;
  update?: OrganizationIncomingRolesOrganizationUpdateConnectionInput | null | undefined;
  where?: OrganizationIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesProfileConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: ProfileConnectWhere | null | undefined;
};

export type OrganizationIncomingRolesProfileConnectionWhere = {
  AND?: Array<OrganizationIncomingRolesProfileConnectionWhere> | null | undefined;
  NOT?: OrganizationIncomingRolesProfileConnectionWhere | null | undefined;
  OR?: Array<OrganizationIncomingRolesProfileConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type OrganizationIncomingRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type OrganizationIncomingRolesProfileDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: OrganizationIncomingRolesProfileConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesProfileDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: OrganizationIncomingRolesProfileConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesProfileFieldInput = {
  connect?: Array<OrganizationIncomingRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesProfileCreateFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesProfileUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: ProfileUpdateInput | null | undefined;
};

export type OrganizationIncomingRolesProfileUpdateFieldInput = {
  connect?: Array<OrganizationIncomingRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesProfileCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationIncomingRolesProfileDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationIncomingRolesProfileDisconnectFieldInput> | null | undefined;
  update?: OrganizationIncomingRolesProfileUpdateConnectionInput | null | undefined;
  where?: OrganizationIncomingRolesProfileConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesUpdateInput = {
  Group?: Array<OrganizationIncomingRolesGroupUpdateFieldInput> | null | undefined;
  Organization?: Array<OrganizationIncomingRolesOrganizationUpdateFieldInput> | null | undefined;
  Profile?: Array<OrganizationIncomingRolesProfileUpdateFieldInput> | null | undefined;
  User?: Array<OrganizationIncomingRolesUserUpdateFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesUserConnectFieldInput = {
  connect?: Array<UserConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: UserConnectWhere | null | undefined;
};

export type OrganizationIncomingRolesUserConnectionWhere = {
  AND?: Array<OrganizationIncomingRolesUserConnectionWhere> | null | undefined;
  NOT?: OrganizationIncomingRolesUserConnectionWhere | null | undefined;
  OR?: Array<OrganizationIncomingRolesUserConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type OrganizationIncomingRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type OrganizationIncomingRolesUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: OrganizationIncomingRolesUserConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: OrganizationIncomingRolesUserConnectionWhere | null | undefined;
};

export type OrganizationIncomingRolesUserFieldInput = {
  connect?: Array<OrganizationIncomingRolesUserConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesUserCreateFieldInput> | null | undefined;
};

export type OrganizationIncomingRolesUserUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: UserUpdateInput | null | undefined;
};

export type OrganizationIncomingRolesUserUpdateFieldInput = {
  connect?: Array<OrganizationIncomingRolesUserConnectFieldInput> | null | undefined;
  create?: Array<OrganizationIncomingRolesUserCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationIncomingRolesUserDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationIncomingRolesUserDisconnectFieldInput> | null | undefined;
  update?: OrganizationIncomingRolesUserUpdateConnectionInput | null | undefined;
  where?: OrganizationIncomingRolesUserConnectionWhere | null | undefined;
};

export type OrganizationLicensedApplicationsAggregateInput = {
  AND?: Array<OrganizationLicensedApplicationsAggregateInput> | null | undefined;
  NOT?: OrganizationLicensedApplicationsAggregateInput | null | undefined;
  OR?: Array<OrganizationLicensedApplicationsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: LicensePropertiesAggregationWhereInput | null | undefined;
  node?: OrganizationLicensedApplicationsNodeAggregationWhereInput | null | undefined;
};

export type OrganizationLicensedApplicationsConnectionWhere = {
  AND?: Array<OrganizationLicensedApplicationsConnectionWhere> | null | undefined;
  NOT?: OrganizationLicensedApplicationsConnectionWhere | null | undefined;
  OR?: Array<OrganizationLicensedApplicationsConnectionWhere> | null | undefined;
  edge?: LicensePropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: LicensePropertiesWhere | null | undefined;
  node?: ApplicationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ApplicationWhere | null | undefined;
};

export type OrganizationLicensedApplicationsNodeAggregationWhereInput = {
  AND?: Array<OrganizationLicensedApplicationsNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationLicensedApplicationsNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationLicensedApplicationsNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  uri_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  uri_AVERAGE_LENGTH_GT?: number | null | undefined;
  uri_AVERAGE_LENGTH_GTE?: number | null | undefined;
  uri_AVERAGE_LENGTH_LT?: number | null | undefined;
  uri_AVERAGE_LENGTH_LTE?: number | null | undefined;
  uri_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  uri_LONGEST_LENGTH_GT?: number | null | undefined;
  uri_LONGEST_LENGTH_GTE?: number | null | undefined;
  uri_LONGEST_LENGTH_LT?: number | null | undefined;
  uri_LONGEST_LENGTH_LTE?: number | null | undefined;
  uri_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  uri_SHORTEST_LENGTH_GT?: number | null | undefined;
  uri_SHORTEST_LENGTH_GTE?: number | null | undefined;
  uri_SHORTEST_LENGTH_LT?: number | null | undefined;
  uri_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationOptions = {
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  /** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: Array<OrganizationSort> | null | undefined;
};

export type OrganizationProfilesAggregateInput = {
  AND?: Array<OrganizationProfilesAggregateInput> | null | undefined;
  NOT?: OrganizationProfilesAggregateInput | null | undefined;
  OR?: Array<OrganizationProfilesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: OrganizationProfilesNodeAggregationWhereInput | null | undefined;
};

export type OrganizationProfilesConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: ProfileConnectWhere | null | undefined;
};

export type OrganizationProfilesConnectionWhere = {
  AND?: Array<OrganizationProfilesConnectionWhere> | null | undefined;
  NOT?: OrganizationProfilesConnectionWhere | null | undefined;
  OR?: Array<OrganizationProfilesConnectionWhere> | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type OrganizationProfilesCreateFieldInput = {
  node: ProfileCreateInput;
};

export type OrganizationProfilesDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: OrganizationProfilesConnectionWhere | null | undefined;
};

export type OrganizationProfilesDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: OrganizationProfilesConnectionWhere | null | undefined;
};

export type OrganizationProfilesFieldInput = {
  connect?: Array<OrganizationProfilesConnectFieldInput> | null | undefined;
  create?: Array<OrganizationProfilesCreateFieldInput> | null | undefined;
};

export type OrganizationProfilesNodeAggregationWhereInput = {
  AND?: Array<OrganizationProfilesNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationProfilesNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationProfilesNodeAggregationWhereInput> | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_LONGEST_LENGTH_GT?: number | null | undefined;
  firstName_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_LT?: number | null | undefined;
  firstName_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_LONGEST_LENGTH_GT?: number | null | undefined;
  lastName_LONGEST_LENGTH_GTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_LT?: number | null | undefined;
  lastName_LONGEST_LENGTH_LTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_LONGEST_LENGTH_GT?: number | null | undefined;
  salutation_LONGEST_LENGTH_GTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_LT?: number | null | undefined;
  salutation_LONGEST_LENGTH_LTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_LONGEST_LENGTH_GT?: number | null | undefined;
  shortName_LONGEST_LENGTH_GTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_LT?: number | null | undefined;
  shortName_LONGEST_LENGTH_LTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  title_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  title_AVERAGE_LENGTH_GT?: number | null | undefined;
  title_AVERAGE_LENGTH_GTE?: number | null | undefined;
  title_AVERAGE_LENGTH_LT?: number | null | undefined;
  title_AVERAGE_LENGTH_LTE?: number | null | undefined;
  title_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  title_LONGEST_LENGTH_GT?: number | null | undefined;
  title_LONGEST_LENGTH_GTE?: number | null | undefined;
  title_LONGEST_LENGTH_LT?: number | null | undefined;
  title_LONGEST_LENGTH_LTE?: number | null | undefined;
  title_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  title_SHORTEST_LENGTH_GT?: number | null | undefined;
  title_SHORTEST_LENGTH_GTE?: number | null | undefined;
  title_SHORTEST_LENGTH_LT?: number | null | undefined;
  title_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosAccepted_MAX_EQUAL?: string | null | undefined;
  tosAccepted_MAX_GT?: string | null | undefined;
  tosAccepted_MAX_GTE?: string | null | undefined;
  tosAccepted_MAX_LT?: string | null | undefined;
  tosAccepted_MAX_LTE?: string | null | undefined;
  tosAccepted_MIN_EQUAL?: string | null | undefined;
  tosAccepted_MIN_GT?: string | null | undefined;
  tosAccepted_MIN_GTE?: string | null | undefined;
  tosAccepted_MIN_LT?: string | null | undefined;
  tosAccepted_MIN_LTE?: string | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationProfilesUpdateConnectionInput = {
  node?: ProfileUpdateInput | null | undefined;
};

export type OrganizationProfilesUpdateFieldInput = {
  connect?: Array<OrganizationProfilesConnectFieldInput> | null | undefined;
  create?: Array<OrganizationProfilesCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationProfilesDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationProfilesDisconnectFieldInput> | null | undefined;
  update?: OrganizationProfilesUpdateConnectionInput | null | undefined;
  where?: OrganizationProfilesConnectionWhere | null | undefined;
};

export type OrganizationPropertiesAggregateInput = {
  AND?: Array<OrganizationPropertiesAggregateInput> | null | undefined;
  NOT?: OrganizationPropertiesAggregateInput | null | undefined;
  OR?: Array<OrganizationPropertiesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: PropertiesScopeAggregationWhereInput | null | undefined;
  node?: OrganizationPropertiesNodeAggregationWhereInput | null | undefined;
};

export type OrganizationPropertiesConnectFieldInput = {
  connect?: Array<PropertyConnectInput> | null | undefined;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: PropertyConnectWhere | null | undefined;
};

export type OrganizationPropertiesConnectionWhere = {
  AND?: Array<OrganizationPropertiesConnectionWhere> | null | undefined;
  NOT?: OrganizationPropertiesConnectionWhere | null | undefined;
  OR?: Array<OrganizationPropertiesConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: PropertyWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: PropertyWhere | null | undefined;
};

export type OrganizationPropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type OrganizationPropertiesDeleteFieldInput = {
  delete?: PropertyDeleteInput | null | undefined;
  where?: OrganizationPropertiesConnectionWhere | null | undefined;
};

export type OrganizationPropertiesDisconnectFieldInput = {
  disconnect?: PropertyDisconnectInput | null | undefined;
  where?: OrganizationPropertiesConnectionWhere | null | undefined;
};

export type OrganizationPropertiesFieldInput = {
  connect?: Array<OrganizationPropertiesConnectFieldInput> | null | undefined;
  create?: Array<OrganizationPropertiesCreateFieldInput> | null | undefined;
};

export type OrganizationPropertiesNodeAggregationWhereInput = {
  AND?: Array<OrganizationPropertiesNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationPropertiesNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationPropertiesNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  value_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  value_AVERAGE_LENGTH_GT?: number | null | undefined;
  value_AVERAGE_LENGTH_GTE?: number | null | undefined;
  value_AVERAGE_LENGTH_LT?: number | null | undefined;
  value_AVERAGE_LENGTH_LTE?: number | null | undefined;
  value_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  value_LONGEST_LENGTH_GT?: number | null | undefined;
  value_LONGEST_LENGTH_GTE?: number | null | undefined;
  value_LONGEST_LENGTH_LT?: number | null | undefined;
  value_LONGEST_LENGTH_LTE?: number | null | undefined;
  value_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  value_SHORTEST_LENGTH_GT?: number | null | undefined;
  value_SHORTEST_LENGTH_GTE?: number | null | undefined;
  value_SHORTEST_LENGTH_LT?: number | null | undefined;
  value_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationPropertiesUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: PropertyUpdateInput | null | undefined;
};

export type OrganizationPropertiesUpdateFieldInput = {
  connect?: Array<OrganizationPropertiesConnectFieldInput> | null | undefined;
  create?: Array<OrganizationPropertiesCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationPropertiesDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationPropertiesDisconnectFieldInput> | null | undefined;
  update?: OrganizationPropertiesUpdateConnectionInput | null | undefined;
  where?: OrganizationPropertiesConnectionWhere | null | undefined;
};

export type OrganizationShadowProfileGroupsAggregateInput = {
  AND?: Array<OrganizationShadowProfileGroupsAggregateInput> | null | undefined;
  NOT?: OrganizationShadowProfileGroupsAggregateInput | null | undefined;
  OR?: Array<OrganizationShadowProfileGroupsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: ShadowRelationPropertiesAggregationWhereInput | null | undefined;
  node?: OrganizationShadowProfileGroupsNodeAggregationWhereInput | null | undefined;
};

export type OrganizationShadowProfileGroupsConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  edge: ShadowRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: GroupConnectWhere | null | undefined;
};

export type OrganizationShadowProfileGroupsConnectionWhere = {
  AND?: Array<OrganizationShadowProfileGroupsConnectionWhere> | null | undefined;
  NOT?: OrganizationShadowProfileGroupsConnectionWhere | null | undefined;
  OR?: Array<OrganizationShadowProfileGroupsConnectionWhere> | null | undefined;
  edge?: ShadowRelationPropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: ShadowRelationPropertiesWhere | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type OrganizationShadowProfileGroupsCreateFieldInput = {
  edge: ShadowRelationPropertiesCreateInput;
  node: GroupCreateInput;
};

export type OrganizationShadowProfileGroupsDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: OrganizationShadowProfileGroupsConnectionWhere | null | undefined;
};

export type OrganizationShadowProfileGroupsDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: OrganizationShadowProfileGroupsConnectionWhere | null | undefined;
};

export type OrganizationShadowProfileGroupsFieldInput = {
  connect?: Array<OrganizationShadowProfileGroupsConnectFieldInput> | null | undefined;
  create?: Array<OrganizationShadowProfileGroupsCreateFieldInput> | null | undefined;
};

export type OrganizationShadowProfileGroupsNodeAggregationWhereInput = {
  AND?: Array<OrganizationShadowProfileGroupsNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationShadowProfileGroupsNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationShadowProfileGroupsNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationShadowProfileGroupsUpdateConnectionInput = {
  edge?: ShadowRelationPropertiesUpdateInput | null | undefined;
  node?: GroupUpdateInput | null | undefined;
};

export type OrganizationShadowProfileGroupsUpdateFieldInput = {
  connect?: Array<OrganizationShadowProfileGroupsConnectFieldInput> | null | undefined;
  create?: Array<OrganizationShadowProfileGroupsCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationShadowProfileGroupsDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationShadowProfileGroupsDisconnectFieldInput> | null | undefined;
  update?: OrganizationShadowProfileGroupsUpdateConnectionInput | null | undefined;
  where?: OrganizationShadowProfileGroupsConnectionWhere | null | undefined;
};

export type OrganizationShadowsProfilesToAggregateInput = {
  AND?: Array<OrganizationShadowsProfilesToAggregateInput> | null | undefined;
  NOT?: OrganizationShadowsProfilesToAggregateInput | null | undefined;
  OR?: Array<OrganizationShadowsProfilesToAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: ShadowRelationPropertiesAggregationWhereInput | null | undefined;
  node?: OrganizationShadowsProfilesToNodeAggregationWhereInput | null | undefined;
};

export type OrganizationShadowsProfilesToConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge: ShadowRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: OrganizationConnectWhere | null | undefined;
};

export type OrganizationShadowsProfilesToConnectionWhere = {
  AND?: Array<OrganizationShadowsProfilesToConnectionWhere> | null | undefined;
  NOT?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
  OR?: Array<OrganizationShadowsProfilesToConnectionWhere> | null | undefined;
  edge?: ShadowRelationPropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: ShadowRelationPropertiesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type OrganizationShadowsProfilesToCreateFieldInput = {
  edge: ShadowRelationPropertiesCreateInput;
  node: OrganizationCreateInput;
};

export type OrganizationShadowsProfilesToDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
};

export type OrganizationShadowsProfilesToDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
};

export type OrganizationShadowsProfilesToFieldInput = {
  connect?: Array<OrganizationShadowsProfilesToConnectFieldInput> | null | undefined;
  create?: Array<OrganizationShadowsProfilesToCreateFieldInput> | null | undefined;
};

export type OrganizationShadowsProfilesToNodeAggregationWhereInput = {
  AND?: Array<OrganizationShadowsProfilesToNodeAggregationWhereInput> | null | undefined;
  NOT?: OrganizationShadowsProfilesToNodeAggregationWhereInput | null | undefined;
  OR?: Array<OrganizationShadowsProfilesToNodeAggregationWhereInput> | null | undefined;
  address1_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address1_AVERAGE_LENGTH_GT?: number | null | undefined;
  address1_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address1_AVERAGE_LENGTH_LT?: number | null | undefined;
  address1_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address1_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address1_LONGEST_LENGTH_GT?: number | null | undefined;
  address1_LONGEST_LENGTH_GTE?: number | null | undefined;
  address1_LONGEST_LENGTH_LT?: number | null | undefined;
  address1_LONGEST_LENGTH_LTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address1_SHORTEST_LENGTH_GT?: number | null | undefined;
  address1_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_LT?: number | null | undefined;
  address1_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address2_AVERAGE_LENGTH_GT?: number | null | undefined;
  address2_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_LT?: number | null | undefined;
  address2_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address2_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address2_LONGEST_LENGTH_GT?: number | null | undefined;
  address2_LONGEST_LENGTH_GTE?: number | null | undefined;
  address2_LONGEST_LENGTH_LT?: number | null | undefined;
  address2_LONGEST_LENGTH_LTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address2_SHORTEST_LENGTH_GT?: number | null | undefined;
  address2_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_LT?: number | null | undefined;
  address2_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address3_AVERAGE_LENGTH_GT?: number | null | undefined;
  address3_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_LT?: number | null | undefined;
  address3_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address3_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address3_LONGEST_LENGTH_GT?: number | null | undefined;
  address3_LONGEST_LENGTH_GTE?: number | null | undefined;
  address3_LONGEST_LENGTH_LT?: number | null | undefined;
  address3_LONGEST_LENGTH_LTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address3_SHORTEST_LENGTH_GT?: number | null | undefined;
  address3_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_LT?: number | null | undefined;
  address3_SHORTEST_LENGTH_LTE?: number | null | undefined;
  city_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  city_AVERAGE_LENGTH_GT?: number | null | undefined;
  city_AVERAGE_LENGTH_GTE?: number | null | undefined;
  city_AVERAGE_LENGTH_LT?: number | null | undefined;
  city_AVERAGE_LENGTH_LTE?: number | null | undefined;
  city_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  city_LONGEST_LENGTH_GT?: number | null | undefined;
  city_LONGEST_LENGTH_GTE?: number | null | undefined;
  city_LONGEST_LENGTH_LT?: number | null | undefined;
  city_LONGEST_LENGTH_LTE?: number | null | undefined;
  city_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  city_SHORTEST_LENGTH_GT?: number | null | undefined;
  city_SHORTEST_LENGTH_GTE?: number | null | undefined;
  city_SHORTEST_LENGTH_LT?: number | null | undefined;
  city_SHORTEST_LENGTH_LTE?: number | null | undefined;
  country_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  country_AVERAGE_LENGTH_GT?: number | null | undefined;
  country_AVERAGE_LENGTH_GTE?: number | null | undefined;
  country_AVERAGE_LENGTH_LT?: number | null | undefined;
  country_AVERAGE_LENGTH_LTE?: number | null | undefined;
  country_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  country_LONGEST_LENGTH_GT?: number | null | undefined;
  country_LONGEST_LENGTH_GTE?: number | null | undefined;
  country_LONGEST_LENGTH_LT?: number | null | undefined;
  country_LONGEST_LENGTH_LTE?: number | null | undefined;
  country_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  country_SHORTEST_LENGTH_GT?: number | null | undefined;
  country_SHORTEST_LENGTH_GTE?: number | null | undefined;
  country_SHORTEST_LENGTH_LT?: number | null | undefined;
  country_SHORTEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  region_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  region_AVERAGE_LENGTH_GT?: number | null | undefined;
  region_AVERAGE_LENGTH_GTE?: number | null | undefined;
  region_AVERAGE_LENGTH_LT?: number | null | undefined;
  region_AVERAGE_LENGTH_LTE?: number | null | undefined;
  region_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  region_LONGEST_LENGTH_GT?: number | null | undefined;
  region_LONGEST_LENGTH_GTE?: number | null | undefined;
  region_LONGEST_LENGTH_LT?: number | null | undefined;
  region_LONGEST_LENGTH_LTE?: number | null | undefined;
  region_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  region_SHORTEST_LENGTH_GT?: number | null | undefined;
  region_SHORTEST_LENGTH_GTE?: number | null | undefined;
  region_SHORTEST_LENGTH_LT?: number | null | undefined;
  region_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_LONGEST_LENGTH_GT?: number | null | undefined;
  timezone_LONGEST_LENGTH_GTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_LT?: number | null | undefined;
  timezone_LONGEST_LENGTH_LTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type OrganizationShadowsProfilesToUpdateConnectionInput = {
  edge?: ShadowRelationPropertiesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type OrganizationShadowsProfilesToUpdateFieldInput = {
  connect?: Array<OrganizationShadowsProfilesToConnectFieldInput> | null | undefined;
  create?: Array<OrganizationShadowsProfilesToCreateFieldInput> | null | undefined;
  delete?: Array<OrganizationShadowsProfilesToDeleteFieldInput> | null | undefined;
  disconnect?: Array<OrganizationShadowsProfilesToDisconnectFieldInput> | null | undefined;
  update?: OrganizationShadowsProfilesToUpdateConnectionInput | null | undefined;
  where?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
  address1?: SortDirection | null | undefined;
  address2?: SortDirection | null | undefined;
  address3?: SortDirection | null | undefined;
  city?: SortDirection | null | undefined;
  country?: SortDirection | null | undefined;
  imprintHtml?: SortDirection | null | undefined;
  locale?: SortDirection | null | undefined;
  name?: SortDirection | null | undefined;
  privacyHtml?: SortDirection | null | undefined;
  region?: SortDirection | null | undefined;
  studentCount?: SortDirection | null | undefined;
  tecartContactId?: SortDirection | null | undefined;
  timezone?: SortDirection | null | undefined;
  tosHtml?: SortDirection | null | undefined;
  tosVersion?: SortDirection | null | undefined;
  uuid?: SortDirection | null | undefined;
  zipCode?: SortDirection | null | undefined;
};

export type OrganizationUpdateInput = {
  address1?: string | null | undefined;
  address2?: string | null | undefined;
  address3?: string | null | undefined;
  city?: string | null | undefined;
  collaboratesWith?: Array<OrganizationCollaboratesWithUpdateFieldInput> | null | undefined;
  country?: string | null | undefined;
  federatedClient?: Array<OrganizationFederatedClientUpdateFieldInput> | null | undefined;
  groups?: Array<OrganizationGroupsUpdateFieldInput> | null | undefined;
  imprintHtml?: string | null | undefined;
  incomingRoles?: OrganizationIncomingRolesUpdateInput | null | undefined;
  locale?: string | null | undefined;
  name?: string | null | undefined;
  privacyHtml?: string | null | undefined;
  profiles?: Array<OrganizationProfilesUpdateFieldInput> | null | undefined;
  properties?: Array<OrganizationPropertiesUpdateFieldInput> | null | undefined;
  region?: string | null | undefined;
  shadowProfileGroups?: Array<OrganizationShadowProfileGroupsUpdateFieldInput> | null | undefined;
  shadowsProfilesTo?: Array<OrganizationShadowsProfilesToUpdateFieldInput> | null | undefined;
  tecartContactId?: string | null | undefined;
  timezone?: string | null | undefined;
  tosHtml?: string | null | undefined;
  tosVersion?: string | null | undefined;
  zipCode?: string | null | undefined;
};

export type OrganizationWhere = {
  AND?: Array<OrganizationWhere> | null | undefined;
  NOT?: OrganizationWhere | null | undefined;
  OR?: Array<OrganizationWhere> | null | undefined;
  address1?: string | null | undefined;
  address1_CONTAINS?: string | null | undefined;
  address1_ENDS_WITH?: string | null | undefined;
  address1_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_STARTS_WITH?: string | null | undefined;
  address1_STARTS_WITH?: string | null | undefined;
  address2?: string | null | undefined;
  address2_CONTAINS?: string | null | undefined;
  address2_ENDS_WITH?: string | null | undefined;
  address2_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_STARTS_WITH?: string | null | undefined;
  address2_STARTS_WITH?: string | null | undefined;
  address3?: string | null | undefined;
  address3_CONTAINS?: string | null | undefined;
  address3_ENDS_WITH?: string | null | undefined;
  address3_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_STARTS_WITH?: string | null | undefined;
  address3_STARTS_WITH?: string | null | undefined;
  city?: string | null | undefined;
  city_CONTAINS?: string | null | undefined;
  city_ENDS_WITH?: string | null | undefined;
  city_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_STARTS_WITH?: string | null | undefined;
  city_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `collaboratesWith_SOME` instead. */
  collaboratesWith?: OrganizationWhere | null | undefined;
  collaboratesWithAggregate?: OrganizationCollaboratesWithAggregateInput | null | undefined;
  /** @deprecated Use `collaboratesWithConnection_SOME` instead. */
  collaboratesWithConnection?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_ALL?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_NONE?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
  /** @deprecated Use `collaboratesWithConnection_NONE` instead. */
  collaboratesWithConnection_NOT?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_SINGLE?:
    | OrganizationCollaboratesWithConnectionWhere
    | null
    | undefined;
  /** Return Organizations where some of the related OrganizationCollaboratesWithConnections match this filter */
  collaboratesWithConnection_SOME?: OrganizationCollaboratesWithConnectionWhere | null | undefined;
  /** Return Organizations where all of the related Organizations match this filter */
  collaboratesWith_ALL?: OrganizationWhere | null | undefined;
  /** Return Organizations where none of the related Organizations match this filter */
  collaboratesWith_NONE?: OrganizationWhere | null | undefined;
  /** @deprecated Use `collaboratesWith_NONE` instead. */
  collaboratesWith_NOT?: OrganizationWhere | null | undefined;
  /** Return Organizations where one of the related Organizations match this filter */
  collaboratesWith_SINGLE?: OrganizationWhere | null | undefined;
  /** Return Organizations where some of the related Organizations match this filter */
  collaboratesWith_SOME?: OrganizationWhere | null | undefined;
  country?: string | null | undefined;
  country_CONTAINS?: string | null | undefined;
  country_ENDS_WITH?: string | null | undefined;
  country_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_STARTS_WITH?: string | null | undefined;
  country_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `federatedClient_SOME` instead. */
  federatedClient?: FederatedClientWhere | null | undefined;
  federatedClientAggregate?: OrganizationFederatedClientAggregateInput | null | undefined;
  /** @deprecated Use `federatedClientConnection_SOME` instead. */
  federatedClientConnection?: OrganizationFederatedClientConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_ALL?: OrganizationFederatedClientConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_NONE?: OrganizationFederatedClientConnectionWhere | null | undefined;
  /** @deprecated Use `federatedClientConnection_NONE` instead. */
  federatedClientConnection_NOT?: OrganizationFederatedClientConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_SINGLE?: OrganizationFederatedClientConnectionWhere | null | undefined;
  /** Return Organizations where some of the related OrganizationFederatedClientConnections match this filter */
  federatedClientConnection_SOME?: OrganizationFederatedClientConnectionWhere | null | undefined;
  /** Return Organizations where all of the related FederatedClients match this filter */
  federatedClient_ALL?: FederatedClientWhere | null | undefined;
  /** Return Organizations where none of the related FederatedClients match this filter */
  federatedClient_NONE?: FederatedClientWhere | null | undefined;
  /** @deprecated Use `federatedClient_NONE` instead. */
  federatedClient_NOT?: FederatedClientWhere | null | undefined;
  /** Return Organizations where one of the related FederatedClients match this filter */
  federatedClient_SINGLE?: FederatedClientWhere | null | undefined;
  /** Return Organizations where some of the related FederatedClients match this filter */
  federatedClient_SOME?: FederatedClientWhere | null | undefined;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: GroupWhere | null | undefined;
  groupsAggregate?: OrganizationGroupsAggregateInput | null | undefined;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: OrganizationGroupsConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationGroupsConnections match this filter */
  groupsConnection_ALL?: OrganizationGroupsConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationGroupsConnections match this filter */
  groupsConnection_NONE?: OrganizationGroupsConnectionWhere | null | undefined;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: OrganizationGroupsConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationGroupsConnections match this filter */
  groupsConnection_SINGLE?: OrganizationGroupsConnectionWhere | null | undefined;
  /** Return Organizations where some of the related OrganizationGroupsConnections match this filter */
  groupsConnection_SOME?: OrganizationGroupsConnectionWhere | null | undefined;
  /** Return Organizations where all of the related Groups match this filter */
  groups_ALL?: GroupWhere | null | undefined;
  /** Return Organizations where none of the related Groups match this filter */
  groups_NONE?: GroupWhere | null | undefined;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: GroupWhere | null | undefined;
  /** Return Organizations where one of the related Groups match this filter */
  groups_SINGLE?: GroupWhere | null | undefined;
  /** Return Organizations where some of the related Groups match this filter */
  groups_SOME?: GroupWhere | null | undefined;
  imprintHtml?: string | null | undefined;
  imprintHtml_CONTAINS?: string | null | undefined;
  imprintHtml_ENDS_WITH?: string | null | undefined;
  imprintHtml_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  imprintHtml_NOT_STARTS_WITH?: string | null | undefined;
  imprintHtml_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: OrganizationIncomingRolesConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: OrganizationIncomingRolesConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: OrganizationIncomingRolesConnectionWhere | null | undefined;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: OrganizationIncomingRolesConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: OrganizationIncomingRolesConnectionWhere | null | undefined;
  /** Return Organizations where some of the related OrganizationIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: OrganizationIncomingRolesConnectionWhere | null | undefined;
  /** Return Organizations where all of the related RoleTargets match this filter */
  incomingRoles_ALL?: RoleTargetWhere | null | undefined;
  /** Return Organizations where none of the related RoleTargets match this filter */
  incomingRoles_NONE?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: RoleTargetWhere | null | undefined;
  /** Return Organizations where one of the related RoleTargets match this filter */
  incomingRoles_SINGLE?: RoleTargetWhere | null | undefined;
  /** Return Organizations where some of the related RoleTargets match this filter */
  incomingRoles_SOME?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `licensedApplications_SOME` instead. */
  licensedApplications?: ApplicationWhere | null | undefined;
  licensedApplicationsAggregate?: OrganizationLicensedApplicationsAggregateInput | null | undefined;
  /** @deprecated Use `licensedApplicationsConnection_SOME` instead. */
  licensedApplicationsConnection?:
    | OrganizationLicensedApplicationsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where all of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_ALL?:
    | OrganizationLicensedApplicationsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where none of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_NONE?:
    | OrganizationLicensedApplicationsConnectionWhere
    | null
    | undefined;
  /** @deprecated Use `licensedApplicationsConnection_NONE` instead. */
  licensedApplicationsConnection_NOT?:
    | OrganizationLicensedApplicationsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where one of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_SINGLE?:
    | OrganizationLicensedApplicationsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where some of the related OrganizationLicensedApplicationsConnections match this filter */
  licensedApplicationsConnection_SOME?:
    | OrganizationLicensedApplicationsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where all of the related Applications match this filter */
  licensedApplications_ALL?: ApplicationWhere | null | undefined;
  /** Return Organizations where none of the related Applications match this filter */
  licensedApplications_NONE?: ApplicationWhere | null | undefined;
  /** @deprecated Use `licensedApplications_NONE` instead. */
  licensedApplications_NOT?: ApplicationWhere | null | undefined;
  /** Return Organizations where one of the related Applications match this filter */
  licensedApplications_SINGLE?: ApplicationWhere | null | undefined;
  /** Return Organizations where some of the related Applications match this filter */
  licensedApplications_SOME?: ApplicationWhere | null | undefined;
  locale?: string | null | undefined;
  locale_CONTAINS?: string | null | undefined;
  locale_ENDS_WITH?: string | null | undefined;
  locale_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: string | null | undefined;
  locale_STARTS_WITH?: string | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  privacyHtml?: string | null | undefined;
  privacyHtml_CONTAINS?: string | null | undefined;
  privacyHtml_ENDS_WITH?: string | null | undefined;
  privacyHtml_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacyHtml_NOT_STARTS_WITH?: string | null | undefined;
  privacyHtml_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: ProfileWhere | null | undefined;
  profilesAggregate?: OrganizationProfilesAggregateInput | null | undefined;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: OrganizationProfilesConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationProfilesConnections match this filter */
  profilesConnection_ALL?: OrganizationProfilesConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationProfilesConnections match this filter */
  profilesConnection_NONE?: OrganizationProfilesConnectionWhere | null | undefined;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: OrganizationProfilesConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationProfilesConnections match this filter */
  profilesConnection_SINGLE?: OrganizationProfilesConnectionWhere | null | undefined;
  /** Return Organizations where some of the related OrganizationProfilesConnections match this filter */
  profilesConnection_SOME?: OrganizationProfilesConnectionWhere | null | undefined;
  /** Return Organizations where all of the related Profiles match this filter */
  profiles_ALL?: ProfileWhere | null | undefined;
  /** Return Organizations where none of the related Profiles match this filter */
  profiles_NONE?: ProfileWhere | null | undefined;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: ProfileWhere | null | undefined;
  /** Return Organizations where one of the related Profiles match this filter */
  profiles_SINGLE?: ProfileWhere | null | undefined;
  /** Return Organizations where some of the related Profiles match this filter */
  profiles_SOME?: ProfileWhere | null | undefined;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: PropertyWhere | null | undefined;
  propertiesAggregate?: OrganizationPropertiesAggregateInput | null | undefined;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: OrganizationPropertiesConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_ALL?: OrganizationPropertiesConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_NONE?: OrganizationPropertiesConnectionWhere | null | undefined;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: OrganizationPropertiesConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_SINGLE?: OrganizationPropertiesConnectionWhere | null | undefined;
  /** Return Organizations where some of the related OrganizationPropertiesConnections match this filter */
  propertiesConnection_SOME?: OrganizationPropertiesConnectionWhere | null | undefined;
  /** Return Organizations where all of the related Properties match this filter */
  properties_ALL?: PropertyWhere | null | undefined;
  /** Return Organizations where none of the related Properties match this filter */
  properties_NONE?: PropertyWhere | null | undefined;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: PropertyWhere | null | undefined;
  /** Return Organizations where one of the related Properties match this filter */
  properties_SINGLE?: PropertyWhere | null | undefined;
  /** Return Organizations where some of the related Properties match this filter */
  properties_SOME?: PropertyWhere | null | undefined;
  region?: string | null | undefined;
  region_CONTAINS?: string | null | undefined;
  region_ENDS_WITH?: string | null | undefined;
  region_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  region_NOT_STARTS_WITH?: string | null | undefined;
  region_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `shadowProfileGroups_SOME` instead. */
  shadowProfileGroups?: GroupWhere | null | undefined;
  shadowProfileGroupsAggregate?: OrganizationShadowProfileGroupsAggregateInput | null | undefined;
  /** @deprecated Use `shadowProfileGroupsConnection_SOME` instead. */
  shadowProfileGroupsConnection?: OrganizationShadowProfileGroupsConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_ALL?:
    | OrganizationShadowProfileGroupsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where none of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_NONE?:
    | OrganizationShadowProfileGroupsConnectionWhere
    | null
    | undefined;
  /** @deprecated Use `shadowProfileGroupsConnection_NONE` instead. */
  shadowProfileGroupsConnection_NOT?:
    | OrganizationShadowProfileGroupsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where one of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_SINGLE?:
    | OrganizationShadowProfileGroupsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where some of the related OrganizationShadowProfileGroupsConnections match this filter */
  shadowProfileGroupsConnection_SOME?:
    | OrganizationShadowProfileGroupsConnectionWhere
    | null
    | undefined;
  /** Return Organizations where all of the related Groups match this filter */
  shadowProfileGroups_ALL?: GroupWhere | null | undefined;
  /** Return Organizations where none of the related Groups match this filter */
  shadowProfileGroups_NONE?: GroupWhere | null | undefined;
  /** @deprecated Use `shadowProfileGroups_NONE` instead. */
  shadowProfileGroups_NOT?: GroupWhere | null | undefined;
  /** Return Organizations where one of the related Groups match this filter */
  shadowProfileGroups_SINGLE?: GroupWhere | null | undefined;
  /** Return Organizations where some of the related Groups match this filter */
  shadowProfileGroups_SOME?: GroupWhere | null | undefined;
  /** @deprecated Use `shadowsProfilesTo_SOME` instead. */
  shadowsProfilesTo?: OrganizationWhere | null | undefined;
  shadowsProfilesToAggregate?: OrganizationShadowsProfilesToAggregateInput | null | undefined;
  /** @deprecated Use `shadowsProfilesToConnection_SOME` instead. */
  shadowsProfilesToConnection?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
  /** Return Organizations where all of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_ALL?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
  /** Return Organizations where none of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_NONE?:
    | OrganizationShadowsProfilesToConnectionWhere
    | null
    | undefined;
  /** @deprecated Use `shadowsProfilesToConnection_NONE` instead. */
  shadowsProfilesToConnection_NOT?: OrganizationShadowsProfilesToConnectionWhere | null | undefined;
  /** Return Organizations where one of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_SINGLE?:
    | OrganizationShadowsProfilesToConnectionWhere
    | null
    | undefined;
  /** Return Organizations where some of the related OrganizationShadowsProfilesToConnections match this filter */
  shadowsProfilesToConnection_SOME?:
    | OrganizationShadowsProfilesToConnectionWhere
    | null
    | undefined;
  /** Return Organizations where all of the related Organizations match this filter */
  shadowsProfilesTo_ALL?: OrganizationWhere | null | undefined;
  /** Return Organizations where none of the related Organizations match this filter */
  shadowsProfilesTo_NONE?: OrganizationWhere | null | undefined;
  /** @deprecated Use `shadowsProfilesTo_NONE` instead. */
  shadowsProfilesTo_NOT?: OrganizationWhere | null | undefined;
  /** Return Organizations where one of the related Organizations match this filter */
  shadowsProfilesTo_SINGLE?: OrganizationWhere | null | undefined;
  /** Return Organizations where some of the related Organizations match this filter */
  shadowsProfilesTo_SOME?: OrganizationWhere | null | undefined;
  studentCount?: number | null | undefined;
  studentCount_GT?: number | null | undefined;
  studentCount_GTE?: number | null | undefined;
  studentCount_IN?: Array<number | null | undefined> | null | undefined;
  studentCount_LT?: number | null | undefined;
  studentCount_LTE?: number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentCount_NOT?: number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentCount_NOT_IN?: Array<number | null | undefined> | null | undefined;
  tecartContactId?: string | null | undefined;
  tecartContactId_CONTAINS?: string | null | undefined;
  tecartContactId_ENDS_WITH?: string | null | undefined;
  tecartContactId_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartContactId_NOT_STARTS_WITH?: string | null | undefined;
  tecartContactId_STARTS_WITH?: string | null | undefined;
  timezone?: string | null | undefined;
  timezone_CONTAINS?: string | null | undefined;
  timezone_ENDS_WITH?: string | null | undefined;
  timezone_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_STARTS_WITH?: string | null | undefined;
  timezone_STARTS_WITH?: string | null | undefined;
  tosHtml?: string | null | undefined;
  tosHtml_CONTAINS?: string | null | undefined;
  tosHtml_ENDS_WITH?: string | null | undefined;
  tosHtml_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosHtml_NOT_STARTS_WITH?: string | null | undefined;
  tosHtml_STARTS_WITH?: string | null | undefined;
  tosVersion?: string | null | undefined;
  tosVersion_CONTAINS?: string | null | undefined;
  tosVersion_ENDS_WITH?: string | null | undefined;
  tosVersion_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_STARTS_WITH?: string | null | undefined;
  tosVersion_STARTS_WITH?: string | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
  zipCode?: string | null | undefined;
  zipCode_CONTAINS?: string | null | undefined;
  zipCode_ENDS_WITH?: string | null | undefined;
  zipCode_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_STARTS_WITH?: string | null | undefined;
  zipCode_STARTS_WITH?: string | null | undefined;
};

export type ProfileConnectInput = {
  groups?: Array<ProfileGroupsConnectFieldInput> | null | undefined;
  incomingRoles?: ProfileIncomingRolesConnectInput | null | undefined;
  organization?: ProfileOrganizationConnectFieldInput | null | undefined;
  properties?: Array<ProfilePropertiesConnectFieldInput> | null | undefined;
  roles?: ProfileRolesConnectInput | null | undefined;
  user?: ProfileUserConnectFieldInput | null | undefined;
};

export type ProfileConnectWhere = {
  node: ProfileWhere;
};

export type ProfileCreateInput = {
  birthday?: string | null | undefined;
  email?: string | null | undefined;
  firstName: string;
  firstNames?: string | null | undefined;
  groups?: ProfileGroupsFieldInput | null | undefined;
  incomingRoles?: ProfileIncomingRolesCreateInput | null | undefined;
  lastName: string;
  organization?: ProfileOrganizationFieldInput | null | undefined;
  prefixName?: string | null | undefined;
  properties?: ProfilePropertiesFieldInput | null | undefined;
  roles?: ProfileRolesCreateInput | null | undefined;
  salutation?: string | null | undefined;
  shortName?: string | null | undefined;
  tecartPersonId?: string | null | undefined;
  title?: string | null | undefined;
  tosAccepted?: string | null | undefined;
  tosVersion?: string | null | undefined;
  user?: ProfileUserFieldInput | null | undefined;
};

export type ProfileDeleteInput = {
  groups?: Array<ProfileGroupsDeleteFieldInput> | null | undefined;
  incomingRoles?: ProfileIncomingRolesDeleteInput | null | undefined;
  organization?: ProfileOrganizationDeleteFieldInput | null | undefined;
  properties?: Array<ProfilePropertiesDeleteFieldInput> | null | undefined;
  roles?: ProfileRolesDeleteInput | null | undefined;
  user?: ProfileUserDeleteFieldInput | null | undefined;
};

export type ProfileDisconnectInput = {
  groups?: Array<ProfileGroupsDisconnectFieldInput> | null | undefined;
  incomingRoles?: ProfileIncomingRolesDisconnectInput | null | undefined;
  organization?: ProfileOrganizationDisconnectFieldInput | null | undefined;
  properties?: Array<ProfilePropertiesDisconnectFieldInput> | null | undefined;
  roles?: ProfileRolesDisconnectInput | null | undefined;
  user?: ProfileUserDisconnectFieldInput | null | undefined;
};

export type ProfileGroupsAggregateInput = {
  AND?: Array<ProfileGroupsAggregateInput> | null | undefined;
  NOT?: ProfileGroupsAggregateInput | null | undefined;
  OR?: Array<ProfileGroupsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: ProfileGroupsNodeAggregationWhereInput | null | undefined;
};

export type ProfileGroupsConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: GroupConnectWhere | null | undefined;
};

export type ProfileGroupsConnectionWhere = {
  AND?: Array<ProfileGroupsConnectionWhere> | null | undefined;
  NOT?: ProfileGroupsConnectionWhere | null | undefined;
  OR?: Array<ProfileGroupsConnectionWhere> | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type ProfileGroupsCreateFieldInput = {
  node: GroupCreateInput;
};

export type ProfileGroupsDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: ProfileGroupsConnectionWhere | null | undefined;
};

export type ProfileGroupsDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: ProfileGroupsConnectionWhere | null | undefined;
};

export type ProfileGroupsFieldInput = {
  connect?: Array<ProfileGroupsConnectFieldInput> | null | undefined;
  create?: Array<ProfileGroupsCreateFieldInput> | null | undefined;
};

export type ProfileGroupsNodeAggregationWhereInput = {
  AND?: Array<ProfileGroupsNodeAggregationWhereInput> | null | undefined;
  NOT?: ProfileGroupsNodeAggregationWhereInput | null | undefined;
  OR?: Array<ProfileGroupsNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ProfileGroupsUpdateConnectionInput = {
  node?: GroupUpdateInput | null | undefined;
};

export type ProfileGroupsUpdateFieldInput = {
  connect?: Array<ProfileGroupsConnectFieldInput> | null | undefined;
  create?: Array<ProfileGroupsCreateFieldInput> | null | undefined;
  delete?: Array<ProfileGroupsDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileGroupsDisconnectFieldInput> | null | undefined;
  update?: ProfileGroupsUpdateConnectionInput | null | undefined;
  where?: ProfileGroupsConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesConnectInput = {
  Group?: Array<ProfileIncomingRolesGroupConnectFieldInput> | null | undefined;
  Organization?: Array<ProfileIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  Profile?: Array<ProfileIncomingRolesProfileConnectFieldInput> | null | undefined;
  User?: Array<ProfileIncomingRolesUserConnectFieldInput> | null | undefined;
};

export type ProfileIncomingRolesConnectionWhere = {
  Group?: ProfileIncomingRolesGroupConnectionWhere | null | undefined;
  Organization?: ProfileIncomingRolesOrganizationConnectionWhere | null | undefined;
  Profile?: ProfileIncomingRolesProfileConnectionWhere | null | undefined;
  User?: ProfileIncomingRolesUserConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesCreateInput = {
  Group?: ProfileIncomingRolesGroupFieldInput | null | undefined;
  Organization?: ProfileIncomingRolesOrganizationFieldInput | null | undefined;
  Profile?: ProfileIncomingRolesProfileFieldInput | null | undefined;
  User?: ProfileIncomingRolesUserFieldInput | null | undefined;
};

export type ProfileIncomingRolesDeleteInput = {
  Group?: Array<ProfileIncomingRolesGroupDeleteFieldInput> | null | undefined;
  Organization?: Array<ProfileIncomingRolesOrganizationDeleteFieldInput> | null | undefined;
  Profile?: Array<ProfileIncomingRolesProfileDeleteFieldInput> | null | undefined;
  User?: Array<ProfileIncomingRolesUserDeleteFieldInput> | null | undefined;
};

export type ProfileIncomingRolesDisconnectInput = {
  Group?: Array<ProfileIncomingRolesGroupDisconnectFieldInput> | null | undefined;
  Organization?: Array<ProfileIncomingRolesOrganizationDisconnectFieldInput> | null | undefined;
  Profile?: Array<ProfileIncomingRolesProfileDisconnectFieldInput> | null | undefined;
  User?: Array<ProfileIncomingRolesUserDisconnectFieldInput> | null | undefined;
};

export type ProfileIncomingRolesGroupConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: GroupConnectWhere | null | undefined;
};

export type ProfileIncomingRolesGroupConnectionWhere = {
  AND?: Array<ProfileIncomingRolesGroupConnectionWhere> | null | undefined;
  NOT?: ProfileIncomingRolesGroupConnectionWhere | null | undefined;
  OR?: Array<ProfileIncomingRolesGroupConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type ProfileIncomingRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type ProfileIncomingRolesGroupDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: ProfileIncomingRolesGroupConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesGroupDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: ProfileIncomingRolesGroupConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesGroupFieldInput = {
  connect?: Array<ProfileIncomingRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesGroupCreateFieldInput> | null | undefined;
};

export type ProfileIncomingRolesGroupUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: GroupUpdateInput | null | undefined;
};

export type ProfileIncomingRolesGroupUpdateFieldInput = {
  connect?: Array<ProfileIncomingRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesGroupCreateFieldInput> | null | undefined;
  delete?: Array<ProfileIncomingRolesGroupDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileIncomingRolesGroupDisconnectFieldInput> | null | undefined;
  update?: ProfileIncomingRolesGroupUpdateConnectionInput | null | undefined;
  where?: ProfileIncomingRolesGroupConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesOrganizationConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: OrganizationConnectWhere | null | undefined;
};

export type ProfileIncomingRolesOrganizationConnectionWhere = {
  AND?: Array<ProfileIncomingRolesOrganizationConnectionWhere> | null | undefined;
  NOT?: ProfileIncomingRolesOrganizationConnectionWhere | null | undefined;
  OR?: Array<ProfileIncomingRolesOrganizationConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type ProfileIncomingRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type ProfileIncomingRolesOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: ProfileIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: ProfileIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesOrganizationFieldInput = {
  connect?: Array<ProfileIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesOrganizationCreateFieldInput> | null | undefined;
};

export type ProfileIncomingRolesOrganizationUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type ProfileIncomingRolesOrganizationUpdateFieldInput = {
  connect?: Array<ProfileIncomingRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesOrganizationCreateFieldInput> | null | undefined;
  delete?: Array<ProfileIncomingRolesOrganizationDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileIncomingRolesOrganizationDisconnectFieldInput> | null | undefined;
  update?: ProfileIncomingRolesOrganizationUpdateConnectionInput | null | undefined;
  where?: ProfileIncomingRolesOrganizationConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesProfileConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: ProfileConnectWhere | null | undefined;
};

export type ProfileIncomingRolesProfileConnectionWhere = {
  AND?: Array<ProfileIncomingRolesProfileConnectionWhere> | null | undefined;
  NOT?: ProfileIncomingRolesProfileConnectionWhere | null | undefined;
  OR?: Array<ProfileIncomingRolesProfileConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type ProfileIncomingRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type ProfileIncomingRolesProfileDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: ProfileIncomingRolesProfileConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesProfileDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: ProfileIncomingRolesProfileConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesProfileFieldInput = {
  connect?: Array<ProfileIncomingRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesProfileCreateFieldInput> | null | undefined;
};

export type ProfileIncomingRolesProfileUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: ProfileUpdateInput | null | undefined;
};

export type ProfileIncomingRolesProfileUpdateFieldInput = {
  connect?: Array<ProfileIncomingRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesProfileCreateFieldInput> | null | undefined;
  delete?: Array<ProfileIncomingRolesProfileDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileIncomingRolesProfileDisconnectFieldInput> | null | undefined;
  update?: ProfileIncomingRolesProfileUpdateConnectionInput | null | undefined;
  where?: ProfileIncomingRolesProfileConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesUpdateInput = {
  Group?: Array<ProfileIncomingRolesGroupUpdateFieldInput> | null | undefined;
  Organization?: Array<ProfileIncomingRolesOrganizationUpdateFieldInput> | null | undefined;
  Profile?: Array<ProfileIncomingRolesProfileUpdateFieldInput> | null | undefined;
  User?: Array<ProfileIncomingRolesUserUpdateFieldInput> | null | undefined;
};

export type ProfileIncomingRolesUserConnectFieldInput = {
  connect?: Array<UserConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: UserConnectWhere | null | undefined;
};

export type ProfileIncomingRolesUserConnectionWhere = {
  AND?: Array<ProfileIncomingRolesUserConnectionWhere> | null | undefined;
  NOT?: ProfileIncomingRolesUserConnectionWhere | null | undefined;
  OR?: Array<ProfileIncomingRolesUserConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type ProfileIncomingRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type ProfileIncomingRolesUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: ProfileIncomingRolesUserConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: ProfileIncomingRolesUserConnectionWhere | null | undefined;
};

export type ProfileIncomingRolesUserFieldInput = {
  connect?: Array<ProfileIncomingRolesUserConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesUserCreateFieldInput> | null | undefined;
};

export type ProfileIncomingRolesUserUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: UserUpdateInput | null | undefined;
};

export type ProfileIncomingRolesUserUpdateFieldInput = {
  connect?: Array<ProfileIncomingRolesUserConnectFieldInput> | null | undefined;
  create?: Array<ProfileIncomingRolesUserCreateFieldInput> | null | undefined;
  delete?: Array<ProfileIncomingRolesUserDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileIncomingRolesUserDisconnectFieldInput> | null | undefined;
  update?: ProfileIncomingRolesUserUpdateConnectionInput | null | undefined;
  where?: ProfileIncomingRolesUserConnectionWhere | null | undefined;
};

export type ProfileOrganizationAggregateInput = {
  AND?: Array<ProfileOrganizationAggregateInput> | null | undefined;
  NOT?: ProfileOrganizationAggregateInput | null | undefined;
  OR?: Array<ProfileOrganizationAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: ProfileOrganizationNodeAggregationWhereInput | null | undefined;
};

export type ProfileOrganizationConnectFieldInput = {
  connect?: OrganizationConnectInput | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: OrganizationConnectWhere | null | undefined;
};

export type ProfileOrganizationConnectionWhere = {
  AND?: Array<ProfileOrganizationConnectionWhere> | null | undefined;
  NOT?: ProfileOrganizationConnectionWhere | null | undefined;
  OR?: Array<ProfileOrganizationConnectionWhere> | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type ProfileOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ProfileOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: ProfileOrganizationConnectionWhere | null | undefined;
};

export type ProfileOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: ProfileOrganizationConnectionWhere | null | undefined;
};

export type ProfileOrganizationFieldInput = {
  connect?: ProfileOrganizationConnectFieldInput | null | undefined;
  create?: ProfileOrganizationCreateFieldInput | null | undefined;
};

export type ProfileOrganizationNodeAggregationWhereInput = {
  AND?: Array<ProfileOrganizationNodeAggregationWhereInput> | null | undefined;
  NOT?: ProfileOrganizationNodeAggregationWhereInput | null | undefined;
  OR?: Array<ProfileOrganizationNodeAggregationWhereInput> | null | undefined;
  address1_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address1_AVERAGE_LENGTH_GT?: number | null | undefined;
  address1_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address1_AVERAGE_LENGTH_LT?: number | null | undefined;
  address1_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address1_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address1_LONGEST_LENGTH_GT?: number | null | undefined;
  address1_LONGEST_LENGTH_GTE?: number | null | undefined;
  address1_LONGEST_LENGTH_LT?: number | null | undefined;
  address1_LONGEST_LENGTH_LTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address1_SHORTEST_LENGTH_GT?: number | null | undefined;
  address1_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address1_SHORTEST_LENGTH_LT?: number | null | undefined;
  address1_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address2_AVERAGE_LENGTH_GT?: number | null | undefined;
  address2_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address2_AVERAGE_LENGTH_LT?: number | null | undefined;
  address2_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address2_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address2_LONGEST_LENGTH_GT?: number | null | undefined;
  address2_LONGEST_LENGTH_GTE?: number | null | undefined;
  address2_LONGEST_LENGTH_LT?: number | null | undefined;
  address2_LONGEST_LENGTH_LTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address2_SHORTEST_LENGTH_GT?: number | null | undefined;
  address2_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address2_SHORTEST_LENGTH_LT?: number | null | undefined;
  address2_SHORTEST_LENGTH_LTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  address3_AVERAGE_LENGTH_GT?: number | null | undefined;
  address3_AVERAGE_LENGTH_GTE?: number | null | undefined;
  address3_AVERAGE_LENGTH_LT?: number | null | undefined;
  address3_AVERAGE_LENGTH_LTE?: number | null | undefined;
  address3_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  address3_LONGEST_LENGTH_GT?: number | null | undefined;
  address3_LONGEST_LENGTH_GTE?: number | null | undefined;
  address3_LONGEST_LENGTH_LT?: number | null | undefined;
  address3_LONGEST_LENGTH_LTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  address3_SHORTEST_LENGTH_GT?: number | null | undefined;
  address3_SHORTEST_LENGTH_GTE?: number | null | undefined;
  address3_SHORTEST_LENGTH_LT?: number | null | undefined;
  address3_SHORTEST_LENGTH_LTE?: number | null | undefined;
  city_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  city_AVERAGE_LENGTH_GT?: number | null | undefined;
  city_AVERAGE_LENGTH_GTE?: number | null | undefined;
  city_AVERAGE_LENGTH_LT?: number | null | undefined;
  city_AVERAGE_LENGTH_LTE?: number | null | undefined;
  city_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  city_LONGEST_LENGTH_GT?: number | null | undefined;
  city_LONGEST_LENGTH_GTE?: number | null | undefined;
  city_LONGEST_LENGTH_LT?: number | null | undefined;
  city_LONGEST_LENGTH_LTE?: number | null | undefined;
  city_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  city_SHORTEST_LENGTH_GT?: number | null | undefined;
  city_SHORTEST_LENGTH_GTE?: number | null | undefined;
  city_SHORTEST_LENGTH_LT?: number | null | undefined;
  city_SHORTEST_LENGTH_LTE?: number | null | undefined;
  country_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  country_AVERAGE_LENGTH_GT?: number | null | undefined;
  country_AVERAGE_LENGTH_GTE?: number | null | undefined;
  country_AVERAGE_LENGTH_LT?: number | null | undefined;
  country_AVERAGE_LENGTH_LTE?: number | null | undefined;
  country_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  country_LONGEST_LENGTH_GT?: number | null | undefined;
  country_LONGEST_LENGTH_GTE?: number | null | undefined;
  country_LONGEST_LENGTH_LT?: number | null | undefined;
  country_LONGEST_LENGTH_LTE?: number | null | undefined;
  country_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  country_SHORTEST_LENGTH_GT?: number | null | undefined;
  country_SHORTEST_LENGTH_GTE?: number | null | undefined;
  country_SHORTEST_LENGTH_LT?: number | null | undefined;
  country_SHORTEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  imprintHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  imprintHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  locale_AVERAGE_LENGTH_GT?: number | null | undefined;
  locale_AVERAGE_LENGTH_GTE?: number | null | undefined;
  locale_AVERAGE_LENGTH_LT?: number | null | undefined;
  locale_AVERAGE_LENGTH_LTE?: number | null | undefined;
  locale_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  locale_LONGEST_LENGTH_GT?: number | null | undefined;
  locale_LONGEST_LENGTH_GTE?: number | null | undefined;
  locale_LONGEST_LENGTH_LT?: number | null | undefined;
  locale_LONGEST_LENGTH_LTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  locale_SHORTEST_LENGTH_GT?: number | null | undefined;
  locale_SHORTEST_LENGTH_GTE?: number | null | undefined;
  locale_SHORTEST_LENGTH_LT?: number | null | undefined;
  locale_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  privacyHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  privacyHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  region_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  region_AVERAGE_LENGTH_GT?: number | null | undefined;
  region_AVERAGE_LENGTH_GTE?: number | null | undefined;
  region_AVERAGE_LENGTH_LT?: number | null | undefined;
  region_AVERAGE_LENGTH_LTE?: number | null | undefined;
  region_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  region_LONGEST_LENGTH_GT?: number | null | undefined;
  region_LONGEST_LENGTH_GTE?: number | null | undefined;
  region_LONGEST_LENGTH_LT?: number | null | undefined;
  region_LONGEST_LENGTH_LTE?: number | null | undefined;
  region_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  region_SHORTEST_LENGTH_GT?: number | null | undefined;
  region_SHORTEST_LENGTH_GTE?: number | null | undefined;
  region_SHORTEST_LENGTH_LT?: number | null | undefined;
  region_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartContactId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartContactId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_GTE?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LT?: number | null | undefined;
  timezone_AVERAGE_LENGTH_LTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_LONGEST_LENGTH_GT?: number | null | undefined;
  timezone_LONGEST_LENGTH_GTE?: number | null | undefined;
  timezone_LONGEST_LENGTH_LT?: number | null | undefined;
  timezone_LONGEST_LENGTH_LTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_GTE?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LT?: number | null | undefined;
  timezone_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosHtml_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LT?: number | null | undefined;
  tosHtml_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosHtml_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_GTE?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LT?: number | null | undefined;
  zipCode_AVERAGE_LENGTH_LTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_GTE?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LT?: number | null | undefined;
  zipCode_LONGEST_LENGTH_LTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_GTE?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LT?: number | null | undefined;
  zipCode_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ProfileOrganizationUpdateConnectionInput = {
  node?: OrganizationUpdateInput | null | undefined;
};

export type ProfileOrganizationUpdateFieldInput = {
  connect?: ProfileOrganizationConnectFieldInput | null | undefined;
  create?: ProfileOrganizationCreateFieldInput | null | undefined;
  delete?: ProfileOrganizationDeleteFieldInput | null | undefined;
  disconnect?: ProfileOrganizationDisconnectFieldInput | null | undefined;
  update?: ProfileOrganizationUpdateConnectionInput | null | undefined;
  where?: ProfileOrganizationConnectionWhere | null | undefined;
};

export type ProfilePropertiesAggregateInput = {
  AND?: Array<ProfilePropertiesAggregateInput> | null | undefined;
  NOT?: ProfilePropertiesAggregateInput | null | undefined;
  OR?: Array<ProfilePropertiesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: PropertiesScopeAggregationWhereInput | null | undefined;
  node?: ProfilePropertiesNodeAggregationWhereInput | null | undefined;
};

export type ProfilePropertiesConnectFieldInput = {
  connect?: Array<PropertyConnectInput> | null | undefined;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: PropertyConnectWhere | null | undefined;
};

export type ProfilePropertiesConnectionWhere = {
  AND?: Array<ProfilePropertiesConnectionWhere> | null | undefined;
  NOT?: ProfilePropertiesConnectionWhere | null | undefined;
  OR?: Array<ProfilePropertiesConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: PropertyWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: PropertyWhere | null | undefined;
};

export type ProfilePropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type ProfilePropertiesDeleteFieldInput = {
  delete?: PropertyDeleteInput | null | undefined;
  where?: ProfilePropertiesConnectionWhere | null | undefined;
};

export type ProfilePropertiesDisconnectFieldInput = {
  disconnect?: PropertyDisconnectInput | null | undefined;
  where?: ProfilePropertiesConnectionWhere | null | undefined;
};

export type ProfilePropertiesFieldInput = {
  connect?: Array<ProfilePropertiesConnectFieldInput> | null | undefined;
  create?: Array<ProfilePropertiesCreateFieldInput> | null | undefined;
};

export type ProfilePropertiesNodeAggregationWhereInput = {
  AND?: Array<ProfilePropertiesNodeAggregationWhereInput> | null | undefined;
  NOT?: ProfilePropertiesNodeAggregationWhereInput | null | undefined;
  OR?: Array<ProfilePropertiesNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  value_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  value_AVERAGE_LENGTH_GT?: number | null | undefined;
  value_AVERAGE_LENGTH_GTE?: number | null | undefined;
  value_AVERAGE_LENGTH_LT?: number | null | undefined;
  value_AVERAGE_LENGTH_LTE?: number | null | undefined;
  value_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  value_LONGEST_LENGTH_GT?: number | null | undefined;
  value_LONGEST_LENGTH_GTE?: number | null | undefined;
  value_LONGEST_LENGTH_LT?: number | null | undefined;
  value_LONGEST_LENGTH_LTE?: number | null | undefined;
  value_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  value_SHORTEST_LENGTH_GT?: number | null | undefined;
  value_SHORTEST_LENGTH_GTE?: number | null | undefined;
  value_SHORTEST_LENGTH_LT?: number | null | undefined;
  value_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ProfilePropertiesUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: PropertyUpdateInput | null | undefined;
};

export type ProfilePropertiesUpdateFieldInput = {
  connect?: Array<ProfilePropertiesConnectFieldInput> | null | undefined;
  create?: Array<ProfilePropertiesCreateFieldInput> | null | undefined;
  delete?: Array<ProfilePropertiesDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfilePropertiesDisconnectFieldInput> | null | undefined;
  update?: ProfilePropertiesUpdateConnectionInput | null | undefined;
  where?: ProfilePropertiesConnectionWhere | null | undefined;
};

export type ProfileRelationPropertiesCreateInput = {
  primary?: boolean | null | undefined;
  shadow?: boolean | null | undefined;
};

export type ProfileRelationPropertiesUpdateInput = {
  primary?: boolean | null | undefined;
  shadow?: boolean | null | undefined;
};

export type ProfileRelationPropertiesWhere = {
  AND?: Array<ProfileRelationPropertiesWhere> | null | undefined;
  NOT?: ProfileRelationPropertiesWhere | null | undefined;
  OR?: Array<ProfileRelationPropertiesWhere> | null | undefined;
  primary?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  primary_NOT?: boolean | null | undefined;
  shadow?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shadow_NOT?: boolean | null | undefined;
};

export type ProfileRolesConnectInput = {
  Group?: Array<ProfileRolesGroupConnectFieldInput> | null | undefined;
  Organization?: Array<ProfileRolesOrganizationConnectFieldInput> | null | undefined;
  Profile?: Array<ProfileRolesProfileConnectFieldInput> | null | undefined;
  User?: Array<ProfileRolesUserConnectFieldInput> | null | undefined;
};

export type ProfileRolesConnectionWhere = {
  Group?: ProfileRolesGroupConnectionWhere | null | undefined;
  Organization?: ProfileRolesOrganizationConnectionWhere | null | undefined;
  Profile?: ProfileRolesProfileConnectionWhere | null | undefined;
  User?: ProfileRolesUserConnectionWhere | null | undefined;
};

export type ProfileRolesCreateInput = {
  Group?: ProfileRolesGroupFieldInput | null | undefined;
  Organization?: ProfileRolesOrganizationFieldInput | null | undefined;
  Profile?: ProfileRolesProfileFieldInput | null | undefined;
  User?: ProfileRolesUserFieldInput | null | undefined;
};

export type ProfileRolesDeleteInput = {
  Group?: Array<ProfileRolesGroupDeleteFieldInput> | null | undefined;
  Organization?: Array<ProfileRolesOrganizationDeleteFieldInput> | null | undefined;
  Profile?: Array<ProfileRolesProfileDeleteFieldInput> | null | undefined;
  User?: Array<ProfileRolesUserDeleteFieldInput> | null | undefined;
};

export type ProfileRolesDisconnectInput = {
  Group?: Array<ProfileRolesGroupDisconnectFieldInput> | null | undefined;
  Organization?: Array<ProfileRolesOrganizationDisconnectFieldInput> | null | undefined;
  Profile?: Array<ProfileRolesProfileDisconnectFieldInput> | null | undefined;
  User?: Array<ProfileRolesUserDisconnectFieldInput> | null | undefined;
};

export type ProfileRolesGroupConnectFieldInput = {
  connect?: Array<GroupConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: GroupConnectWhere | null | undefined;
};

export type ProfileRolesGroupConnectionWhere = {
  AND?: Array<ProfileRolesGroupConnectionWhere> | null | undefined;
  NOT?: ProfileRolesGroupConnectionWhere | null | undefined;
  OR?: Array<ProfileRolesGroupConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type ProfileRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type ProfileRolesGroupDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: ProfileRolesGroupConnectionWhere | null | undefined;
};

export type ProfileRolesGroupDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: ProfileRolesGroupConnectionWhere | null | undefined;
};

export type ProfileRolesGroupFieldInput = {
  connect?: Array<ProfileRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesGroupCreateFieldInput> | null | undefined;
};

export type ProfileRolesGroupUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: GroupUpdateInput | null | undefined;
};

export type ProfileRolesGroupUpdateFieldInput = {
  connect?: Array<ProfileRolesGroupConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesGroupCreateFieldInput> | null | undefined;
  delete?: Array<ProfileRolesGroupDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileRolesGroupDisconnectFieldInput> | null | undefined;
  update?: ProfileRolesGroupUpdateConnectionInput | null | undefined;
  where?: ProfileRolesGroupConnectionWhere | null | undefined;
};

export type ProfileRolesOrganizationConnectFieldInput = {
  connect?: Array<OrganizationConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: OrganizationConnectWhere | null | undefined;
};

export type ProfileRolesOrganizationConnectionWhere = {
  AND?: Array<ProfileRolesOrganizationConnectionWhere> | null | undefined;
  NOT?: ProfileRolesOrganizationConnectionWhere | null | undefined;
  OR?: Array<ProfileRolesOrganizationConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type ProfileRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type ProfileRolesOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: ProfileRolesOrganizationConnectionWhere | null | undefined;
};

export type ProfileRolesOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: ProfileRolesOrganizationConnectionWhere | null | undefined;
};

export type ProfileRolesOrganizationFieldInput = {
  connect?: Array<ProfileRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesOrganizationCreateFieldInput> | null | undefined;
};

export type ProfileRolesOrganizationUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type ProfileRolesOrganizationUpdateFieldInput = {
  connect?: Array<ProfileRolesOrganizationConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesOrganizationCreateFieldInput> | null | undefined;
  delete?: Array<ProfileRolesOrganizationDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileRolesOrganizationDisconnectFieldInput> | null | undefined;
  update?: ProfileRolesOrganizationUpdateConnectionInput | null | undefined;
  where?: ProfileRolesOrganizationConnectionWhere | null | undefined;
};

export type ProfileRolesProfileConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: ProfileConnectWhere | null | undefined;
};

export type ProfileRolesProfileConnectionWhere = {
  AND?: Array<ProfileRolesProfileConnectionWhere> | null | undefined;
  NOT?: ProfileRolesProfileConnectionWhere | null | undefined;
  OR?: Array<ProfileRolesProfileConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type ProfileRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type ProfileRolesProfileDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: ProfileRolesProfileConnectionWhere | null | undefined;
};

export type ProfileRolesProfileDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: ProfileRolesProfileConnectionWhere | null | undefined;
};

export type ProfileRolesProfileFieldInput = {
  connect?: Array<ProfileRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesProfileCreateFieldInput> | null | undefined;
};

export type ProfileRolesProfileUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: ProfileUpdateInput | null | undefined;
};

export type ProfileRolesProfileUpdateFieldInput = {
  connect?: Array<ProfileRolesProfileConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesProfileCreateFieldInput> | null | undefined;
  delete?: Array<ProfileRolesProfileDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileRolesProfileDisconnectFieldInput> | null | undefined;
  update?: ProfileRolesProfileUpdateConnectionInput | null | undefined;
  where?: ProfileRolesProfileConnectionWhere | null | undefined;
};

export type ProfileRolesUpdateInput = {
  Group?: Array<ProfileRolesGroupUpdateFieldInput> | null | undefined;
  Organization?: Array<ProfileRolesOrganizationUpdateFieldInput> | null | undefined;
  Profile?: Array<ProfileRolesProfileUpdateFieldInput> | null | undefined;
  User?: Array<ProfileRolesUserUpdateFieldInput> | null | undefined;
};

export type ProfileRolesUserConnectFieldInput = {
  connect?: Array<UserConnectInput> | null | undefined;
  edge: RoleNamesCreateInput;
  where?: UserConnectWhere | null | undefined;
};

export type ProfileRolesUserConnectionWhere = {
  AND?: Array<ProfileRolesUserConnectionWhere> | null | undefined;
  NOT?: ProfileRolesUserConnectionWhere | null | undefined;
  OR?: Array<ProfileRolesUserConnectionWhere> | null | undefined;
  edge?: RoleNamesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: RoleNamesWhere | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type ProfileRolesUserCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: UserCreateInput;
};

export type ProfileRolesUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: ProfileRolesUserConnectionWhere | null | undefined;
};

export type ProfileRolesUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: ProfileRolesUserConnectionWhere | null | undefined;
};

export type ProfileRolesUserFieldInput = {
  connect?: Array<ProfileRolesUserConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesUserCreateFieldInput> | null | undefined;
};

export type ProfileRolesUserUpdateConnectionInput = {
  edge?: RoleNamesUpdateInput | null | undefined;
  node?: UserUpdateInput | null | undefined;
};

export type ProfileRolesUserUpdateFieldInput = {
  connect?: Array<ProfileRolesUserConnectFieldInput> | null | undefined;
  create?: Array<ProfileRolesUserCreateFieldInput> | null | undefined;
  delete?: Array<ProfileRolesUserDeleteFieldInput> | null | undefined;
  disconnect?: Array<ProfileRolesUserDisconnectFieldInput> | null | undefined;
  update?: ProfileRolesUserUpdateConnectionInput | null | undefined;
  where?: ProfileRolesUserConnectionWhere | null | undefined;
};

export type ProfileUpdateInput = {
  birthday?: string | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  firstNames?: string | null | undefined;
  groups?: Array<ProfileGroupsUpdateFieldInput> | null | undefined;
  incomingRoles?: ProfileIncomingRolesUpdateInput | null | undefined;
  lastName?: string | null | undefined;
  organization?: ProfileOrganizationUpdateFieldInput | null | undefined;
  prefixName?: string | null | undefined;
  properties?: Array<ProfilePropertiesUpdateFieldInput> | null | undefined;
  roles?: ProfileRolesUpdateInput | null | undefined;
  salutation?: string | null | undefined;
  shortName?: string | null | undefined;
  tecartPersonId?: string | null | undefined;
  title?: string | null | undefined;
  tosAccepted?: string | null | undefined;
  tosVersion?: string | null | undefined;
  user?: ProfileUserUpdateFieldInput | null | undefined;
};

export type ProfileUserAggregateInput = {
  AND?: Array<ProfileUserAggregateInput> | null | undefined;
  NOT?: ProfileUserAggregateInput | null | undefined;
  OR?: Array<ProfileUserAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: ProfileUserNodeAggregationWhereInput | null | undefined;
};

export type ProfileUserConnectFieldInput = {
  connect?: UserConnectInput | null | undefined;
  edge?: ProfileRelationPropertiesCreateInput | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: UserConnectWhere | null | undefined;
};

export type ProfileUserConnectionWhere = {
  AND?: Array<ProfileUserConnectionWhere> | null | undefined;
  NOT?: ProfileUserConnectionWhere | null | undefined;
  OR?: Array<ProfileUserConnectionWhere> | null | undefined;
  edge?: ProfileRelationPropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: ProfileRelationPropertiesWhere | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type ProfileUserCreateFieldInput = {
  edge?: ProfileRelationPropertiesCreateInput | null | undefined;
  node: UserCreateInput;
};

export type ProfileUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: ProfileUserConnectionWhere | null | undefined;
};

export type ProfileUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: ProfileUserConnectionWhere | null | undefined;
};

export type ProfileUserFieldInput = {
  connect?: ProfileUserConnectFieldInput | null | undefined;
  create?: ProfileUserCreateFieldInput | null | undefined;
};

export type ProfileUserNodeAggregationWhereInput = {
  AND?: Array<ProfileUserNodeAggregationWhereInput> | null | undefined;
  NOT?: ProfileUserNodeAggregationWhereInput | null | undefined;
  OR?: Array<ProfileUserNodeAggregationWhereInput> | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_GT?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_GTE?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_LT?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_LTE?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_GT?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_GTE?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_LT?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_LTE?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_GT?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_GTE?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_LT?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_LTE?: number | null | undefined;
  invitationOtpValidUntil_MAX_EQUAL?: string | null | undefined;
  invitationOtpValidUntil_MAX_GT?: string | null | undefined;
  invitationOtpValidUntil_MAX_GTE?: string | null | undefined;
  invitationOtpValidUntil_MAX_LT?: string | null | undefined;
  invitationOtpValidUntil_MAX_LTE?: string | null | undefined;
  invitationOtpValidUntil_MIN_EQUAL?: string | null | undefined;
  invitationOtpValidUntil_MIN_GT?: string | null | undefined;
  invitationOtpValidUntil_MIN_GTE?: string | null | undefined;
  invitationOtpValidUntil_MIN_LT?: string | null | undefined;
  invitationOtpValidUntil_MIN_LTE?: string | null | undefined;
  newEmailOtpValidUntil_MAX_EQUAL?: string | null | undefined;
  newEmailOtpValidUntil_MAX_GT?: string | null | undefined;
  newEmailOtpValidUntil_MAX_GTE?: string | null | undefined;
  newEmailOtpValidUntil_MAX_LT?: string | null | undefined;
  newEmailOtpValidUntil_MAX_LTE?: string | null | undefined;
  newEmailOtpValidUntil_MIN_EQUAL?: string | null | undefined;
  newEmailOtpValidUntil_MIN_GT?: string | null | undefined;
  newEmailOtpValidUntil_MIN_GTE?: string | null | undefined;
  newEmailOtpValidUntil_MIN_LT?: string | null | undefined;
  newEmailOtpValidUntil_MIN_LTE?: string | null | undefined;
  newEmail_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_GT?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_GTE?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_LT?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_LTE?: number | null | undefined;
  newEmail_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  newEmail_LONGEST_LENGTH_GT?: number | null | undefined;
  newEmail_LONGEST_LENGTH_GTE?: number | null | undefined;
  newEmail_LONGEST_LENGTH_LT?: number | null | undefined;
  newEmail_LONGEST_LENGTH_LTE?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_GT?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_GTE?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_LT?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_LTE?: number | null | undefined;
  passwordChangedAt_MAX_EQUAL?: string | null | undefined;
  passwordChangedAt_MAX_GT?: string | null | undefined;
  passwordChangedAt_MAX_GTE?: string | null | undefined;
  passwordChangedAt_MAX_LT?: string | null | undefined;
  passwordChangedAt_MAX_LTE?: string | null | undefined;
  passwordChangedAt_MIN_EQUAL?: string | null | undefined;
  passwordChangedAt_MIN_GT?: string | null | undefined;
  passwordChangedAt_MIN_GTE?: string | null | undefined;
  passwordChangedAt_MIN_LT?: string | null | undefined;
  passwordChangedAt_MIN_LTE?: string | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_GT?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_GTE?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_LT?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_LTE?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_GT?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_GTE?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_LT?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_LTE?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_GT?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_GTE?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_LT?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_LTE?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_GT?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_GTE?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_LT?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_LTE?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_GT?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_GTE?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_LT?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_LTE?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_GT?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_GTE?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_LT?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_LTE?: number | null | undefined;
  recoveryCodesGeneratedAt_MAX_EQUAL?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_GT?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_GTE?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_LT?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_LTE?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_EQUAL?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_GT?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_GTE?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_LT?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_LTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_EQUAL?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_GT?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_GTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_LT?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_LTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_EQUAL?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_GT?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_GTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_LT?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_LTE?: string | null | undefined;
};

export type ProfileUserUpdateConnectionInput = {
  edge?: ProfileRelationPropertiesUpdateInput | null | undefined;
  node?: UserUpdateInput | null | undefined;
};

export type ProfileUserUpdateFieldInput = {
  connect?: ProfileUserConnectFieldInput | null | undefined;
  create?: ProfileUserCreateFieldInput | null | undefined;
  delete?: ProfileUserDeleteFieldInput | null | undefined;
  disconnect?: ProfileUserDisconnectFieldInput | null | undefined;
  update?: ProfileUserUpdateConnectionInput | null | undefined;
  where?: ProfileUserConnectionWhere | null | undefined;
};

export type ProfileWhere = {
  AND?: Array<ProfileWhere> | null | undefined;
  NOT?: ProfileWhere | null | undefined;
  OR?: Array<ProfileWhere> | null | undefined;
  birthday?: string | null | undefined;
  birthday_GT?: string | null | undefined;
  birthday_GTE?: string | null | undefined;
  birthday_IN?: Array<string | null | undefined> | null | undefined;
  birthday_LT?: string | null | undefined;
  birthday_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_IN?: Array<string | null | undefined> | null | undefined;
  displayName?: string | null | undefined;
  displayNameShort?: string | null | undefined;
  displayNameShort_CONTAINS?: string | null | undefined;
  displayNameShort_ENDS_WITH?: string | null | undefined;
  displayNameShort_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_STARTS_WITH?: string | null | undefined;
  displayNameShort_STARTS_WITH?: string | null | undefined;
  displayName_CONTAINS?: string | null | undefined;
  displayName_ENDS_WITH?: string | null | undefined;
  displayName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_STARTS_WITH?: string | null | undefined;
  displayName_STARTS_WITH?: string | null | undefined;
  email?: string | null | undefined;
  email_CONTAINS?: string | null | undefined;
  email_ENDS_WITH?: string | null | undefined;
  email_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: string | null | undefined;
  email_STARTS_WITH?: string | null | undefined;
  firstName?: string | null | undefined;
  firstName_CONTAINS?: string | null | undefined;
  firstName_ENDS_WITH?: string | null | undefined;
  firstName_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_STARTS_WITH?: string | null | undefined;
  firstName_STARTS_WITH?: string | null | undefined;
  firstNames?: string | null | undefined;
  firstNames_CONTAINS?: string | null | undefined;
  firstNames_ENDS_WITH?: string | null | undefined;
  firstNames_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_STARTS_WITH?: string | null | undefined;
  firstNames_STARTS_WITH?: string | null | undefined;
  fullName?: string | null | undefined;
  fullName_CONTAINS?: string | null | undefined;
  fullName_ENDS_WITH?: string | null | undefined;
  fullName_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_STARTS_WITH?: string | null | undefined;
  fullName_STARTS_WITH?: string | null | undefined;
  grantedApplications?: ApplicationWhere | null | undefined;
  grantedApplications_ALL?: ApplicationWhere | null | undefined;
  grantedApplications_NONE?: ApplicationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grantedApplications_NOT?: ApplicationWhere | null | undefined;
  grantedApplications_SINGLE?: ApplicationWhere | null | undefined;
  grantedApplications_SOME?: ApplicationWhere | null | undefined;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: GroupWhere | null | undefined;
  groupsAggregate?: ProfileGroupsAggregateInput | null | undefined;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: ProfileGroupsConnectionWhere | null | undefined;
  /** Return Profiles where all of the related ProfileGroupsConnections match this filter */
  groupsConnection_ALL?: ProfileGroupsConnectionWhere | null | undefined;
  /** Return Profiles where none of the related ProfileGroupsConnections match this filter */
  groupsConnection_NONE?: ProfileGroupsConnectionWhere | null | undefined;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: ProfileGroupsConnectionWhere | null | undefined;
  /** Return Profiles where one of the related ProfileGroupsConnections match this filter */
  groupsConnection_SINGLE?: ProfileGroupsConnectionWhere | null | undefined;
  /** Return Profiles where some of the related ProfileGroupsConnections match this filter */
  groupsConnection_SOME?: ProfileGroupsConnectionWhere | null | undefined;
  /** Return Profiles where all of the related Groups match this filter */
  groups_ALL?: GroupWhere | null | undefined;
  /** Return Profiles where none of the related Groups match this filter */
  groups_NONE?: GroupWhere | null | undefined;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: GroupWhere | null | undefined;
  /** Return Profiles where one of the related Groups match this filter */
  groups_SINGLE?: GroupWhere | null | undefined;
  /** Return Profiles where some of the related Groups match this filter */
  groups_SOME?: GroupWhere | null | undefined;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: ProfileIncomingRolesConnectionWhere | null | undefined;
  /** Return Profiles where all of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: ProfileIncomingRolesConnectionWhere | null | undefined;
  /** Return Profiles where none of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: ProfileIncomingRolesConnectionWhere | null | undefined;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: ProfileIncomingRolesConnectionWhere | null | undefined;
  /** Return Profiles where one of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: ProfileIncomingRolesConnectionWhere | null | undefined;
  /** Return Profiles where some of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: ProfileIncomingRolesConnectionWhere | null | undefined;
  /** Return Profiles where all of the related RoleTargets match this filter */
  incomingRoles_ALL?: RoleTargetWhere | null | undefined;
  /** Return Profiles where none of the related RoleTargets match this filter */
  incomingRoles_NONE?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: RoleTargetWhere | null | undefined;
  /** Return Profiles where one of the related RoleTargets match this filter */
  incomingRoles_SINGLE?: RoleTargetWhere | null | undefined;
  /** Return Profiles where some of the related RoleTargets match this filter */
  incomingRoles_SOME?: RoleTargetWhere | null | undefined;
  lastName?: string | null | undefined;
  lastName_CONTAINS?: string | null | undefined;
  lastName_ENDS_WITH?: string | null | undefined;
  lastName_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_STARTS_WITH?: string | null | undefined;
  lastName_STARTS_WITH?: string | null | undefined;
  listName?: string | null | undefined;
  listName_CONTAINS?: string | null | undefined;
  listName_ENDS_WITH?: string | null | undefined;
  listName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_STARTS_WITH?: string | null | undefined;
  listName_STARTS_WITH?: string | null | undefined;
  organization?: OrganizationWhere | null | undefined;
  organizationAggregate?: ProfileOrganizationAggregateInput | null | undefined;
  organizationConnection?: ProfileOrganizationConnectionWhere | null | undefined;
  organizationConnection_NOT?: ProfileOrganizationConnectionWhere | null | undefined;
  organization_NOT?: OrganizationWhere | null | undefined;
  prefixName?: string | null | undefined;
  prefixName_CONTAINS?: string | null | undefined;
  prefixName_ENDS_WITH?: string | null | undefined;
  prefixName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_STARTS_WITH?: string | null | undefined;
  prefixName_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: PropertyWhere | null | undefined;
  propertiesAggregate?: ProfilePropertiesAggregateInput | null | undefined;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: ProfilePropertiesConnectionWhere | null | undefined;
  /** Return Profiles where all of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_ALL?: ProfilePropertiesConnectionWhere | null | undefined;
  /** Return Profiles where none of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_NONE?: ProfilePropertiesConnectionWhere | null | undefined;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: ProfilePropertiesConnectionWhere | null | undefined;
  /** Return Profiles where one of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_SINGLE?: ProfilePropertiesConnectionWhere | null | undefined;
  /** Return Profiles where some of the related ProfilePropertiesConnections match this filter */
  propertiesConnection_SOME?: ProfilePropertiesConnectionWhere | null | undefined;
  /** Return Profiles where all of the related Properties match this filter */
  properties_ALL?: PropertyWhere | null | undefined;
  /** Return Profiles where none of the related Properties match this filter */
  properties_NONE?: PropertyWhere | null | undefined;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: PropertyWhere | null | undefined;
  /** Return Profiles where one of the related Properties match this filter */
  properties_SINGLE?: PropertyWhere | null | undefined;
  /** Return Profiles where some of the related Properties match this filter */
  properties_SOME?: PropertyWhere | null | undefined;
  /** @deprecated Use `roles_SOME` instead. */
  roles?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `rolesConnection_SOME` instead. */
  rolesConnection?: ProfileRolesConnectionWhere | null | undefined;
  /** Return Profiles where all of the related ProfileRolesConnections match this filter */
  rolesConnection_ALL?: ProfileRolesConnectionWhere | null | undefined;
  /** Return Profiles where none of the related ProfileRolesConnections match this filter */
  rolesConnection_NONE?: ProfileRolesConnectionWhere | null | undefined;
  /** @deprecated Use `rolesConnection_NONE` instead. */
  rolesConnection_NOT?: ProfileRolesConnectionWhere | null | undefined;
  /** Return Profiles where one of the related ProfileRolesConnections match this filter */
  rolesConnection_SINGLE?: ProfileRolesConnectionWhere | null | undefined;
  /** Return Profiles where some of the related ProfileRolesConnections match this filter */
  rolesConnection_SOME?: ProfileRolesConnectionWhere | null | undefined;
  /** Return Profiles where all of the related RoleTargets match this filter */
  roles_ALL?: RoleTargetWhere | null | undefined;
  /** Return Profiles where none of the related RoleTargets match this filter */
  roles_NONE?: RoleTargetWhere | null | undefined;
  /** @deprecated Use `roles_NONE` instead. */
  roles_NOT?: RoleTargetWhere | null | undefined;
  /** Return Profiles where one of the related RoleTargets match this filter */
  roles_SINGLE?: RoleTargetWhere | null | undefined;
  /** Return Profiles where some of the related RoleTargets match this filter */
  roles_SOME?: RoleTargetWhere | null | undefined;
  salutation?: string | null | undefined;
  salutation_CONTAINS?: string | null | undefined;
  salutation_ENDS_WITH?: string | null | undefined;
  salutation_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_STARTS_WITH?: string | null | undefined;
  salutation_STARTS_WITH?: string | null | undefined;
  selectName?: string | null | undefined;
  selectName_CONTAINS?: string | null | undefined;
  selectName_ENDS_WITH?: string | null | undefined;
  selectName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_STARTS_WITH?: string | null | undefined;
  selectName_STARTS_WITH?: string | null | undefined;
  shortName?: string | null | undefined;
  shortName_CONTAINS?: string | null | undefined;
  shortName_ENDS_WITH?: string | null | undefined;
  shortName_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: string | null | undefined;
  shortName_STARTS_WITH?: string | null | undefined;
  tecartPersonId?: string | null | undefined;
  tecartPersonId_CONTAINS?: string | null | undefined;
  tecartPersonId_ENDS_WITH?: string | null | undefined;
  tecartPersonId_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tecartPersonId_NOT_STARTS_WITH?: string | null | undefined;
  tecartPersonId_STARTS_WITH?: string | null | undefined;
  title?: string | null | undefined;
  title_CONTAINS?: string | null | undefined;
  title_ENDS_WITH?: string | null | undefined;
  title_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: string | null | undefined;
  title_STARTS_WITH?: string | null | undefined;
  tosAccepted?: string | null | undefined;
  tosAccepted_GT?: string | null | undefined;
  tosAccepted_GTE?: string | null | undefined;
  tosAccepted_IN?: Array<string | null | undefined> | null | undefined;
  tosAccepted_LT?: string | null | undefined;
  tosAccepted_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosAccepted_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosAccepted_NOT_IN?: Array<string | null | undefined> | null | undefined;
  tosVersion?: string | null | undefined;
  tosVersion_CONTAINS?: string | null | undefined;
  tosVersion_ENDS_WITH?: string | null | undefined;
  tosVersion_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tosVersion_NOT_STARTS_WITH?: string | null | undefined;
  tosVersion_STARTS_WITH?: string | null | undefined;
  user?: UserWhere | null | undefined;
  userAggregate?: ProfileUserAggregateInput | null | undefined;
  userConnection?: ProfileUserConnectionWhere | null | undefined;
  userConnection_NOT?: ProfileUserConnectionWhere | null | undefined;
  user_NOT?: UserWhere | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
};

export type PropertiesScopeAggregationWhereInput = {
  AND?: Array<PropertiesScopeAggregationWhereInput> | null | undefined;
  NOT?: PropertiesScopeAggregationWhereInput | null | undefined;
  OR?: Array<PropertiesScopeAggregationWhereInput> | null | undefined;
  scope_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  scope_AVERAGE_LENGTH_GT?: number | null | undefined;
  scope_AVERAGE_LENGTH_GTE?: number | null | undefined;
  scope_AVERAGE_LENGTH_LT?: number | null | undefined;
  scope_AVERAGE_LENGTH_LTE?: number | null | undefined;
  scope_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  scope_LONGEST_LENGTH_GT?: number | null | undefined;
  scope_LONGEST_LENGTH_GTE?: number | null | undefined;
  scope_LONGEST_LENGTH_LT?: number | null | undefined;
  scope_LONGEST_LENGTH_LTE?: number | null | undefined;
  scope_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  scope_SHORTEST_LENGTH_GT?: number | null | undefined;
  scope_SHORTEST_LENGTH_GTE?: number | null | undefined;
  scope_SHORTEST_LENGTH_LT?: number | null | undefined;
  scope_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type PropertiesScopeCreateInput = {
  scope: string;
};

export type PropertiesScopeUpdateInput = {
  scope?: string | null | undefined;
};

export type PropertiesScopeWhere = {
  AND?: Array<PropertiesScopeWhere> | null | undefined;
  NOT?: PropertiesScopeWhere | null | undefined;
  OR?: Array<PropertiesScopeWhere> | null | undefined;
  scope?: string | null | undefined;
  scope_CONTAINS?: string | null | undefined;
  scope_ENDS_WITH?: string | null | undefined;
  scope_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scope_NOT_STARTS_WITH?: string | null | undefined;
  scope_STARTS_WITH?: string | null | undefined;
};

export type PropertiesSubjectWhere = {
  Group?: GroupWhere | null | undefined;
  Organization?: OrganizationWhere | null | undefined;
  Profile?: ProfileWhere | null | undefined;
  User?: UserWhere | null | undefined;
};

export type PropertyConnectInput = {
  subject?: PropertySubjectConnectInput | null | undefined;
};

export type PropertyConnectWhere = {
  node: PropertyWhere;
};

export type PropertyCreateInput = {
  name: string;
  subject?: PropertySubjectCreateInput | null | undefined;
  value: string;
};

export type PropertyDeleteInput = {
  subject?: PropertySubjectDeleteInput | null | undefined;
};

export type PropertyDisconnectInput = {
  subject?: PropertySubjectDisconnectInput | null | undefined;
};

export type PropertySubjectConnectInput = {
  Group?: PropertySubjectGroupConnectFieldInput | null | undefined;
  Organization?: PropertySubjectOrganizationConnectFieldInput | null | undefined;
  Profile?: PropertySubjectProfileConnectFieldInput | null | undefined;
  User?: PropertySubjectUserConnectFieldInput | null | undefined;
};

export type PropertySubjectConnectionWhere = {
  Group?: PropertySubjectGroupConnectionWhere | null | undefined;
  Organization?: PropertySubjectOrganizationConnectionWhere | null | undefined;
  Profile?: PropertySubjectProfileConnectionWhere | null | undefined;
  User?: PropertySubjectUserConnectionWhere | null | undefined;
};

export type PropertySubjectCreateInput = {
  Group?: PropertySubjectGroupFieldInput | null | undefined;
  Organization?: PropertySubjectOrganizationFieldInput | null | undefined;
  Profile?: PropertySubjectProfileFieldInput | null | undefined;
  User?: PropertySubjectUserFieldInput | null | undefined;
};

export type PropertySubjectDeleteInput = {
  Group?: PropertySubjectGroupDeleteFieldInput | null | undefined;
  Organization?: PropertySubjectOrganizationDeleteFieldInput | null | undefined;
  Profile?: PropertySubjectProfileDeleteFieldInput | null | undefined;
  User?: PropertySubjectUserDeleteFieldInput | null | undefined;
};

export type PropertySubjectDisconnectInput = {
  Group?: PropertySubjectGroupDisconnectFieldInput | null | undefined;
  Organization?: PropertySubjectOrganizationDisconnectFieldInput | null | undefined;
  Profile?: PropertySubjectProfileDisconnectFieldInput | null | undefined;
  User?: PropertySubjectUserDisconnectFieldInput | null | undefined;
};

export type PropertySubjectGroupConnectFieldInput = {
  connect?: GroupConnectInput | null | undefined;
  edge: PropertiesScopeCreateInput;
  where?: GroupConnectWhere | null | undefined;
};

export type PropertySubjectGroupConnectionWhere = {
  AND?: Array<PropertySubjectGroupConnectionWhere> | null | undefined;
  NOT?: PropertySubjectGroupConnectionWhere | null | undefined;
  OR?: Array<PropertySubjectGroupConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: GroupWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: GroupWhere | null | undefined;
};

export type PropertySubjectGroupCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: GroupCreateInput;
};

export type PropertySubjectGroupDeleteFieldInput = {
  delete?: GroupDeleteInput | null | undefined;
  where?: PropertySubjectGroupConnectionWhere | null | undefined;
};

export type PropertySubjectGroupDisconnectFieldInput = {
  disconnect?: GroupDisconnectInput | null | undefined;
  where?: PropertySubjectGroupConnectionWhere | null | undefined;
};

export type PropertySubjectGroupFieldInput = {
  connect?: PropertySubjectGroupConnectFieldInput | null | undefined;
  create?: PropertySubjectGroupCreateFieldInput | null | undefined;
};

export type PropertySubjectGroupUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: GroupUpdateInput | null | undefined;
};

export type PropertySubjectGroupUpdateFieldInput = {
  connect?: PropertySubjectGroupConnectFieldInput | null | undefined;
  create?: PropertySubjectGroupCreateFieldInput | null | undefined;
  delete?: PropertySubjectGroupDeleteFieldInput | null | undefined;
  disconnect?: PropertySubjectGroupDisconnectFieldInput | null | undefined;
  update?: PropertySubjectGroupUpdateConnectionInput | null | undefined;
  where?: PropertySubjectGroupConnectionWhere | null | undefined;
};

export type PropertySubjectOrganizationConnectFieldInput = {
  connect?: OrganizationConnectInput | null | undefined;
  edge: PropertiesScopeCreateInput;
  where?: OrganizationConnectWhere | null | undefined;
};

export type PropertySubjectOrganizationConnectionWhere = {
  AND?: Array<PropertySubjectOrganizationConnectionWhere> | null | undefined;
  NOT?: PropertySubjectOrganizationConnectionWhere | null | undefined;
  OR?: Array<PropertySubjectOrganizationConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: OrganizationWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: OrganizationWhere | null | undefined;
};

export type PropertySubjectOrganizationCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: OrganizationCreateInput;
};

export type PropertySubjectOrganizationDeleteFieldInput = {
  delete?: OrganizationDeleteInput | null | undefined;
  where?: PropertySubjectOrganizationConnectionWhere | null | undefined;
};

export type PropertySubjectOrganizationDisconnectFieldInput = {
  disconnect?: OrganizationDisconnectInput | null | undefined;
  where?: PropertySubjectOrganizationConnectionWhere | null | undefined;
};

export type PropertySubjectOrganizationFieldInput = {
  connect?: PropertySubjectOrganizationConnectFieldInput | null | undefined;
  create?: PropertySubjectOrganizationCreateFieldInput | null | undefined;
};

export type PropertySubjectOrganizationUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: OrganizationUpdateInput | null | undefined;
};

export type PropertySubjectOrganizationUpdateFieldInput = {
  connect?: PropertySubjectOrganizationConnectFieldInput | null | undefined;
  create?: PropertySubjectOrganizationCreateFieldInput | null | undefined;
  delete?: PropertySubjectOrganizationDeleteFieldInput | null | undefined;
  disconnect?: PropertySubjectOrganizationDisconnectFieldInput | null | undefined;
  update?: PropertySubjectOrganizationUpdateConnectionInput | null | undefined;
  where?: PropertySubjectOrganizationConnectionWhere | null | undefined;
};

export type PropertySubjectProfileConnectFieldInput = {
  connect?: ProfileConnectInput | null | undefined;
  edge: PropertiesScopeCreateInput;
  where?: ProfileConnectWhere | null | undefined;
};

export type PropertySubjectProfileConnectionWhere = {
  AND?: Array<PropertySubjectProfileConnectionWhere> | null | undefined;
  NOT?: PropertySubjectProfileConnectionWhere | null | undefined;
  OR?: Array<PropertySubjectProfileConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type PropertySubjectProfileCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: ProfileCreateInput;
};

export type PropertySubjectProfileDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: PropertySubjectProfileConnectionWhere | null | undefined;
};

export type PropertySubjectProfileDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: PropertySubjectProfileConnectionWhere | null | undefined;
};

export type PropertySubjectProfileFieldInput = {
  connect?: PropertySubjectProfileConnectFieldInput | null | undefined;
  create?: PropertySubjectProfileCreateFieldInput | null | undefined;
};

export type PropertySubjectProfileUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: ProfileUpdateInput | null | undefined;
};

export type PropertySubjectProfileUpdateFieldInput = {
  connect?: PropertySubjectProfileConnectFieldInput | null | undefined;
  create?: PropertySubjectProfileCreateFieldInput | null | undefined;
  delete?: PropertySubjectProfileDeleteFieldInput | null | undefined;
  disconnect?: PropertySubjectProfileDisconnectFieldInput | null | undefined;
  update?: PropertySubjectProfileUpdateConnectionInput | null | undefined;
  where?: PropertySubjectProfileConnectionWhere | null | undefined;
};

export type PropertySubjectUpdateInput = {
  Group?: PropertySubjectGroupUpdateFieldInput | null | undefined;
  Organization?: PropertySubjectOrganizationUpdateFieldInput | null | undefined;
  Profile?: PropertySubjectProfileUpdateFieldInput | null | undefined;
  User?: PropertySubjectUserUpdateFieldInput | null | undefined;
};

export type PropertySubjectUserConnectFieldInput = {
  connect?: UserConnectInput | null | undefined;
  edge: PropertiesScopeCreateInput;
  where?: UserConnectWhere | null | undefined;
};

export type PropertySubjectUserConnectionWhere = {
  AND?: Array<PropertySubjectUserConnectionWhere> | null | undefined;
  NOT?: PropertySubjectUserConnectionWhere | null | undefined;
  OR?: Array<PropertySubjectUserConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type PropertySubjectUserCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: UserCreateInput;
};

export type PropertySubjectUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: PropertySubjectUserConnectionWhere | null | undefined;
};

export type PropertySubjectUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: PropertySubjectUserConnectionWhere | null | undefined;
};

export type PropertySubjectUserFieldInput = {
  connect?: PropertySubjectUserConnectFieldInput | null | undefined;
  create?: PropertySubjectUserCreateFieldInput | null | undefined;
};

export type PropertySubjectUserUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: UserUpdateInput | null | undefined;
};

export type PropertySubjectUserUpdateFieldInput = {
  connect?: PropertySubjectUserConnectFieldInput | null | undefined;
  create?: PropertySubjectUserCreateFieldInput | null | undefined;
  delete?: PropertySubjectUserDeleteFieldInput | null | undefined;
  disconnect?: PropertySubjectUserDisconnectFieldInput | null | undefined;
  update?: PropertySubjectUserUpdateConnectionInput | null | undefined;
  where?: PropertySubjectUserConnectionWhere | null | undefined;
};

export type PropertyUpdateInput = {
  name?: string | null | undefined;
  subject?: PropertySubjectUpdateInput | null | undefined;
  value?: string | null | undefined;
};

export type PropertyWhere = {
  AND?: Array<PropertyWhere> | null | undefined;
  NOT?: PropertyWhere | null | undefined;
  OR?: Array<PropertyWhere> | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  subject?: PropertiesSubjectWhere | null | undefined;
  subjectConnection?: PropertySubjectConnectionWhere | null | undefined;
  subjectConnection_NOT?: PropertySubjectConnectionWhere | null | undefined;
  subject_NOT?: PropertiesSubjectWhere | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
  value?: string | null | undefined;
  value_CONTAINS?: string | null | undefined;
  value_ENDS_WITH?: string | null | undefined;
  value_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_STARTS_WITH?: string | null | undefined;
  value_STARTS_WITH?: string | null | undefined;
};

export type RoleNamesCreateInput = {
  names: Array<string>;
};

export type RoleNamesUpdateInput = {
  names?: Array<string> | null | undefined;
  names_POP?: number | null | undefined;
  names_PUSH?: Array<string> | null | undefined;
};

export type RoleNamesWhere = {
  AND?: Array<RoleNamesWhere> | null | undefined;
  NOT?: RoleNamesWhere | null | undefined;
  OR?: Array<RoleNamesWhere> | null | undefined;
  names?: Array<string> | null | undefined;
  names_INCLUDES?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  names_NOT?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  names_NOT_INCLUDES?: string | null | undefined;
};

export type RoleTargetWhere = {
  Group?: GroupWhere | null | undefined;
  Organization?: OrganizationWhere | null | undefined;
  Profile?: ProfileWhere | null | undefined;
  User?: UserWhere | null | undefined;
};

export type ShadowRelationPropertiesAggregationWhereInput = {
  AND?: Array<ShadowRelationPropertiesAggregationWhereInput> | null | undefined;
  NOT?: ShadowRelationPropertiesAggregationWhereInput | null | undefined;
  OR?: Array<ShadowRelationPropertiesAggregationWhereInput> | null | undefined;
  conditions_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  conditions_AVERAGE_LENGTH_GT?: number | null | undefined;
  conditions_AVERAGE_LENGTH_GTE?: number | null | undefined;
  conditions_AVERAGE_LENGTH_LT?: number | null | undefined;
  conditions_AVERAGE_LENGTH_LTE?: number | null | undefined;
  conditions_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  conditions_LONGEST_LENGTH_GT?: number | null | undefined;
  conditions_LONGEST_LENGTH_GTE?: number | null | undefined;
  conditions_LONGEST_LENGTH_LT?: number | null | undefined;
  conditions_LONGEST_LENGTH_LTE?: number | null | undefined;
  conditions_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  conditions_SHORTEST_LENGTH_GT?: number | null | undefined;
  conditions_SHORTEST_LENGTH_GTE?: number | null | undefined;
  conditions_SHORTEST_LENGTH_LT?: number | null | undefined;
  conditions_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type ShadowRelationPropertiesCreateInput = {
  conditions: string;
  optIn: boolean;
};

export type ShadowRelationPropertiesUpdateInput = {
  conditions?: string | null | undefined;
  optIn?: boolean | null | undefined;
};

export type ShadowRelationPropertiesWhere = {
  AND?: Array<ShadowRelationPropertiesWhere> | null | undefined;
  NOT?: ShadowRelationPropertiesWhere | null | undefined;
  OR?: Array<ShadowRelationPropertiesWhere> | null | undefined;
  conditions?: string | null | undefined;
  conditions_CONTAINS?: string | null | undefined;
  conditions_ENDS_WITH?: string | null | undefined;
  conditions_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conditions_NOT_STARTS_WITH?: string | null | undefined;
  conditions_STARTS_WITH?: string | null | undefined;
  optIn?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  optIn_NOT?: boolean | null | undefined;
};

/** An enum for sorting in either ascending or descending order. */
export type SortDirection =
  /** Sort by field values in ascending order. */
  | "ASC"
  /** Sort by field values in descending order. */
  | "DESC";

export type TwoFactorMethodConnectInput = {
  user?: TwoFactorMethodUserConnectFieldInput | null | undefined;
};

export type TwoFactorMethodConnectWhere = {
  node: TwoFactorMethodWhere;
};

export type TwoFactorMethodCreateInput = {
  name: string;
  type: TwoFactorMethodType;
  user?: TwoFactorMethodUserFieldInput | null | undefined;
};

export type TwoFactorMethodDeleteInput = {
  user?: TwoFactorMethodUserDeleteFieldInput | null | undefined;
};

export type TwoFactorMethodDisconnectInput = {
  user?: TwoFactorMethodUserDisconnectFieldInput | null | undefined;
};

export type TwoFactorMethodType = "TOTP";

export type TwoFactorMethodUpdateInput = {
  name?: string | null | undefined;
  type?: TwoFactorMethodType | null | undefined;
  user?: TwoFactorMethodUserUpdateFieldInput | null | undefined;
};

export type TwoFactorMethodUserAggregateInput = {
  AND?: Array<TwoFactorMethodUserAggregateInput> | null | undefined;
  NOT?: TwoFactorMethodUserAggregateInput | null | undefined;
  OR?: Array<TwoFactorMethodUserAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: TwoFactorMethodUserNodeAggregationWhereInput | null | undefined;
};

export type TwoFactorMethodUserConnectFieldInput = {
  connect?: UserConnectInput | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: UserConnectWhere | null | undefined;
};

export type TwoFactorMethodUserConnectionWhere = {
  AND?: Array<TwoFactorMethodUserConnectionWhere> | null | undefined;
  NOT?: TwoFactorMethodUserConnectionWhere | null | undefined;
  OR?: Array<TwoFactorMethodUserConnectionWhere> | null | undefined;
  node?: UserWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: UserWhere | null | undefined;
};

export type TwoFactorMethodUserCreateFieldInput = {
  node: UserCreateInput;
};

export type TwoFactorMethodUserDeleteFieldInput = {
  delete?: UserDeleteInput | null | undefined;
  where?: TwoFactorMethodUserConnectionWhere | null | undefined;
};

export type TwoFactorMethodUserDisconnectFieldInput = {
  disconnect?: UserDisconnectInput | null | undefined;
  where?: TwoFactorMethodUserConnectionWhere | null | undefined;
};

export type TwoFactorMethodUserFieldInput = {
  connect?: TwoFactorMethodUserConnectFieldInput | null | undefined;
  create?: TwoFactorMethodUserCreateFieldInput | null | undefined;
};

export type TwoFactorMethodUserNodeAggregationWhereInput = {
  AND?: Array<TwoFactorMethodUserNodeAggregationWhereInput> | null | undefined;
  NOT?: TwoFactorMethodUserNodeAggregationWhereInput | null | undefined;
  OR?: Array<TwoFactorMethodUserNodeAggregationWhereInput> | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_GT?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_GTE?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_LT?: number | null | undefined;
  invitationFrontendUrl_AVERAGE_LENGTH_LTE?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_GT?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_GTE?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_LT?: number | null | undefined;
  invitationFrontendUrl_LONGEST_LENGTH_LTE?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_GT?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_GTE?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_LT?: number | null | undefined;
  invitationFrontendUrl_SHORTEST_LENGTH_LTE?: number | null | undefined;
  invitationOtpValidUntil_MAX_EQUAL?: string | null | undefined;
  invitationOtpValidUntil_MAX_GT?: string | null | undefined;
  invitationOtpValidUntil_MAX_GTE?: string | null | undefined;
  invitationOtpValidUntil_MAX_LT?: string | null | undefined;
  invitationOtpValidUntil_MAX_LTE?: string | null | undefined;
  invitationOtpValidUntil_MIN_EQUAL?: string | null | undefined;
  invitationOtpValidUntil_MIN_GT?: string | null | undefined;
  invitationOtpValidUntil_MIN_GTE?: string | null | undefined;
  invitationOtpValidUntil_MIN_LT?: string | null | undefined;
  invitationOtpValidUntil_MIN_LTE?: string | null | undefined;
  newEmailOtpValidUntil_MAX_EQUAL?: string | null | undefined;
  newEmailOtpValidUntil_MAX_GT?: string | null | undefined;
  newEmailOtpValidUntil_MAX_GTE?: string | null | undefined;
  newEmailOtpValidUntil_MAX_LT?: string | null | undefined;
  newEmailOtpValidUntil_MAX_LTE?: string | null | undefined;
  newEmailOtpValidUntil_MIN_EQUAL?: string | null | undefined;
  newEmailOtpValidUntil_MIN_GT?: string | null | undefined;
  newEmailOtpValidUntil_MIN_GTE?: string | null | undefined;
  newEmailOtpValidUntil_MIN_LT?: string | null | undefined;
  newEmailOtpValidUntil_MIN_LTE?: string | null | undefined;
  newEmail_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_GT?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_GTE?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_LT?: number | null | undefined;
  newEmail_AVERAGE_LENGTH_LTE?: number | null | undefined;
  newEmail_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  newEmail_LONGEST_LENGTH_GT?: number | null | undefined;
  newEmail_LONGEST_LENGTH_GTE?: number | null | undefined;
  newEmail_LONGEST_LENGTH_LT?: number | null | undefined;
  newEmail_LONGEST_LENGTH_LTE?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_GT?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_GTE?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_LT?: number | null | undefined;
  newEmail_SHORTEST_LENGTH_LTE?: number | null | undefined;
  passwordChangedAt_MAX_EQUAL?: string | null | undefined;
  passwordChangedAt_MAX_GT?: string | null | undefined;
  passwordChangedAt_MAX_GTE?: string | null | undefined;
  passwordChangedAt_MAX_LT?: string | null | undefined;
  passwordChangedAt_MAX_LTE?: string | null | undefined;
  passwordChangedAt_MIN_EQUAL?: string | null | undefined;
  passwordChangedAt_MIN_GT?: string | null | undefined;
  passwordChangedAt_MIN_GTE?: string | null | undefined;
  passwordChangedAt_MIN_LT?: string | null | undefined;
  passwordChangedAt_MIN_LTE?: string | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_GT?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_GTE?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_LT?: number | null | undefined;
  preferredLanguage_AVERAGE_LENGTH_LTE?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_GT?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_GTE?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_LT?: number | null | undefined;
  preferredLanguage_LONGEST_LENGTH_LTE?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_GT?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_GTE?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_LT?: number | null | undefined;
  preferredLanguage_SHORTEST_LENGTH_LTE?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_GT?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_GTE?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_LT?: number | null | undefined;
  preferredTheme_AVERAGE_LENGTH_LTE?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_GT?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_GTE?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_LT?: number | null | undefined;
  preferredTheme_LONGEST_LENGTH_LTE?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_GT?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_GTE?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_LT?: number | null | undefined;
  preferredTheme_SHORTEST_LENGTH_LTE?: number | null | undefined;
  recoveryCodesGeneratedAt_MAX_EQUAL?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_GT?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_GTE?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_LT?: string | null | undefined;
  recoveryCodesGeneratedAt_MAX_LTE?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_EQUAL?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_GT?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_GTE?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_LT?: string | null | undefined;
  recoveryCodesGeneratedAt_MIN_LTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_EQUAL?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_GT?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_GTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_LT?: string | null | undefined;
  resetPasswordOtpValidUntil_MAX_LTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_EQUAL?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_GT?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_GTE?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_LT?: string | null | undefined;
  resetPasswordOtpValidUntil_MIN_LTE?: string | null | undefined;
};

export type TwoFactorMethodUserUpdateConnectionInput = {
  node?: UserUpdateInput | null | undefined;
};

export type TwoFactorMethodUserUpdateFieldInput = {
  connect?: TwoFactorMethodUserConnectFieldInput | null | undefined;
  create?: TwoFactorMethodUserCreateFieldInput | null | undefined;
  delete?: TwoFactorMethodUserDeleteFieldInput | null | undefined;
  disconnect?: TwoFactorMethodUserDisconnectFieldInput | null | undefined;
  update?: TwoFactorMethodUserUpdateConnectionInput | null | undefined;
  where?: TwoFactorMethodUserConnectionWhere | null | undefined;
};

export type TwoFactorMethodWhere = {
  AND?: Array<TwoFactorMethodWhere> | null | undefined;
  NOT?: TwoFactorMethodWhere | null | undefined;
  OR?: Array<TwoFactorMethodWhere> | null | undefined;
  name?: string | null | undefined;
  name_CONTAINS?: string | null | undefined;
  name_ENDS_WITH?: string | null | undefined;
  name_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: string | null | undefined;
  name_STARTS_WITH?: string | null | undefined;
  type?: TwoFactorMethodType | null | undefined;
  type_IN?: Array<TwoFactorMethodType> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: TwoFactorMethodType | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: Array<TwoFactorMethodType> | null | undefined;
  user?: UserWhere | null | undefined;
  userAggregate?: TwoFactorMethodUserAggregateInput | null | undefined;
  userConnection?: TwoFactorMethodUserConnectionWhere | null | undefined;
  userConnection_NOT?: TwoFactorMethodUserConnectionWhere | null | undefined;
  user_NOT?: UserWhere | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
};

export type UserConnectInput = {
  federatedClient?: Array<UserFederatedClientConnectFieldInput> | null | undefined;
  profiles?: Array<UserProfilesConnectFieldInput> | null | undefined;
  properties?: Array<UserPropertiesConnectFieldInput> | null | undefined;
  twoFactorMethods?: Array<UserTwoFactorMethodsConnectFieldInput> | null | undefined;
};

export type UserConnectWhere = {
  node: UserWhere;
};

export type UserCreateInput = {
  email: string;
  emailVerified: boolean;
  federatedClient?: UserFederatedClientFieldInput | null | undefined;
  impersonateOnly?: boolean | null | undefined;
  invitationFrontendUrl?: string | null | undefined;
  invitationOtpValidUntil?: string | null | undefined;
  newEmail?: string | null | undefined;
  newEmailOtpValidUntil?: string | null | undefined;
  passwordChangedAt?: string | null | undefined;
  preferredLanguage?: string | null | undefined;
  preferredTheme?: string | null | undefined;
  profiles?: UserProfilesFieldInput | null | undefined;
  properties?: UserPropertiesFieldInput | null | undefined;
  recoveryCodesGeneratedAt?: string | null | undefined;
  resetPasswordOtpValidUntil?: string | null | undefined;
  twoFactorMethods?: UserTwoFactorMethodsFieldInput | null | undefined;
};

export type UserDeleteInput = {
  federatedClient?: Array<UserFederatedClientDeleteFieldInput> | null | undefined;
  profiles?: Array<UserProfilesDeleteFieldInput> | null | undefined;
  properties?: Array<UserPropertiesDeleteFieldInput> | null | undefined;
  twoFactorMethods?: Array<UserTwoFactorMethodsDeleteFieldInput> | null | undefined;
};

export type UserDisconnectInput = {
  federatedClient?: Array<UserFederatedClientDisconnectFieldInput> | null | undefined;
  profiles?: Array<UserProfilesDisconnectFieldInput> | null | undefined;
  properties?: Array<UserPropertiesDisconnectFieldInput> | null | undefined;
  twoFactorMethods?: Array<UserTwoFactorMethodsDisconnectFieldInput> | null | undefined;
};

export type UserFederatedClientAggregateInput = {
  AND?: Array<UserFederatedClientAggregateInput> | null | undefined;
  NOT?: UserFederatedClientAggregateInput | null | undefined;
  OR?: Array<UserFederatedClientAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: FederatedClientPropertiesAggregationWhereInput | null | undefined;
  node?: UserFederatedClientNodeAggregationWhereInput | null | undefined;
};

export type UserFederatedClientConnectFieldInput = {
  edge: FederatedClientPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: FederatedClientConnectWhere | null | undefined;
};

export type UserFederatedClientConnectionWhere = {
  AND?: Array<UserFederatedClientConnectionWhere> | null | undefined;
  NOT?: UserFederatedClientConnectionWhere | null | undefined;
  OR?: Array<UserFederatedClientConnectionWhere> | null | undefined;
  edge?: FederatedClientPropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: FederatedClientPropertiesWhere | null | undefined;
  node?: FederatedClientWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: FederatedClientWhere | null | undefined;
};

export type UserFederatedClientCreateFieldInput = {
  edge: FederatedClientPropertiesCreateInput;
  node: FederatedClientCreateInput;
};

export type UserFederatedClientDeleteFieldInput = {
  where?: UserFederatedClientConnectionWhere | null | undefined;
};

export type UserFederatedClientDisconnectFieldInput = {
  where?: UserFederatedClientConnectionWhere | null | undefined;
};

export type UserFederatedClientFieldInput = {
  connect?: Array<UserFederatedClientConnectFieldInput> | null | undefined;
  create?: Array<UserFederatedClientCreateFieldInput> | null | undefined;
};

export type UserFederatedClientNodeAggregationWhereInput = {
  AND?: Array<UserFederatedClientNodeAggregationWhereInput> | null | undefined;
  NOT?: UserFederatedClientNodeAggregationWhereInput | null | undefined;
  OR?: Array<UserFederatedClientNodeAggregationWhereInput> | null | undefined;
  clientId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  clientId_AVERAGE_LENGTH_GT?: number | null | undefined;
  clientId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  clientId_AVERAGE_LENGTH_LT?: number | null | undefined;
  clientId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  clientId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  clientId_LONGEST_LENGTH_GT?: number | null | undefined;
  clientId_LONGEST_LENGTH_GTE?: number | null | undefined;
  clientId_LONGEST_LENGTH_LT?: number | null | undefined;
  clientId_LONGEST_LENGTH_LTE?: number | null | undefined;
  clientId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  clientId_SHORTEST_LENGTH_GT?: number | null | undefined;
  clientId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  clientId_SHORTEST_LENGTH_LT?: number | null | undefined;
  clientId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_GT?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_GTE?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_LT?: number | null | undefined;
  clientSecret_AVERAGE_LENGTH_LTE?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_GT?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_GTE?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_LT?: number | null | undefined;
  clientSecret_LONGEST_LENGTH_LTE?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_GT?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_GTE?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_LT?: number | null | undefined;
  clientSecret_SHORTEST_LENGTH_LTE?: number | null | undefined;
  issuer_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  issuer_AVERAGE_LENGTH_GT?: number | null | undefined;
  issuer_AVERAGE_LENGTH_GTE?: number | null | undefined;
  issuer_AVERAGE_LENGTH_LT?: number | null | undefined;
  issuer_AVERAGE_LENGTH_LTE?: number | null | undefined;
  issuer_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  issuer_LONGEST_LENGTH_GT?: number | null | undefined;
  issuer_LONGEST_LENGTH_GTE?: number | null | undefined;
  issuer_LONGEST_LENGTH_LT?: number | null | undefined;
  issuer_LONGEST_LENGTH_LTE?: number | null | undefined;
  issuer_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  issuer_SHORTEST_LENGTH_GT?: number | null | undefined;
  issuer_SHORTEST_LENGTH_GTE?: number | null | undefined;
  issuer_SHORTEST_LENGTH_LT?: number | null | undefined;
  issuer_SHORTEST_LENGTH_LTE?: number | null | undefined;
  label_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  label_AVERAGE_LENGTH_GT?: number | null | undefined;
  label_AVERAGE_LENGTH_GTE?: number | null | undefined;
  label_AVERAGE_LENGTH_LT?: number | null | undefined;
  label_AVERAGE_LENGTH_LTE?: number | null | undefined;
  label_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  label_LONGEST_LENGTH_GT?: number | null | undefined;
  label_LONGEST_LENGTH_GTE?: number | null | undefined;
  label_LONGEST_LENGTH_LT?: number | null | undefined;
  label_LONGEST_LENGTH_LTE?: number | null | undefined;
  label_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  label_SHORTEST_LENGTH_GT?: number | null | undefined;
  label_SHORTEST_LENGTH_GTE?: number | null | undefined;
  label_SHORTEST_LENGTH_LT?: number | null | undefined;
  label_SHORTEST_LENGTH_LTE?: number | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type UserFederatedClientUpdateConnectionInput = {
  edge?: FederatedClientPropertiesUpdateInput | null | undefined;
  node?: FederatedClientUpdateInput | null | undefined;
};

export type UserFederatedClientUpdateFieldInput = {
  connect?: Array<UserFederatedClientConnectFieldInput> | null | undefined;
  create?: Array<UserFederatedClientCreateFieldInput> | null | undefined;
  delete?: Array<UserFederatedClientDeleteFieldInput> | null | undefined;
  disconnect?: Array<UserFederatedClientDisconnectFieldInput> | null | undefined;
  update?: UserFederatedClientUpdateConnectionInput | null | undefined;
  where?: UserFederatedClientConnectionWhere | null | undefined;
};

export type UserProfilesAggregateInput = {
  AND?: Array<UserProfilesAggregateInput> | null | undefined;
  NOT?: UserProfilesAggregateInput | null | undefined;
  OR?: Array<UserProfilesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: UserProfilesNodeAggregationWhereInput | null | undefined;
};

export type UserProfilesConnectFieldInput = {
  connect?: Array<ProfileConnectInput> | null | undefined;
  edge?: ProfileRelationPropertiesCreateInput | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: ProfileConnectWhere | null | undefined;
};

export type UserProfilesConnectionWhere = {
  AND?: Array<UserProfilesConnectionWhere> | null | undefined;
  NOT?: UserProfilesConnectionWhere | null | undefined;
  OR?: Array<UserProfilesConnectionWhere> | null | undefined;
  edge?: ProfileRelationPropertiesWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: ProfileRelationPropertiesWhere | null | undefined;
  node?: ProfileWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: ProfileWhere | null | undefined;
};

export type UserProfilesCreateFieldInput = {
  edge?: ProfileRelationPropertiesCreateInput | null | undefined;
  node: ProfileCreateInput;
};

export type UserProfilesDeleteFieldInput = {
  delete?: ProfileDeleteInput | null | undefined;
  where?: UserProfilesConnectionWhere | null | undefined;
};

export type UserProfilesDisconnectFieldInput = {
  disconnect?: ProfileDisconnectInput | null | undefined;
  where?: UserProfilesConnectionWhere | null | undefined;
};

export type UserProfilesFieldInput = {
  connect?: Array<UserProfilesConnectFieldInput> | null | undefined;
  create?: Array<UserProfilesCreateFieldInput> | null | undefined;
};

export type UserProfilesNodeAggregationWhereInput = {
  AND?: Array<UserProfilesNodeAggregationWhereInput> | null | undefined;
  NOT?: UserProfilesNodeAggregationWhereInput | null | undefined;
  OR?: Array<UserProfilesNodeAggregationWhereInput> | null | undefined;
  email_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  email_AVERAGE_LENGTH_GT?: number | null | undefined;
  email_AVERAGE_LENGTH_GTE?: number | null | undefined;
  email_AVERAGE_LENGTH_LT?: number | null | undefined;
  email_AVERAGE_LENGTH_LTE?: number | null | undefined;
  email_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  email_LONGEST_LENGTH_GT?: number | null | undefined;
  email_LONGEST_LENGTH_GTE?: number | null | undefined;
  email_LONGEST_LENGTH_LT?: number | null | undefined;
  email_LONGEST_LENGTH_LTE?: number | null | undefined;
  email_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  email_SHORTEST_LENGTH_GT?: number | null | undefined;
  email_SHORTEST_LENGTH_GTE?: number | null | undefined;
  email_SHORTEST_LENGTH_LT?: number | null | undefined;
  email_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_LONGEST_LENGTH_GT?: number | null | undefined;
  firstName_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstName_LONGEST_LENGTH_LT?: number | null | undefined;
  firstName_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_GTE?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LT?: number | null | undefined;
  firstNames_AVERAGE_LENGTH_LTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_GTE?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LT?: number | null | undefined;
  firstNames_LONGEST_LENGTH_LTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_GTE?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LT?: number | null | undefined;
  firstNames_SHORTEST_LENGTH_LTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LT?: number | null | undefined;
  lastName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_LONGEST_LENGTH_GT?: number | null | undefined;
  lastName_LONGEST_LENGTH_GTE?: number | null | undefined;
  lastName_LONGEST_LENGTH_LT?: number | null | undefined;
  lastName_LONGEST_LENGTH_LTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LT?: number | null | undefined;
  lastName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LT?: number | null | undefined;
  prefixName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_GTE?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LT?: number | null | undefined;
  prefixName_LONGEST_LENGTH_LTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LT?: number | null | undefined;
  prefixName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_GTE?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LT?: number | null | undefined;
  salutation_AVERAGE_LENGTH_LTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_LONGEST_LENGTH_GT?: number | null | undefined;
  salutation_LONGEST_LENGTH_GTE?: number | null | undefined;
  salutation_LONGEST_LENGTH_LT?: number | null | undefined;
  salutation_LONGEST_LENGTH_LTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_GTE?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LT?: number | null | undefined;
  salutation_SHORTEST_LENGTH_LTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_GTE?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LT?: number | null | undefined;
  shortName_AVERAGE_LENGTH_LTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_LONGEST_LENGTH_GT?: number | null | undefined;
  shortName_LONGEST_LENGTH_GTE?: number | null | undefined;
  shortName_LONGEST_LENGTH_LT?: number | null | undefined;
  shortName_LONGEST_LENGTH_LTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_GTE?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LT?: number | null | undefined;
  shortName_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LT?: number | null | undefined;
  tecartPersonId_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_LONGEST_LENGTH_LTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LT?: number | null | undefined;
  tecartPersonId_SHORTEST_LENGTH_LTE?: number | null | undefined;
  title_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  title_AVERAGE_LENGTH_GT?: number | null | undefined;
  title_AVERAGE_LENGTH_GTE?: number | null | undefined;
  title_AVERAGE_LENGTH_LT?: number | null | undefined;
  title_AVERAGE_LENGTH_LTE?: number | null | undefined;
  title_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  title_LONGEST_LENGTH_GT?: number | null | undefined;
  title_LONGEST_LENGTH_GTE?: number | null | undefined;
  title_LONGEST_LENGTH_LT?: number | null | undefined;
  title_LONGEST_LENGTH_LTE?: number | null | undefined;
  title_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  title_SHORTEST_LENGTH_GT?: number | null | undefined;
  title_SHORTEST_LENGTH_GTE?: number | null | undefined;
  title_SHORTEST_LENGTH_LT?: number | null | undefined;
  title_SHORTEST_LENGTH_LTE?: number | null | undefined;
  tosAccepted_MAX_EQUAL?: string | null | undefined;
  tosAccepted_MAX_GT?: string | null | undefined;
  tosAccepted_MAX_GTE?: string | null | undefined;
  tosAccepted_MAX_LT?: string | null | undefined;
  tosAccepted_MAX_LTE?: string | null | undefined;
  tosAccepted_MIN_EQUAL?: string | null | undefined;
  tosAccepted_MIN_GT?: string | null | undefined;
  tosAccepted_MIN_GTE?: string | null | undefined;
  tosAccepted_MIN_LT?: string | null | undefined;
  tosAccepted_MIN_LTE?: string | null | undefined;
  tosVersion_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_GTE?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LT?: number | null | undefined;
  tosVersion_AVERAGE_LENGTH_LTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LT?: number | null | undefined;
  tosVersion_LONGEST_LENGTH_LTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_GTE?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LT?: number | null | undefined;
  tosVersion_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type UserProfilesUpdateConnectionInput = {
  edge?: ProfileRelationPropertiesUpdateInput | null | undefined;
  node?: ProfileUpdateInput | null | undefined;
};

export type UserProfilesUpdateFieldInput = {
  connect?: Array<UserProfilesConnectFieldInput> | null | undefined;
  create?: Array<UserProfilesCreateFieldInput> | null | undefined;
  delete?: Array<UserProfilesDeleteFieldInput> | null | undefined;
  disconnect?: Array<UserProfilesDisconnectFieldInput> | null | undefined;
  update?: UserProfilesUpdateConnectionInput | null | undefined;
  where?: UserProfilesConnectionWhere | null | undefined;
};

export type UserPropertiesAggregateInput = {
  AND?: Array<UserPropertiesAggregateInput> | null | undefined;
  NOT?: UserPropertiesAggregateInput | null | undefined;
  OR?: Array<UserPropertiesAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  edge?: PropertiesScopeAggregationWhereInput | null | undefined;
  node?: UserPropertiesNodeAggregationWhereInput | null | undefined;
};

export type UserPropertiesConnectFieldInput = {
  connect?: Array<PropertyConnectInput> | null | undefined;
  edge: PropertiesScopeCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: PropertyConnectWhere | null | undefined;
};

export type UserPropertiesConnectionWhere = {
  AND?: Array<UserPropertiesConnectionWhere> | null | undefined;
  NOT?: UserPropertiesConnectionWhere | null | undefined;
  OR?: Array<UserPropertiesConnectionWhere> | null | undefined;
  edge?: PropertiesScopeWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: PropertiesScopeWhere | null | undefined;
  node?: PropertyWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: PropertyWhere | null | undefined;
};

export type UserPropertiesCreateFieldInput = {
  edge: PropertiesScopeCreateInput;
  node: PropertyCreateInput;
};

export type UserPropertiesDeleteFieldInput = {
  delete?: PropertyDeleteInput | null | undefined;
  where?: UserPropertiesConnectionWhere | null | undefined;
};

export type UserPropertiesDisconnectFieldInput = {
  disconnect?: PropertyDisconnectInput | null | undefined;
  where?: UserPropertiesConnectionWhere | null | undefined;
};

export type UserPropertiesFieldInput = {
  connect?: Array<UserPropertiesConnectFieldInput> | null | undefined;
  create?: Array<UserPropertiesCreateFieldInput> | null | undefined;
};

export type UserPropertiesNodeAggregationWhereInput = {
  AND?: Array<UserPropertiesNodeAggregationWhereInput> | null | undefined;
  NOT?: UserPropertiesNodeAggregationWhereInput | null | undefined;
  OR?: Array<UserPropertiesNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
  value_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  value_AVERAGE_LENGTH_GT?: number | null | undefined;
  value_AVERAGE_LENGTH_GTE?: number | null | undefined;
  value_AVERAGE_LENGTH_LT?: number | null | undefined;
  value_AVERAGE_LENGTH_LTE?: number | null | undefined;
  value_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  value_LONGEST_LENGTH_GT?: number | null | undefined;
  value_LONGEST_LENGTH_GTE?: number | null | undefined;
  value_LONGEST_LENGTH_LT?: number | null | undefined;
  value_LONGEST_LENGTH_LTE?: number | null | undefined;
  value_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  value_SHORTEST_LENGTH_GT?: number | null | undefined;
  value_SHORTEST_LENGTH_GTE?: number | null | undefined;
  value_SHORTEST_LENGTH_LT?: number | null | undefined;
  value_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type UserPropertiesUpdateConnectionInput = {
  edge?: PropertiesScopeUpdateInput | null | undefined;
  node?: PropertyUpdateInput | null | undefined;
};

export type UserPropertiesUpdateFieldInput = {
  connect?: Array<UserPropertiesConnectFieldInput> | null | undefined;
  create?: Array<UserPropertiesCreateFieldInput> | null | undefined;
  delete?: Array<UserPropertiesDeleteFieldInput> | null | undefined;
  disconnect?: Array<UserPropertiesDisconnectFieldInput> | null | undefined;
  update?: UserPropertiesUpdateConnectionInput | null | undefined;
  where?: UserPropertiesConnectionWhere | null | undefined;
};

export type UserTwoFactorMethodsAggregateInput = {
  AND?: Array<UserTwoFactorMethodsAggregateInput> | null | undefined;
  NOT?: UserTwoFactorMethodsAggregateInput | null | undefined;
  OR?: Array<UserTwoFactorMethodsAggregateInput> | null | undefined;
  count?: number | null | undefined;
  count_GT?: number | null | undefined;
  count_GTE?: number | null | undefined;
  count_LT?: number | null | undefined;
  count_LTE?: number | null | undefined;
  node?: UserTwoFactorMethodsNodeAggregationWhereInput | null | undefined;
};

export type UserTwoFactorMethodsConnectFieldInput = {
  connect?: Array<TwoFactorMethodConnectInput> | null | undefined;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: boolean;
  where?: TwoFactorMethodConnectWhere | null | undefined;
};

export type UserTwoFactorMethodsConnectionWhere = {
  AND?: Array<UserTwoFactorMethodsConnectionWhere> | null | undefined;
  NOT?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  OR?: Array<UserTwoFactorMethodsConnectionWhere> | null | undefined;
  node?: TwoFactorMethodWhere | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: TwoFactorMethodWhere | null | undefined;
};

export type UserTwoFactorMethodsCreateFieldInput = {
  node: TwoFactorMethodCreateInput;
};

export type UserTwoFactorMethodsDeleteFieldInput = {
  delete?: TwoFactorMethodDeleteInput | null | undefined;
  where?: UserTwoFactorMethodsConnectionWhere | null | undefined;
};

export type UserTwoFactorMethodsDisconnectFieldInput = {
  disconnect?: TwoFactorMethodDisconnectInput | null | undefined;
  where?: UserTwoFactorMethodsConnectionWhere | null | undefined;
};

export type UserTwoFactorMethodsFieldInput = {
  connect?: Array<UserTwoFactorMethodsConnectFieldInput> | null | undefined;
  create?: Array<UserTwoFactorMethodsCreateFieldInput> | null | undefined;
};

export type UserTwoFactorMethodsNodeAggregationWhereInput = {
  AND?: Array<UserTwoFactorMethodsNodeAggregationWhereInput> | null | undefined;
  NOT?: UserTwoFactorMethodsNodeAggregationWhereInput | null | undefined;
  OR?: Array<UserTwoFactorMethodsNodeAggregationWhereInput> | null | undefined;
  name_AVERAGE_LENGTH_EQUAL?: number | null | undefined;
  name_AVERAGE_LENGTH_GT?: number | null | undefined;
  name_AVERAGE_LENGTH_GTE?: number | null | undefined;
  name_AVERAGE_LENGTH_LT?: number | null | undefined;
  name_AVERAGE_LENGTH_LTE?: number | null | undefined;
  name_LONGEST_LENGTH_EQUAL?: number | null | undefined;
  name_LONGEST_LENGTH_GT?: number | null | undefined;
  name_LONGEST_LENGTH_GTE?: number | null | undefined;
  name_LONGEST_LENGTH_LT?: number | null | undefined;
  name_LONGEST_LENGTH_LTE?: number | null | undefined;
  name_SHORTEST_LENGTH_EQUAL?: number | null | undefined;
  name_SHORTEST_LENGTH_GT?: number | null | undefined;
  name_SHORTEST_LENGTH_GTE?: number | null | undefined;
  name_SHORTEST_LENGTH_LT?: number | null | undefined;
  name_SHORTEST_LENGTH_LTE?: number | null | undefined;
};

export type UserTwoFactorMethodsUpdateConnectionInput = {
  node?: TwoFactorMethodUpdateInput | null | undefined;
};

export type UserTwoFactorMethodsUpdateFieldInput = {
  connect?: Array<UserTwoFactorMethodsConnectFieldInput> | null | undefined;
  create?: Array<UserTwoFactorMethodsCreateFieldInput> | null | undefined;
  delete?: Array<UserTwoFactorMethodsDeleteFieldInput> | null | undefined;
  disconnect?: Array<UserTwoFactorMethodsDisconnectFieldInput> | null | undefined;
  update?: UserTwoFactorMethodsUpdateConnectionInput | null | undefined;
  where?: UserTwoFactorMethodsConnectionWhere | null | undefined;
};

export type UserUpdateInput = {
  email?: string | null | undefined;
  emailVerified?: boolean | null | undefined;
  federatedClient?: Array<UserFederatedClientUpdateFieldInput> | null | undefined;
  impersonateOnly?: boolean | null | undefined;
  invitationFrontendUrl?: string | null | undefined;
  invitationOtpValidUntil?: string | null | undefined;
  newEmail?: string | null | undefined;
  newEmailOtpValidUntil?: string | null | undefined;
  passwordChangedAt?: string | null | undefined;
  preferredLanguage?: string | null | undefined;
  preferredTheme?: string | null | undefined;
  profiles?: Array<UserProfilesUpdateFieldInput> | null | undefined;
  properties?: Array<UserPropertiesUpdateFieldInput> | null | undefined;
  recoveryCodesGeneratedAt?: string | null | undefined;
  resetPasswordOtpValidUntil?: string | null | undefined;
  twoFactorMethods?: Array<UserTwoFactorMethodsUpdateFieldInput> | null | undefined;
};

export type UserWhere = {
  AND?: Array<UserWhere> | null | undefined;
  NOT?: UserWhere | null | undefined;
  OR?: Array<UserWhere> | null | undefined;
  email?: string | null | undefined;
  emailLower?: string | null | undefined;
  emailLower_CONTAINS?: string | null | undefined;
  emailLower_ENDS_WITH?: string | null | undefined;
  emailLower_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailLower_NOT_STARTS_WITH?: string | null | undefined;
  emailLower_STARTS_WITH?: string | null | undefined;
  emailVerified?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  emailVerified_NOT?: boolean | null | undefined;
  email_CONTAINS?: string | null | undefined;
  email_ENDS_WITH?: string | null | undefined;
  email_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: Array<string> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: string | null | undefined;
  email_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `federatedClient_SOME` instead. */
  federatedClient?: FederatedClientWhere | null | undefined;
  federatedClientAggregate?: UserFederatedClientAggregateInput | null | undefined;
  /** @deprecated Use `federatedClientConnection_SOME` instead. */
  federatedClientConnection?: UserFederatedClientConnectionWhere | null | undefined;
  /** Return Users where all of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_ALL?: UserFederatedClientConnectionWhere | null | undefined;
  /** Return Users where none of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_NONE?: UserFederatedClientConnectionWhere | null | undefined;
  /** @deprecated Use `federatedClientConnection_NONE` instead. */
  federatedClientConnection_NOT?: UserFederatedClientConnectionWhere | null | undefined;
  /** Return Users where one of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_SINGLE?: UserFederatedClientConnectionWhere | null | undefined;
  /** Return Users where some of the related UserFederatedClientConnections match this filter */
  federatedClientConnection_SOME?: UserFederatedClientConnectionWhere | null | undefined;
  /** Return Users where all of the related FederatedClients match this filter */
  federatedClient_ALL?: FederatedClientWhere | null | undefined;
  /** Return Users where none of the related FederatedClients match this filter */
  federatedClient_NONE?: FederatedClientWhere | null | undefined;
  /** @deprecated Use `federatedClient_NONE` instead. */
  federatedClient_NOT?: FederatedClientWhere | null | undefined;
  /** Return Users where one of the related FederatedClients match this filter */
  federatedClient_SINGLE?: FederatedClientWhere | null | undefined;
  /** Return Users where some of the related FederatedClients match this filter */
  federatedClient_SOME?: FederatedClientWhere | null | undefined;
  impersonateOnly?: boolean | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  impersonateOnly_NOT?: boolean | null | undefined;
  invitationFrontendUrl?: string | null | undefined;
  invitationFrontendUrl_CONTAINS?: string | null | undefined;
  invitationFrontendUrl_ENDS_WITH?: string | null | undefined;
  invitationFrontendUrl_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationFrontendUrl_NOT_STARTS_WITH?: string | null | undefined;
  invitationFrontendUrl_STARTS_WITH?: string | null | undefined;
  invitationOtpValidUntil?: string | null | undefined;
  invitationOtpValidUntil_GT?: string | null | undefined;
  invitationOtpValidUntil_GTE?: string | null | undefined;
  invitationOtpValidUntil_IN?: Array<string | null | undefined> | null | undefined;
  invitationOtpValidUntil_LT?: string | null | undefined;
  invitationOtpValidUntil_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationOtpValidUntil_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  invitationOtpValidUntil_NOT_IN?: Array<string | null | undefined> | null | undefined;
  lastLogin?: string | null | undefined;
  lastLogin_GT?: string | null | undefined;
  lastLogin_GTE?: string | null | undefined;
  lastLogin_IN?: Array<string | null | undefined> | null | undefined;
  lastLogin_LT?: string | null | undefined;
  lastLogin_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastLogin_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastLogin_NOT_IN?: Array<string | null | undefined> | null | undefined;
  newEmail?: string | null | undefined;
  newEmailOtpValidUntil?: string | null | undefined;
  newEmailOtpValidUntil_GT?: string | null | undefined;
  newEmailOtpValidUntil_GTE?: string | null | undefined;
  newEmailOtpValidUntil_IN?: Array<string | null | undefined> | null | undefined;
  newEmailOtpValidUntil_LT?: string | null | undefined;
  newEmailOtpValidUntil_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmailOtpValidUntil_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmailOtpValidUntil_NOT_IN?: Array<string | null | undefined> | null | undefined;
  newEmail_CONTAINS?: string | null | undefined;
  newEmail_ENDS_WITH?: string | null | undefined;
  newEmail_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  newEmail_NOT_STARTS_WITH?: string | null | undefined;
  newEmail_STARTS_WITH?: string | null | undefined;
  passwordChangedAt?: string | null | undefined;
  passwordChangedAt_GT?: string | null | undefined;
  passwordChangedAt_GTE?: string | null | undefined;
  passwordChangedAt_IN?: Array<string | null | undefined> | null | undefined;
  passwordChangedAt_LT?: string | null | undefined;
  passwordChangedAt_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  passwordChangedAt_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  passwordChangedAt_NOT_IN?: Array<string | null | undefined> | null | undefined;
  preferredLanguage?: string | null | undefined;
  preferredLanguage_CONTAINS?: string | null | undefined;
  preferredLanguage_ENDS_WITH?: string | null | undefined;
  preferredLanguage_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredLanguage_NOT_STARTS_WITH?: string | null | undefined;
  preferredLanguage_STARTS_WITH?: string | null | undefined;
  preferredTheme?: string | null | undefined;
  preferredTheme_CONTAINS?: string | null | undefined;
  preferredTheme_ENDS_WITH?: string | null | undefined;
  preferredTheme_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_CONTAINS?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_ENDS_WITH?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  preferredTheme_NOT_STARTS_WITH?: string | null | undefined;
  preferredTheme_STARTS_WITH?: string | null | undefined;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: ProfileWhere | null | undefined;
  profilesAggregate?: UserProfilesAggregateInput | null | undefined;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: UserProfilesConnectionWhere | null | undefined;
  /** Return Users where all of the related UserProfilesConnections match this filter */
  profilesConnection_ALL?: UserProfilesConnectionWhere | null | undefined;
  /** Return Users where none of the related UserProfilesConnections match this filter */
  profilesConnection_NONE?: UserProfilesConnectionWhere | null | undefined;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: UserProfilesConnectionWhere | null | undefined;
  /** Return Users where one of the related UserProfilesConnections match this filter */
  profilesConnection_SINGLE?: UserProfilesConnectionWhere | null | undefined;
  /** Return Users where some of the related UserProfilesConnections match this filter */
  profilesConnection_SOME?: UserProfilesConnectionWhere | null | undefined;
  /** Return Users where all of the related Profiles match this filter */
  profiles_ALL?: ProfileWhere | null | undefined;
  /** Return Users where none of the related Profiles match this filter */
  profiles_NONE?: ProfileWhere | null | undefined;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: ProfileWhere | null | undefined;
  /** Return Users where one of the related Profiles match this filter */
  profiles_SINGLE?: ProfileWhere | null | undefined;
  /** Return Users where some of the related Profiles match this filter */
  profiles_SOME?: ProfileWhere | null | undefined;
  /** @deprecated Use `properties_SOME` instead. */
  properties?: PropertyWhere | null | undefined;
  propertiesAggregate?: UserPropertiesAggregateInput | null | undefined;
  /** @deprecated Use `propertiesConnection_SOME` instead. */
  propertiesConnection?: UserPropertiesConnectionWhere | null | undefined;
  /** Return Users where all of the related UserPropertiesConnections match this filter */
  propertiesConnection_ALL?: UserPropertiesConnectionWhere | null | undefined;
  /** Return Users where none of the related UserPropertiesConnections match this filter */
  propertiesConnection_NONE?: UserPropertiesConnectionWhere | null | undefined;
  /** @deprecated Use `propertiesConnection_NONE` instead. */
  propertiesConnection_NOT?: UserPropertiesConnectionWhere | null | undefined;
  /** Return Users where one of the related UserPropertiesConnections match this filter */
  propertiesConnection_SINGLE?: UserPropertiesConnectionWhere | null | undefined;
  /** Return Users where some of the related UserPropertiesConnections match this filter */
  propertiesConnection_SOME?: UserPropertiesConnectionWhere | null | undefined;
  /** Return Users where all of the related Properties match this filter */
  properties_ALL?: PropertyWhere | null | undefined;
  /** Return Users where none of the related Properties match this filter */
  properties_NONE?: PropertyWhere | null | undefined;
  /** @deprecated Use `properties_NONE` instead. */
  properties_NOT?: PropertyWhere | null | undefined;
  /** Return Users where one of the related Properties match this filter */
  properties_SINGLE?: PropertyWhere | null | undefined;
  /** Return Users where some of the related Properties match this filter */
  properties_SOME?: PropertyWhere | null | undefined;
  recoveryCodesGeneratedAt?: string | null | undefined;
  recoveryCodesGeneratedAt_GT?: string | null | undefined;
  recoveryCodesGeneratedAt_GTE?: string | null | undefined;
  recoveryCodesGeneratedAt_IN?: Array<string | null | undefined> | null | undefined;
  recoveryCodesGeneratedAt_LT?: string | null | undefined;
  recoveryCodesGeneratedAt_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recoveryCodesGeneratedAt_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recoveryCodesGeneratedAt_NOT_IN?: Array<string | null | undefined> | null | undefined;
  resetPasswordOtpValidUntil?: string | null | undefined;
  resetPasswordOtpValidUntil_GT?: string | null | undefined;
  resetPasswordOtpValidUntil_GTE?: string | null | undefined;
  resetPasswordOtpValidUntil_IN?: Array<string | null | undefined> | null | undefined;
  resetPasswordOtpValidUntil_LT?: string | null | undefined;
  resetPasswordOtpValidUntil_LTE?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  resetPasswordOtpValidUntil_NOT?: string | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  resetPasswordOtpValidUntil_NOT_IN?: Array<string | null | undefined> | null | undefined;
  /** @deprecated Use `twoFactorMethods_SOME` instead. */
  twoFactorMethods?: TwoFactorMethodWhere | null | undefined;
  twoFactorMethodsAggregate?: UserTwoFactorMethodsAggregateInput | null | undefined;
  /** @deprecated Use `twoFactorMethodsConnection_SOME` instead. */
  twoFactorMethodsConnection?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  /** Return Users where all of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_ALL?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  /** Return Users where none of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_NONE?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  /** @deprecated Use `twoFactorMethodsConnection_NONE` instead. */
  twoFactorMethodsConnection_NOT?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  /** Return Users where one of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_SINGLE?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  /** Return Users where some of the related UserTwoFactorMethodsConnections match this filter */
  twoFactorMethodsConnection_SOME?: UserTwoFactorMethodsConnectionWhere | null | undefined;
  /** Return Users where all of the related TwoFactorMethods match this filter */
  twoFactorMethods_ALL?: TwoFactorMethodWhere | null | undefined;
  /** Return Users where none of the related TwoFactorMethods match this filter */
  twoFactorMethods_NONE?: TwoFactorMethodWhere | null | undefined;
  /** @deprecated Use `twoFactorMethods_NONE` instead. */
  twoFactorMethods_NOT?: TwoFactorMethodWhere | null | undefined;
  /** Return Users where one of the related TwoFactorMethods match this filter */
  twoFactorMethods_SINGLE?: TwoFactorMethodWhere | null | undefined;
  /** Return Users where some of the related TwoFactorMethods match this filter */
  twoFactorMethods_SOME?: TwoFactorMethodWhere | null | undefined;
  uuid?: string | number | null | undefined;
  uuid_CONTAINS?: string | number | null | undefined;
  uuid_ENDS_WITH?: string | number | null | undefined;
  uuid_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: string | number | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: Array<string | number> | null | undefined;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: string | number | null | undefined;
  uuid_STARTS_WITH?: string | number | null | undefined;
};

export type ApplicationFormModal_ApplicationFragment = {
  uuid: string;
  name: string;
  clientId: string;
  uri: string | null;
} & { " $fragmentName"?: "ApplicationFormModal_ApplicationFragment" };

export type ApplicationFormModal_CreateApplicationMutationVariables = Exact<{
  input: Array<ApplicationCreateInput> | ApplicationCreateInput;
}>;

export type ApplicationFormModal_CreateApplicationMutation = {
  createApplications: {
    applications: Array<{
      " $fragmentRefs"?: {
        ApplicationFormModal_ApplicationFragment: ApplicationFormModal_ApplicationFragment;
      };
    }>;
  };
};

export type ApplicationFormModal_UpdateApplicationMutationVariables = Exact<{
  where: ApplicationWhere;
  update: ApplicationUpdateInput;
}>;

export type ApplicationFormModal_UpdateApplicationMutation = {
  updateApplications: {
    applications: Array<{
      " $fragmentRefs"?: {
        ApplicationFormModal_ApplicationFragment: ApplicationFormModal_ApplicationFragment;
      };
    }>;
  };
};

export type OrgPickerModal_OrganizationFragment = { uuid: string; name: string } & {
  " $fragmentName"?: "OrgPickerModal_OrganizationFragment";
};

export type OrgPickerModal_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type OrgPickerModal_QueryQuery = {
  organizations: Array<{
    " $fragmentRefs"?: { OrgPickerModal_OrganizationFragment: OrgPickerModal_OrganizationFragment };
  }>;
};

export type ProfilePickerModal_ProfileFragment = {
  uuid: string;
  listName: string | null;
  email: string | null;
  organization: { uuid: string; name: string };
} & { " $fragmentName"?: "ProfilePickerModal_ProfileFragment" };

export type ProfilePickerModal_QueryQueryVariables = Exact<{
  where?: ProfileWhere | null | undefined;
}>;

export type ProfilePickerModal_QueryQuery = {
  profiles: Array<{
    " $fragmentRefs"?: { ProfilePickerModal_ProfileFragment: ProfilePickerModal_ProfileFragment };
  }>;
};

export type MergeAccountsModal_MoveProfileMutationVariables = Exact<{
  where?: ProfileWhere | null | undefined;
  update?: ProfileUpdateInput | null | undefined;
}>;

export type MergeAccountsModal_MoveProfileMutation = {
  updateProfiles: { profiles: Array<{ uuid: string; user: { uuid: string } | null }> };
};

export type MergeAccountsModal_DeleteUserMutationVariables = Exact<{
  where?: UserWhere | null | undefined;
}>;

export type MergeAccountsModal_DeleteUserMutation = { deleteUsers: { __typename: "DeleteInfo" } };

export type AuditActivityList_AuditEventFragment = {
  id: string;
  action: string;
  occurredAt: string;
  actorType: string | null;
  actorId: string | null;
  targetType: string | null;
  targetId: string | null;
  metadata: string | null;
  sessionUid: string | null;
  loginCid: string | null;
} & { " $fragmentName"?: "AuditActivityList_AuditEventFragment" };

export type AuditActivityList_UserFragment = {
  uuid: string;
  email: string;
  profiles: Array<{ uuid: string; listName: string | null }>;
} & { " $fragmentName"?: "AuditActivityList_UserFragment" };

export type AuditActivityList_OrgFragment = { uuid: string; name: string } & {
  " $fragmentName"?: "AuditActivityList_OrgFragment";
};

export type AuditActivityList_QueryQueryVariables = Exact<{
  userUuid?: string | number | null | undefined;
  days?: number | null | undefined;
  limit?: number | null | undefined;
}>;

export type AuditActivityList_QueryQuery = {
  auditEvents: Array<{
    " $fragmentRefs"?: {
      AuditActivityList_AuditEventFragment: AuditActivityList_AuditEventFragment;
    };
  }>;
};

export type AuditActivityList_UsersQueryQueryVariables = Exact<{ [key: string]: never }>;

export type AuditActivityList_UsersQueryQuery = {
  users: Array<{
    " $fragmentRefs"?: { AuditActivityList_UserFragment: AuditActivityList_UserFragment };
  }>;
};

export type AuditActivityList_OrgsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type AuditActivityList_OrgsQueryQuery = {
  organizations: Array<{
    " $fragmentRefs"?: { AuditActivityList_OrgFragment: AuditActivityList_OrgFragment };
  }>;
};

export type ClientFormModal_AuthClientFragment = {
  clientId: string;
  clientName: string | null;
  clientSecret: string | null;
  tokenEndpointAuthMethod: string;
  idTokenSignedResponseAlg: string | null;
  grantTypes: Array<string>;
  responseTypes: Array<string>;
  scope: string | null;
  redirectUris: Array<string> | null;
  postLogoutRedirectUris: Array<string> | null;
  logoUri: string | null;
  tosUri: string | null;
  policyUri: string | null;
  tksExtensionPkceOptional: boolean | null;
  tksExtensionConsentOptional: boolean | null;
  tksExtensionLicenseOptional: boolean | null;
} & { " $fragmentName"?: "ClientFormModal_AuthClientFragment" };

export type ClientFormModal_CreateAuthClientsMutationVariables = Exact<{
  input: Array<AuthClientCreateInput> | AuthClientCreateInput;
}>;

export type ClientFormModal_CreateAuthClientsMutation = {
  createAuthClients: { authClients: Array<{ clientId: string }> };
};

export type ClientFormModal_UpdateAuthClientsMutationVariables = Exact<{
  clientId: string | number;
  update: AuthClientUpdateInput;
}>;

export type ClientFormModal_UpdateAuthClientsMutation = {
  updateAuthClients: { authClients: Array<{ clientId: string }> };
};

export type LinkedApplications_ApplicationFragment = {
  uuid: string;
  clientId: string;
  name: string;
  uri: string | null;
} & { " $fragmentName"?: "LinkedApplications_ApplicationFragment" };

export type LinkedApplications_QueryQueryVariables = Exact<{
  where?: ApplicationWhere | null | undefined;
}>;

export type LinkedApplications_QueryQuery = {
  applications: Array<{
    " $fragmentRefs"?: {
      LinkedApplications_ApplicationFragment: LinkedApplications_ApplicationFragment;
    };
  }>;
};

export type PimCreateFederatedClientsMutationVariables = Exact<{
  input: Array<FederatedClientCreateInput> | FederatedClientCreateInput;
}>;

export type PimCreateFederatedClientsMutation = {
  createFederatedClients: { federatedClients: Array<{ uuid: string }> };
};

export type PimUpdateFederatedClientsMutationVariables = Exact<{
  clientId: string;
  update: FederatedClientUpdateInput;
}>;

export type PimUpdateFederatedClientsMutation = {
  updateFederatedClients: { federatedClients: Array<{ uuid: string }> };
};

export type LicensedProductList_ApplicationFragment = { clientId: string; name: string } & {
  " $fragmentName"?: "LicensedProductList_ApplicationFragment";
};

export type LicensedProductList_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type LicensedProductList_QueryQuery = {
  applications: Array<{
    " $fragmentRefs"?: {
      LicensedProductList_ApplicationFragment: LicensedProductList_ApplicationFragment;
    };
  }>;
};

export type OmniOrgView_ProfileFragment = {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string | null;
  user: { uuid: string } | null;
  rolesConnection: {
    edges: Array<{
      properties: { names: Array<string> };
      node:
        | { __typename: "Group" }
        | { __typename: "Organization"; uuid: string }
        | { __typename: "Profile" }
        | { __typename: "User" };
    }>;
  };
} & { " $fragmentName"?: "OmniOrgView_ProfileFragment" };

export type OmniOrgView_QueryQueryVariables = Exact<{
  where?: ProfileWhere | null | undefined;
}>;

export type OmniOrgView_QueryQuery = {
  profiles: Array<{
    " $fragmentRefs"?: { OmniOrgView_ProfileFragment: OmniOrgView_ProfileFragment };
  }>;
};

export type OrgShared_OrganizationFragment = {
  uuid: string;
  name: string;
  zipCode: string | null;
  city: string | null;
  region: string | null;
  country: string | null;
  profilesConnection: { totalCount: number };
  licensedApplicationsConnection: {
    edges: Array<{
      properties: {
        notBefore: string | null;
        notAfter: string | null;
        licensedModules: Array<string> | null;
        tecartContractId: string | null;
      };
      node: { uuid: string; clientId: string };
    }>;
  };
  federatedClientConnection: {
    totalCount: number;
    edges: Array<{ node: { name: string; label: string } }>;
  };
  shadowsProfilesToConnection: {
    edges: Array<{
      properties: { conditions: string; optIn: boolean };
      node: { name: string; uuid: string };
    }>;
  };
} & { " $fragmentName"?: "OrgShared_OrganizationFragment" };

export type AddMemberModal_CreateProfileMutationVariables = Exact<{
  input: Array<ProfileCreateInput> | ProfileCreateInput;
}>;

export type AddMemberModal_CreateProfileMutation = {
  createProfiles: { profiles: Array<{ uuid: string }> };
};

export type BulkLicenseModal_ApplicationFragment = {
  uuid: string;
  name: string;
  licensedOrganizations: Array<{ uuid: string }>;
} & { " $fragmentName"?: "BulkLicenseModal_ApplicationFragment" };

export type BulkLicenseModal_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type BulkLicenseModal_QueryQuery = {
  applications: Array<{
    " $fragmentRefs"?: {
      BulkLicenseModal_ApplicationFragment: BulkLicenseModal_ApplicationFragment;
    };
  }>;
};

export type BulkLicenseModal_UpdateApplicationMutationVariables = Exact<{
  where: ApplicationWhere;
  update: ApplicationUpdateInput;
}>;

export type BulkLicenseModal_UpdateApplicationMutation = {
  updateApplications: { applications: Array<{ uuid: string }> };
};

export type EditProfileModal_UpdateProfileMutationVariables = Exact<{
  where?: ProfileWhere | null | undefined;
  update?: ProfileUpdateInput | null | undefined;
}>;

export type EditProfileModal_UpdateProfileMutation = {
  updateProfiles: { profiles: Array<{ uuid: string }> };
};

export type GroupMembersModal_ProfileFragment = {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string | null;
} & { " $fragmentName"?: "GroupMembersModal_ProfileFragment" };

export type GroupMembersModal_QueryQueryVariables = Exact<{
  where?: ProfileWhere | null | undefined;
}>;

export type GroupMembersModal_QueryQuery = {
  profiles: Array<{
    " $fragmentRefs"?: { GroupMembersModal_ProfileFragment: GroupMembersModal_ProfileFragment };
  }>;
};

export type GroupMembersModal_UpdateGroupMutationVariables = Exact<{
  where?: GroupWhere | null | undefined;
  update?: GroupUpdateInput | null | undefined;
}>;

export type GroupMembersModal_UpdateGroupMutation = {
  updateGroups: { groups: Array<{ uuid: string }> };
};

export type GroupModal_CreateGroupMutationVariables = Exact<{
  input: Array<GroupCreateInput> | GroupCreateInput;
}>;

export type GroupModal_CreateGroupMutation = { createGroups: { groups: Array<{ name: string }> } };

export type GroupModal_UpdateGroupMutationVariables = Exact<{
  where?: GroupWhere | null | undefined;
  update?: GroupUpdateInput | null | undefined;
}>;

export type GroupModal_UpdateGroupMutation = { updateGroups: { groups: Array<{ uuid: string }> } };

export type LicenseModal_ApplicationFragment = {
  uuid: string;
  name: string;
  licensedOrganizations: Array<{ uuid: string }>;
  accessGrantedProfiles: Array<{ uuid: string }>;
} & { " $fragmentName"?: "LicenseModal_ApplicationFragment" };

export type LicenseModal_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type LicenseModal_QueryQuery = {
  applications: Array<{
    " $fragmentRefs"?: { LicenseModal_ApplicationFragment: LicenseModal_ApplicationFragment };
  }>;
};

export type LicenseModal_UpdateApplicationMutationVariables = Exact<{
  where: ApplicationWhere;
  update: ApplicationUpdateInput;
}>;

export type LicenseModal_UpdateApplicationMutation = {
  updateApplications: { applications: Array<{ uuid: string }> };
};

export type ModuleEditModal_UpdateApplicationMutationVariables = Exact<{
  where: ApplicationWhere;
  update: ApplicationUpdateInput;
}>;

export type ModuleEditModal_UpdateApplicationMutation = {
  updateApplications: { applications: Array<{ uuid: string }> };
};

export type OrgFormModal_OrganizationFragment = {
  uuid: string;
  name: string;
  zipCode: string | null;
  city: string | null;
  region: string | null;
  country: string | null;
} & { " $fragmentName"?: "OrgFormModal_OrganizationFragment" };

export type OrgFormModal_CreateOrganizationMutationVariables = Exact<{
  input: Array<OrganizationCreateInput> | OrganizationCreateInput;
}>;

export type OrgFormModal_CreateOrganizationMutation = {
  createOrganizations: { organizations: Array<{ uuid: string }> };
};

export type OrgFormModal_CreateAdminProfileMutationVariables = Exact<{
  input: Array<ProfileCreateInput> | ProfileCreateInput;
}>;

export type OrgFormModal_CreateAdminProfileMutation = {
  createProfiles: { profiles: Array<{ uuid: string }> };
};

export type OrgFormModal_UpdateOrganizationMutationVariables = Exact<{
  where?: OrganizationWhere | null | undefined;
  update?: OrganizationUpdateInput | null | undefined;
}>;

export type OrgFormModal_UpdateOrganizationMutation = {
  updateOrganizations: { organizations: Array<{ uuid: string }> };
};

export type GroupsPanel_OrganizationFragment = { uuid: string; name: string } & {
  " $fragmentName"?: "GroupsPanel_OrganizationFragment";
};

export type GroupsPanel_GroupFragment = {
  uuid: string;
  name: string;
  publicVisible: boolean | null;
  profilesConnection: { totalCount: number };
  profiles: Array<{ uuid: string }>;
} & { " $fragmentName"?: "GroupsPanel_GroupFragment" };

export type GroupsPanel_QueryQueryVariables = Exact<{
  where?: GroupWhere | null | undefined;
}>;

export type GroupsPanel_QueryQuery = {
  groups: Array<{ " $fragmentRefs"?: { GroupsPanel_GroupFragment: GroupsPanel_GroupFragment } }>;
};

export type GroupsPanel_DeleteGroupMutationVariables = Exact<{
  where?: GroupWhere | null | undefined;
}>;

export type GroupsPanel_DeleteGroupMutation = { deleteGroups: { __typename: "DeleteInfo" } };

export type MembersPanel_OrganizationFragment = {
  uuid: string;
  name: string;
  licensedApplicationsConnection: {
    edges: Array<{ node: { clientId: string; uri: string | null } }>;
  };
} & { " $fragmentName"?: "MembersPanel_OrganizationFragment" };

export type MembersPanel_ProfileFragment = {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string | null;
  user: {
    uuid: string;
    emailVerified: boolean;
    invitationOtpValidUntil: string | null;
    impersonateOnly: boolean | null;
  } | null;
  rolesConnection: {
    edges: Array<{
      properties: { names: Array<string> };
      node:
        | { __typename: "Group" }
        | { __typename: "Organization"; uuid: string }
        | { __typename: "Profile" }
        | { __typename: "User" };
    }>;
  };
} & { " $fragmentName"?: "MembersPanel_ProfileFragment" };

export type MembersPanel_QueryQueryVariables = Exact<{
  where?: ProfileWhere | null | undefined;
}>;

export type MembersPanel_QueryQuery = {
  profiles: Array<{
    " $fragmentRefs"?: { MembersPanel_ProfileFragment: MembersPanel_ProfileFragment };
  }>;
};

export type MembersPanel_DeleteProfileMutationVariables = Exact<{
  where?: ProfileWhere | null | undefined;
}>;

export type MembersPanel_DeleteProfileMutation = { deleteProfiles: { __typename: "DeleteInfo" } };

export type ProductsTab_OrganizationFragment = {
  uuid: string;
  name: string;
  licensedApplicationsConnection: {
    edges: Array<{
      properties: {
        notBefore: string | null;
        notAfter: string | null;
        licensedModules: Array<string> | null;
        tecartContractId: string | null;
      };
      node: { uuid: string; clientId: string };
    }>;
  };
} & { " $fragmentName"?: "ProductsTab_OrganizationFragment" };

export type AccountCard_UpdatePasswordMutationVariables = Exact<{
  userUuid: string | number;
  newPassword: string;
  oldPassword?: string | null | undefined;
}>;

export type AccountCard_UpdatePasswordMutation = {
  updatePasswords: { users: Array<{ uuid: string }> };
};

export type AccountCard_UpdateUserMutationVariables = Exact<{
  where?: UserWhere | null | undefined;
  update?: UserUpdateInput | null | undefined;
}>;

export type AccountCard_UpdateUserMutation = { updateUsers: { users: Array<{ uuid: string }> } };

export type AccountCard_RevokeInvitationMutationVariables = Exact<{
  userUuid: string | number;
}>;

export type AccountCard_RevokeInvitationMutation = {
  revokeInvitation: { users: Array<{ uuid: string }> };
};

export type AccountCard_RevokePasswordResetMutationVariables = Exact<{
  userUuid: string | number;
}>;

export type AccountCard_RevokePasswordResetMutation = {
  revokePasswordReset: { users: Array<{ uuid: string }> };
};

export type AccountCard_DeleteUserMutationVariables = Exact<{
  where?: UserWhere | null | undefined;
}>;

export type AccountCard_DeleteUserMutation = { deleteUsers: { __typename: "DeleteInfo" } };

export type EditAccountModal_UpdateUserMutationVariables = Exact<{
  where?: UserWhere | null | undefined;
  update?: UserUpdateInput | null | undefined;
}>;

export type EditAccountModal_UpdateUserMutation = {
  updateUsers: { users: Array<{ uuid: string }> };
};

export type EditAccountModal_SetImpersonateOnlyMutationVariables = Exact<{
  userUuid: string | number;
  impersonateOnly: boolean;
}>;

export type EditAccountModal_SetImpersonateOnlyMutation = {
  setImpersonateOnly: { users: Array<{ uuid: string }> };
};

export type ProfileActionsMenu_DetachProfileMutationVariables = Exact<{
  where?: ProfileWhere | null | undefined;
  update?: ProfileUpdateInput | null | undefined;
}>;

export type ProfileActionsMenu_DetachProfileMutation = {
  updateProfiles: { profiles: Array<{ uuid: string }> };
};

export type ProfileActionsMenu_DeleteProfileMutationVariables = Exact<{
  where?: ProfileWhere | null | undefined;
}>;

export type ProfileActionsMenu_DeleteProfileMutation = {
  deleteProfiles: { __typename: "DeleteInfo" };
};

export type SearchData_OrganizationFragment = {
  uuid: string;
  name: string;
  city: string | null;
} & { " $fragmentName"?: "SearchData_OrganizationFragment" };

export type SearchData_OrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type SearchData_OrganizationsQuery = {
  organizations: Array<{
    " $fragmentRefs"?: { SearchData_OrganizationFragment: SearchData_OrganizationFragment };
  }>;
};

export type SearchData_UserFragment = {
  uuid: string;
  email: string;
  profiles: Array<{ uuid: string; listName: string | null }>;
} & { " $fragmentName"?: "SearchData_UserFragment" };

export type SearchData_UsersQueryVariables = Exact<{ [key: string]: never }>;

export type SearchData_UsersQuery = {
  users: Array<{ " $fragmentRefs"?: { SearchData_UserFragment: SearchData_UserFragment } }>;
};

export type SearchData_ApplicationFragment = { uuid: string; name: string; clientId: string } & {
  " $fragmentName"?: "SearchData_ApplicationFragment";
};

export type SearchData_ApplicationsQueryVariables = Exact<{ [key: string]: never }>;

export type SearchData_ApplicationsQuery = {
  applications: Array<{
    " $fragmentRefs"?: { SearchData_ApplicationFragment: SearchData_ApplicationFragment };
  }>;
};

export type SearchData_AuthClientFragment = { clientId: string; clientName: string | null } & {
  " $fragmentName"?: "SearchData_AuthClientFragment";
};

export type SearchData_AuthClientsQueryVariables = Exact<{ [key: string]: never }>;

export type SearchData_AuthClientsQuery = {
  authClients: Array<{
    " $fragmentRefs"?: { SearchData_AuthClientFragment: SearchData_AuthClientFragment };
  }>;
};

export type ApplicationDetailPage_ApplicationFragment = {
  uuid: string;
  clientId: string;
  name: string;
  uri: string | null;
  licensedOrganizationsConnection: {
    totalCount: number;
    edges: Array<{
      properties: {
        notAfter: string | null;
        notBefore: string | null;
        tecartContractId: string | null;
      };
      node: { uuid: string; name: string };
    }>;
  };
  accessGrantedOrganizationsConnection: { totalCount: number };
  accessGrantedProfilesConnection: { totalCount: number };
  accessGrantedOrganizations: Array<{ uuid: string; name: string }>;
  accessGrantedProfiles: Array<{ uuid: string; firstName: string; lastName: string }>;
} & { " $fragmentName"?: "ApplicationDetailPage_ApplicationFragment" };

export type ApplicationDetailPage_AuthClientFragment = {
  clientId: string;
  clientName: string | null;
} & { " $fragmentName"?: "ApplicationDetailPage_AuthClientFragment" };

export type ApplicationDetailPage_QueryQueryVariables = Exact<{
  where?: ApplicationWhere | null | undefined;
}>;

export type ApplicationDetailPage_QueryQuery = {
  applications: Array<{
    " $fragmentRefs"?: {
      ApplicationDetailPage_ApplicationFragment: ApplicationDetailPage_ApplicationFragment;
      ApplicationFormModal_ApplicationFragment: ApplicationFormModal_ApplicationFragment;
    };
  }>;
};

export type ApplicationDetailPage_AuthClientQueryQueryVariables = Exact<{
  clientId: string | number;
}>;

export type ApplicationDetailPage_AuthClientQueryQuery = {
  authClients: Array<{
    " $fragmentRefs"?: {
      ApplicationDetailPage_AuthClientFragment: ApplicationDetailPage_AuthClientFragment;
    };
  }>;
};

export type ApplicationDetailPage_DeleteApplicationMutationVariables = Exact<{
  uuid: string | number;
}>;

export type ApplicationDetailPage_DeleteApplicationMutation = {
  deleteApplications: { nodesDeleted: number };
};

export type ApplicationDetailPage_UpdateApplicationMutationVariables = Exact<{
  where: ApplicationWhere;
  update: ApplicationUpdateInput;
}>;

export type ApplicationDetailPage_UpdateApplicationMutation = {
  updateApplications: {
    applications: Array<{
      " $fragmentRefs"?: {
        ApplicationDetailPage_ApplicationFragment: ApplicationDetailPage_ApplicationFragment;
      };
    }>;
  };
};

export type ApplicationsPage_ApplicationFragment = {
  uuid: string;
  name: string;
  clientId: string;
  uri: string | null;
  licensedOrganizationsConnection: { totalCount: number };
} & { " $fragmentName"?: "ApplicationsPage_ApplicationFragment" };

export type ApplicationsPage_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicationsPage_QueryQuery = {
  applications: Array<{
    " $fragmentRefs"?: {
      ApplicationsPage_ApplicationFragment: ApplicationsPage_ApplicationFragment;
    };
  }>;
};

export type ApplicationsPage_DeleteApplicationMutationVariables = Exact<{
  uuid: string | number;
}>;

export type ApplicationsPage_DeleteApplicationMutation = {
  deleteApplications: { nodesDeleted: number };
};

export type AttentionPage_UserFragment = {
  uuid: string;
  email: string;
  emailVerified: boolean;
  emailLower: string;
  newEmail: string | null;
  impersonateOnly: boolean | null;
  invitationOtpValidUntil: string | null;
  resetPasswordOtpValidUntil: string | null;
  lastLogin: string | null;
  passwordChangedAt: string | null;
  twoFactorMethods: Array<{ uuid: string }>;
  profiles: Array<{
    uuid: string;
    listName: string | null;
    organization: { uuid: string; name: string };
  }>;
  profilesConnection: { totalCount: number };
} & { " $fragmentName"?: "AttentionPage_UserFragment" };

export type AttentionPage_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type AttentionPage_QueryQuery = {
  users: Array<{ " $fragmentRefs"?: { AttentionPage_UserFragment: AttentionPage_UserFragment } }>;
};

export type AttentionPage_UpdateUserMutationVariables = Exact<{
  userUuid: string | number;
  update: UserUpdateInput;
}>;

export type AttentionPage_UpdateUserMutation = {
  updateUsers: { users: Array<{ uuid: string; email: string; emailLower: string }> };
};

export type AuditPage_UserFragment = {
  uuid: string;
  email: string;
  profiles: Array<{ listName: string | null }>;
} & { " $fragmentName"?: "AuditPage_UserFragment" };

export type AuditPage_QueryQueryVariables = Exact<{
  uuid: string | number;
}>;

export type AuditPage_QueryQuery = {
  users: Array<{ " $fragmentRefs"?: { AuditPage_UserFragment: AuditPage_UserFragment } }>;
};

export type AuthClientDetailPage_AuthClientFragment = {
  clientId: string;
  clientName: string | null;
  clientSecret: string | null;
  redirectUris: Array<string> | null;
  postLogoutRedirectUris: Array<string> | null;
  responseTypes: Array<string>;
  grantTypes: Array<string>;
  scope: string | null;
  tokenEndpointAuthMethod: string;
  idTokenSignedResponseAlg: string | null;
  logoUri: string | null;
  tosUri: string | null;
  policyUri: string | null;
  tksExtensionPkceOptional: boolean | null;
  tksExtensionConsentOptional: boolean | null;
  tksExtensionLicenseOptional: boolean | null;
} & { " $fragmentName"?: "AuthClientDetailPage_AuthClientFragment" };

export type AuthClientDetailPage_QueryQueryVariables = Exact<{
  clientId: string | number;
}>;

export type AuthClientDetailPage_QueryQuery = {
  authClients: Array<{
    " $fragmentRefs"?: {
      AuthClientDetailPage_AuthClientFragment: AuthClientDetailPage_AuthClientFragment;
      ClientFormModal_AuthClientFragment: ClientFormModal_AuthClientFragment;
    };
  }>;
};

export type AuthClientDetailPage_DeleteAuthClientsMutationVariables = Exact<{
  clientId: string | number;
}>;

export type AuthClientDetailPage_DeleteAuthClientsMutation = {
  deleteAuthClients: { nodesDeleted: number };
};

export type AuthClientDetailPage_UpdateAuthClientsMutationVariables = Exact<{
  clientId: string | number;
  update: AuthClientUpdateInput;
}>;

export type AuthClientDetailPage_UpdateAuthClientsMutation = {
  updateAuthClients: { authClients: Array<{ clientId: string }> };
};

export type AuthClientsPage_AuthClientFragment = {
  clientId: string;
  clientName: string | null;
  tokenEndpointAuthMethod: string;
  grantTypes: Array<string>;
  redirectUris: Array<string> | null;
} & { " $fragmentName"?: "AuthClientsPage_AuthClientFragment" };

export type AuthClientsPage_QueryQueryVariables = Exact<{ [key: string]: never }>;

export type AuthClientsPage_QueryQuery = {
  authClients: Array<{
    " $fragmentRefs"?: { AuthClientsPage_AuthClientFragment: AuthClientsPage_AuthClientFragment };
  }>;
};

export type AuthClientsPage_DeleteAuthClientsMutationVariables = Exact<{
  clientId: string | number;
}>;

export type AuthClientsPage_DeleteAuthClientsMutation = {
  deleteAuthClients: { nodesDeleted: number };
};

export type PimFederatedClientsQueryVariables = Exact<{
  where?: FederatedClientWhere | null | undefined;
}>;

export type PimFederatedClientsQuery = {
  federatedClients: Array<{
    uuid: string;
    label: string;
    name: string;
    issuer: string;
    clientId: string | null;
    clientSecret: string | null;
    responseTypes: Array<string>;
    customIdClaims: Array<string> | null;
  }>;
};

export type PimDeleteFederatedClientsMutationVariables = Exact<{
  clientId: string;
}>;

export type PimDeleteFederatedClientsMutation = {
  deleteFederatedClients: { nodesDeleted: number };
};

export type OrganizationDetailPage_QueryQueryVariables = Exact<{
  where?: OrganizationWhere | null | undefined;
}>;

export type OrganizationDetailPage_QueryQuery = {
  organizations: Array<
    {
      uuid: string;
      name: string;
      zipCode: string | null;
      city: string | null;
      region: string | null;
      country: string | null;
      profilesConnection: { totalCount: number };
      federatedClientConnection: {
        totalCount: number;
        edges: Array<{ node: { name: string; label: string } }>;
      };
    } & {
      " $fragmentRefs"?: {
        ProductsTab_OrganizationFragment: ProductsTab_OrganizationFragment;
        MembersPanel_OrganizationFragment: MembersPanel_OrganizationFragment;
        GroupsPanel_OrganizationFragment: GroupsPanel_OrganizationFragment;
        OrgFormModal_OrganizationFragment: OrgFormModal_OrganizationFragment;
      };
    }
  >;
};

export type OrganizationsPage_OrganizationFragment = {
  uuid: string;
  name: string;
  city: string | null;
  profilesConnection: { totalCount: number };
  licensedApplicationsConnection: { edges: Array<{ node: { clientId: string } }> };
  federatedClientConnection: {
    totalCount: number;
    edges: Array<{ node: { name: string; label: string } }>;
  };
} & { " $fragmentName"?: "OrganizationsPage_OrganizationFragment" };

export type OrganizationsPage_QueryQueryVariables = Exact<{
  options?: OrganizationOptions | null | undefined;
}>;

export type OrganizationsPage_QueryQuery = {
  organizations: Array<{
    " $fragmentRefs"?: {
      OrganizationsPage_OrganizationFragment: OrganizationsPage_OrganizationFragment;
    };
  }>;
};

export type OverviewPage_OrganizationFragment = { uuid: string } & {
  " $fragmentName"?: "OverviewPage_OrganizationFragment";
};

export type OverviewPage_UserFragment = {
  uuid: string;
  email: string;
  emailVerified: boolean;
  emailLower: string;
  newEmail: string | null;
  impersonateOnly: boolean | null;
  invitationOtpValidUntil: string | null;
  resetPasswordOtpValidUntil: string | null;
  profiles: Array<{
    uuid: string;
    listName: string | null;
    organization: { uuid: string; name: string };
  }>;
  profilesConnection: { totalCount: number };
} & { " $fragmentName"?: "OverviewPage_UserFragment" };

export type OverviewPage_OrganizationsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type OverviewPage_OrganizationsQueryQuery = {
  organizations: Array<{
    " $fragmentRefs"?: { OverviewPage_OrganizationFragment: OverviewPage_OrganizationFragment };
  }>;
};

export type OverviewPage_UsersQueryQueryVariables = Exact<{ [key: string]: never }>;

export type OverviewPage_UsersQueryQuery = {
  users: Array<{ " $fragmentRefs"?: { OverviewPage_UserFragment: OverviewPage_UserFragment } }>;
};

export type OverviewPage_ProductUsageQueryQueryVariables = Exact<{ [key: string]: never }>;

export type OverviewPage_ProductUsageQueryQuery = {
  planung: Array<{ clientId: string; licensedOrganizationsConnection: { totalCount: number } }>;
  bildungsplattform: Array<{
    clientId: string;
    licensedOrganizationsConnection: { totalCount: number };
  }>;
};

export type PersonPage_UserFragment = {
  uuid: string;
  email: string;
  emailVerified: boolean;
  newEmail: string | null;
  impersonateOnly: boolean | null;
  invitationOtpValidUntil: string | null;
  invitationFrontendUrl: string | null;
  resetPasswordOtpValidUntil: string | null;
  passwordChangedAt: string | null;
  recoveryCodesGeneratedAt: string | null;
  lastLogin: string | null;
  preferredLanguage: string | null;
  twoFactorMethods: Array<{ uuid: string; name: string; type: TwoFactorMethodType }>;
  federatedClient: Array<{ uuid: string; name: string; label: string; issuer: string }>;
  profiles: Array<{
    uuid: string;
    listName: string | null;
    firstName: string;
    lastName: string;
    birthday: string | null;
    email: string | null;
    groups: Array<{ uuid: string; name: string }>;
    organization: {
      uuid: string;
      name: string;
      licensedApplicationsConnection: {
        edges: Array<{
          properties: {
            notBefore: string | null;
            notAfter: string | null;
            licensedModules: Array<string> | null;
            tecartContractId: string | null;
          };
          node: { uuid: string; clientId: string; name: string };
        }>;
      };
    };
    rolesConnection: {
      edges: Array<{
        properties: { names: Array<string> };
        node:
          | { __typename: "Group" }
          | { __typename: "Organization"; uuid: string }
          | { __typename: "Profile" }
          | { __typename: "User" };
      }>;
    };
    grantedApplications: Array<{
      uuid: string;
      name: string;
      clientId: string;
      uri: string | null;
    }>;
  }>;
  profilesConnection: { totalCount: number };
} & { " $fragmentName"?: "PersonPage_UserFragment" };

export type PersonPage_QueryQueryVariables = Exact<{
  uuid: string | number;
}>;

export type PersonPage_QueryQuery = {
  users: Array<{ " $fragmentRefs"?: { PersonPage_UserFragment: PersonPage_UserFragment } }>;
};

export const ApplicationFormModal_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationFormModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationFormModal_ApplicationFragment, unknown>;
export const OrgPickerModal_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgPickerModal_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgPickerModal_OrganizationFragment, unknown>;
export const ProfilePickerModal_ProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfilePickerModal_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "listName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePickerModal_ProfileFragment, unknown>;
export const AuditActivityList_AuditEventFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditActivityList_AuditEvent" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuditEvent" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
          { kind: "Field", name: { kind: "Name", value: "actorType" } },
          { kind: "Field", name: { kind: "Name", value: "actorId" } },
          { kind: "Field", name: { kind: "Name", value: "targetType" } },
          { kind: "Field", name: { kind: "Name", value: "targetId" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sessionUid" } },
          { kind: "Field", name: { kind: "Name", value: "loginCid" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditActivityList_AuditEventFragment, unknown>;
export const AuditActivityList_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditActivityList_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditActivityList_UserFragment, unknown>;
export const AuditActivityList_OrgFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditActivityList_Org" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditActivityList_OrgFragment, unknown>;
export const ClientFormModal_AuthClientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientFormModal_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "tokenEndpointAuthMethod" } },
          { kind: "Field", name: { kind: "Name", value: "idTokenSignedResponseAlg" } },
          { kind: "Field", name: { kind: "Name", value: "grantTypes" } },
          { kind: "Field", name: { kind: "Name", value: "responseTypes" } },
          { kind: "Field", name: { kind: "Name", value: "scope" } },
          { kind: "Field", name: { kind: "Name", value: "redirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "postLogoutRedirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "logoUri" } },
          { kind: "Field", name: { kind: "Name", value: "tosUri" } },
          { kind: "Field", name: { kind: "Name", value: "policyUri" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionPkceOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionConsentOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionLicenseOptional" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientFormModal_AuthClientFragment, unknown>;
export const LinkedApplications_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedApplications_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkedApplications_ApplicationFragment, unknown>;
export const LicensedProductList_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LicensedProductList_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicensedProductList_ApplicationFragment, unknown>;
export const OmniOrgView_ProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OmniOrgView_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "rolesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "names" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Organization" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OmniOrgView_ProfileFragment, unknown>;
export const OrgShared_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgShared_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "region" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "notBefore" } },
                            { kind: "Field", name: { kind: "Name", value: "notAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "licensedModules" } },
                            { kind: "Field", name: { kind: "Name", value: "tecartContractId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "federatedClientConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "shadowsProfilesToConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "conditions" } },
                            { kind: "Field", name: { kind: "Name", value: "optIn" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgShared_OrganizationFragment, unknown>;
export const BulkLicenseModal_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkLicenseModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkLicenseModal_ApplicationFragment, unknown>;
export const GroupMembersModal_ProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupMembersModal_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupMembersModal_ProfileFragment, unknown>;
export const LicenseModal_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LicenseModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicenseModal_ApplicationFragment, unknown>;
export const OrgFormModal_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgFormModal_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "region" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgFormModal_OrganizationFragment, unknown>;
export const GroupsPanel_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupsPanel_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupsPanel_OrganizationFragment, unknown>;
export const GroupsPanel_GroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupsPanel_Group" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Group" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "publicVisible" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupsPanel_GroupFragment, unknown>;
export const MembersPanel_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MembersPanel_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                            { kind: "Field", name: { kind: "Name", value: "uri" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MembersPanel_OrganizationFragment, unknown>;
export const MembersPanel_ProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MembersPanel_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
                { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
                { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "rolesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "names" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Organization" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MembersPanel_ProfileFragment, unknown>;
export const ProductsTab_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductsTab_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "notBefore" } },
                            { kind: "Field", name: { kind: "Name", value: "notAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "licensedModules" } },
                            { kind: "Field", name: { kind: "Name", value: "tecartContractId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductsTab_OrganizationFragment, unknown>;
export const SearchData_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_OrganizationFragment, unknown>;
export const SearchData_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_UserFragment, unknown>;
export const SearchData_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_ApplicationFragment, unknown>;
export const SearchData_AuthClientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_AuthClientFragment, unknown>;
export const ApplicationDetailPage_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationDetailPage_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "notAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "notBefore" } },
                            { kind: "Field", name: { kind: "Name", value: "tecartContractId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationDetailPage_ApplicationFragment, unknown>;
export const ApplicationDetailPage_AuthClientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationDetailPage_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationDetailPage_AuthClientFragment, unknown>;
export const ApplicationsPage_ApplicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationsPage_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationsPage_ApplicationFragment, unknown>;
export const AttentionPage_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttentionPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "emailLower" } },
          { kind: "Field", name: { kind: "Name", value: "newEmail" } },
          { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
          { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "resetPasswordOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
          { kind: "Field", name: { kind: "Name", value: "passwordChangedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "twoFactorMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttentionPage_UserFragment, unknown>;
export const AuditPage_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "listName" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditPage_UserFragment, unknown>;
export const AuthClientDetailPage_AuthClientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuthClientDetailPage_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "redirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "postLogoutRedirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "responseTypes" } },
          { kind: "Field", name: { kind: "Name", value: "grantTypes" } },
          { kind: "Field", name: { kind: "Name", value: "scope" } },
          { kind: "Field", name: { kind: "Name", value: "tokenEndpointAuthMethod" } },
          { kind: "Field", name: { kind: "Name", value: "idTokenSignedResponseAlg" } },
          { kind: "Field", name: { kind: "Name", value: "logoUri" } },
          { kind: "Field", name: { kind: "Name", value: "tosUri" } },
          { kind: "Field", name: { kind: "Name", value: "policyUri" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionPkceOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionConsentOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionLicenseOptional" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthClientDetailPage_AuthClientFragment, unknown>;
export const AuthClientsPage_AuthClientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuthClientsPage_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
          { kind: "Field", name: { kind: "Name", value: "tokenEndpointAuthMethod" } },
          { kind: "Field", name: { kind: "Name", value: "grantTypes" } },
          { kind: "Field", name: { kind: "Name", value: "redirectUris" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthClientsPage_AuthClientFragment, unknown>;
export const OrganizationsPage_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationsPage_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "federatedClientConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationsPage_OrganizationFragment, unknown>;
export const OverviewPage_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OverviewPage_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
      },
    },
  ],
} as unknown as DocumentNode<OverviewPage_OrganizationFragment, unknown>;
export const OverviewPage_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OverviewPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "emailLower" } },
          { kind: "Field", name: { kind: "Name", value: "newEmail" } },
          { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
          { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "resetPasswordOtpValidUntil" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OverviewPage_UserFragment, unknown>;
export const PersonPage_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "newEmail" } },
          { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
          { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "invitationFrontendUrl" } },
          { kind: "Field", name: { kind: "Name", value: "resetPasswordOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "passwordChangedAt" } },
          { kind: "Field", name: { kind: "Name", value: "recoveryCodesGeneratedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "twoFactorMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "federatedClient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "issuer" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthday" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensedApplicationsConnection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "properties" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "notBefore" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "notAfter" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "licensedModules" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "tecartContractId" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "clientId" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rolesConnection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "properties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "names" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Organization" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grantedApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "clientId" } },
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersonPage_UserFragment, unknown>;
export const ApplicationFormModal_CreateApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplicationFormModal_CreateApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ApplicationCreateInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ApplicationFormModal_Application" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationFormModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationFormModal_CreateApplicationMutation,
  ApplicationFormModal_CreateApplicationMutationVariables
>;
export const ApplicationFormModal_UpdateApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplicationFormModal_UpdateApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ApplicationFormModal_Application" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationFormModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationFormModal_UpdateApplicationMutation,
  ApplicationFormModal_UpdateApplicationMutationVariables
>;
export const OrgPickerModal_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrgPickerModal_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgPickerModal_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgPickerModal_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgPickerModal_QueryQuery, OrgPickerModal_QueryQueryVariables>;
export const ProfilePickerModal_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfilePickerModal_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "25" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lastName" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfilePickerModal_Profile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfilePickerModal_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "listName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePickerModal_QueryQuery, ProfilePickerModal_QueryQueryVariables>;
export const MergeAccountsModal_MoveProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MergeAccountsModal_MoveProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MergeAccountsModal_MoveProfileMutation,
  MergeAccountsModal_MoveProfileMutationVariables
>;
export const MergeAccountsModal_DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MergeAccountsModal_DeleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MergeAccountsModal_DeleteUserMutation,
  MergeAccountsModal_DeleteUserMutationVariables
>;
export const AuditActivityList_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditActivityList_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "days" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auditEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userUuid" },
                value: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "days" },
                value: { kind: "Variable", name: { kind: "Name", value: "days" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AuditActivityList_AuditEvent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditActivityList_AuditEvent" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuditEvent" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "occurredAt" } },
          { kind: "Field", name: { kind: "Name", value: "actorType" } },
          { kind: "Field", name: { kind: "Name", value: "actorId" } },
          { kind: "Field", name: { kind: "Name", value: "targetType" } },
          { kind: "Field", name: { kind: "Name", value: "targetId" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sessionUid" } },
          { kind: "Field", name: { kind: "Name", value: "loginCid" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditActivityList_QueryQuery, AuditActivityList_QueryQueryVariables>;
export const AuditActivityList_UsersQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditActivityList_UsersQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AuditActivityList_User" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditActivityList_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuditActivityList_UsersQueryQuery,
  AuditActivityList_UsersQueryQueryVariables
>;
export const AuditActivityList_OrgsQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditActivityList_OrgsQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AuditActivityList_Org" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditActivityList_Org" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuditActivityList_OrgsQueryQuery,
  AuditActivityList_OrgsQueryQueryVariables
>;
export const ClientFormModal_CreateAuthClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClientFormModal_CreateAuthClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "AuthClientCreateInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAuthClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "authClients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "clientId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientFormModal_CreateAuthClientsMutation,
  ClientFormModal_CreateAuthClientsMutationVariables
>;
export const ClientFormModal_UpdateAuthClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClientFormModal_UpdateAuthClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AuthClientUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAuthClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "authClients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "clientId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientFormModal_UpdateAuthClientsMutation,
  ClientFormModal_UpdateAuthClientsMutationVariables
>;
export const LinkedApplications_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LinkedApplications_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LinkedApplications_Application" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkedApplications_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkedApplications_QueryQuery, LinkedApplications_QueryQueryVariables>;
export const PimCreateFederatedClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "pimCreateFederatedClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "FederatedClientCreateInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFederatedClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "federatedClients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PimCreateFederatedClientsMutation,
  PimCreateFederatedClientsMutationVariables
>;
export const PimUpdateFederatedClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "pimUpdateFederatedClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FederatedClientUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFederatedClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "federatedClients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PimUpdateFederatedClientsMutation,
  PimUpdateFederatedClientsMutationVariables
>;
export const LicensedProductList_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LicensedProductList_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "name" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LicensedProductList_Application" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LicensedProductList_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LicensedProductList_QueryQuery,
  LicensedProductList_QueryQueryVariables
>;
export const OmniOrgView_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OmniOrgView_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OmniOrgView_Profile" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OmniOrgView_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "rolesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "names" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Organization" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OmniOrgView_QueryQuery, OmniOrgView_QueryQueryVariables>;
export const AddMemberModal_CreateProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddMemberModal_CreateProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "ProfileCreateInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddMemberModal_CreateProfileMutation,
  AddMemberModal_CreateProfileMutationVariables
>;
export const BulkLicenseModal_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BulkLicenseModal_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "name" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BulkLicenseModal_Application" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BulkLicenseModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkLicenseModal_QueryQuery, BulkLicenseModal_QueryQueryVariables>;
export const BulkLicenseModal_UpdateApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BulkLicenseModal_UpdateApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkLicenseModal_UpdateApplicationMutation,
  BulkLicenseModal_UpdateApplicationMutationVariables
>;
export const EditProfileModal_UpdateProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditProfileModal_UpdateProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditProfileModal_UpdateProfileMutation,
  EditProfileModal_UpdateProfileMutationVariables
>;
export const GroupMembersModal_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GroupMembersModal_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lastName" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "GroupMembersModal_Profile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupMembersModal_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupMembersModal_QueryQuery, GroupMembersModal_QueryQueryVariables>;
export const GroupMembersModal_UpdateGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GroupMembersModal_UpdateGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GroupWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GroupUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GroupMembersModal_UpdateGroupMutation,
  GroupMembersModal_UpdateGroupMutationVariables
>;
export const GroupModal_CreateGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GroupModal_CreateGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "GroupCreateInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GroupModal_CreateGroupMutation,
  GroupModal_CreateGroupMutationVariables
>;
export const GroupModal_UpdateGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GroupModal_UpdateGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GroupWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GroupUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GroupModal_UpdateGroupMutation,
  GroupModal_UpdateGroupMutationVariables
>;
export const LicenseModal_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LicenseModal_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "name" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LicenseModal_Application" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LicenseModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LicenseModal_QueryQuery, LicenseModal_QueryQueryVariables>;
export const LicenseModal_UpdateApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LicenseModal_UpdateApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LicenseModal_UpdateApplicationMutation,
  LicenseModal_UpdateApplicationMutationVariables
>;
export const ModuleEditModal_UpdateApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ModuleEditModal_UpdateApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ModuleEditModal_UpdateApplicationMutation,
  ModuleEditModal_UpdateApplicationMutationVariables
>;
export const OrgFormModal_CreateOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgFormModal_CreateOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "OrganizationCreateInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrganizations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgFormModal_CreateOrganizationMutation,
  OrgFormModal_CreateOrganizationMutationVariables
>;
export const OrgFormModal_CreateAdminProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgFormModal_CreateAdminProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "ProfileCreateInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgFormModal_CreateAdminProfileMutation,
  OrgFormModal_CreateAdminProfileMutationVariables
>;
export const OrgFormModal_UpdateOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrgFormModal_UpdateOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "OrganizationWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "OrganizationUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrganizations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrgFormModal_UpdateOrganizationMutation,
  OrgFormModal_UpdateOrganizationMutationVariables
>;
export const GroupsPanel_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GroupsPanel_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GroupWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "groups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "GroupsPanel_Group" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupsPanel_Group" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Group" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "publicVisible" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupsPanel_QueryQuery, GroupsPanel_QueryQueryVariables>;
export const GroupsPanel_DeleteGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GroupsPanel_DeleteGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GroupWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GroupsPanel_DeleteGroupMutation,
  GroupsPanel_DeleteGroupMutationVariables
>;
export const MembersPanel_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MembersPanel_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lastName" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "MembersPanel_Profile" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MembersPanel_Profile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
                { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
                { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "rolesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "names" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Organization" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MembersPanel_QueryQuery, MembersPanel_QueryQueryVariables>;
export const MembersPanel_DeleteProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MembersPanel_DeleteProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MembersPanel_DeleteProfileMutation,
  MembersPanel_DeleteProfileMutationVariables
>;
export const AccountCard_UpdatePasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AccountCard_UpdatePassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "oldPassword" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePasswords" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "oldPassword" },
                      value: { kind: "Variable", name: { kind: "Name", value: "oldPassword" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "newPassword" },
                      value: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCard_UpdatePasswordMutation,
  AccountCard_UpdatePasswordMutationVariables
>;
export const AccountCard_UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AccountCard_UpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCard_UpdateUserMutation,
  AccountCard_UpdateUserMutationVariables
>;
export const AccountCard_RevokeInvitationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AccountCard_RevokeInvitation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revokeInvitation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userUuid" },
                value: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCard_RevokeInvitationMutation,
  AccountCard_RevokeInvitationMutationVariables
>;
export const AccountCard_RevokePasswordResetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AccountCard_RevokePasswordReset" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revokePasswordReset" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userUuid" },
                value: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCard_RevokePasswordResetMutation,
  AccountCard_RevokePasswordResetMutationVariables
>;
export const AccountCard_DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AccountCard_DeleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCard_DeleteUserMutation,
  AccountCard_DeleteUserMutationVariables
>;
export const EditAccountModal_UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditAccountModal_UpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditAccountModal_UpdateUserMutation,
  EditAccountModal_UpdateUserMutationVariables
>;
export const EditAccountModal_SetImpersonateOnlyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditAccountModal_SetImpersonateOnly" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "impersonateOnly" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setImpersonateOnly" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userUuid" },
                value: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "impersonateOnly" },
                value: { kind: "Variable", name: { kind: "Name", value: "impersonateOnly" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditAccountModal_SetImpersonateOnlyMutation,
  EditAccountModal_SetImpersonateOnlyMutationVariables
>;
export const ProfileActionsMenu_DetachProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProfileActionsMenu_DetachProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileUpdateInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfileActionsMenu_DetachProfileMutation,
  ProfileActionsMenu_DetachProfileMutationVariables
>;
export const ProfileActionsMenu_DeleteProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProfileActionsMenu_DeleteProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ProfileWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfileActionsMenu_DeleteProfileMutation,
  ProfileActionsMenu_DeleteProfileMutationVariables
>;
export const SearchData_OrganizationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchData_Organizations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SearchData_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_OrganizationsQuery, SearchData_OrganizationsQueryVariables>;
export const SearchData_UsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchData_Users" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SearchData_User" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_UsersQuery, SearchData_UsersQueryVariables>;
export const SearchData_ApplicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchData_Applications" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SearchData_Application" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_ApplicationsQuery, SearchData_ApplicationsQueryVariables>;
export const SearchData_AuthClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchData_AuthClients" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "authClients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SearchData_AuthClient" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SearchData_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchData_AuthClientsQuery, SearchData_AuthClientsQueryVariables>;
export const ApplicationDetailPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ApplicationDetailPage_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApplicationDetailPage_Application" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApplicationFormModal_Application" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationDetailPage_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "notAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "notBefore" } },
                            { kind: "Field", name: { kind: "Name", value: "tecartContractId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationFormModal_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationDetailPage_QueryQuery,
  ApplicationDetailPage_QueryQueryVariables
>;
export const ApplicationDetailPage_AuthClientQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ApplicationDetailPage_AuthClientQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "authClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApplicationDetailPage_AuthClient" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationDetailPage_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationDetailPage_AuthClientQueryQuery,
  ApplicationDetailPage_AuthClientQueryQueryVariables
>;
export const ApplicationDetailPage_DeleteApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplicationDetailPage_DeleteApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "nodesDeleted" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationDetailPage_DeleteApplicationMutation,
  ApplicationDetailPage_DeleteApplicationMutationVariables
>;
export const ApplicationDetailPage_UpdateApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplicationDetailPage_UpdateApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationWhere" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ApplicationUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ApplicationDetailPage_Application" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationDetailPage_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "notAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "notBefore" } },
                            { kind: "Field", name: { kind: "Name", value: "tecartContractId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedOrganizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accessGrantedProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationDetailPage_UpdateApplicationMutation,
  ApplicationDetailPage_UpdateApplicationMutationVariables
>;
export const ApplicationsPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ApplicationsPage_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sort" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "name" },
                            value: { kind: "EnumValue", value: "ASC" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApplicationsPage_Application" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApplicationsPage_Application" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Application" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedOrganizationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplicationsPage_QueryQuery, ApplicationsPage_QueryQueryVariables>;
export const ApplicationsPage_DeleteApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplicationsPage_DeleteApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "nodesDeleted" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplicationsPage_DeleteApplicationMutation,
  ApplicationsPage_DeleteApplicationMutationVariables
>;
export const AttentionPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AttentionPage_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AttentionPage_User" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AttentionPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "emailLower" } },
          { kind: "Field", name: { kind: "Name", value: "newEmail" } },
          { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
          { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "resetPasswordOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
          { kind: "Field", name: { kind: "Name", value: "passwordChangedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "twoFactorMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttentionPage_QueryQuery, AttentionPage_QueryQueryVariables>;
export const AttentionPage_UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AttentionPage_UpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UserUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "userUuid" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "emailLower" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttentionPage_UpdateUserMutation,
  AttentionPage_UpdateUserMutationVariables
>;
export const AuditPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditPage_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "AuditPage_User" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuditPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "listName" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditPage_QueryQuery, AuditPage_QueryQueryVariables>;
export const AuthClientDetailPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuthClientDetailPage_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "authClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AuthClientDetailPage_AuthClient" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ClientFormModal_AuthClient" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuthClientDetailPage_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "redirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "postLogoutRedirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "responseTypes" } },
          { kind: "Field", name: { kind: "Name", value: "grantTypes" } },
          { kind: "Field", name: { kind: "Name", value: "scope" } },
          { kind: "Field", name: { kind: "Name", value: "tokenEndpointAuthMethod" } },
          { kind: "Field", name: { kind: "Name", value: "idTokenSignedResponseAlg" } },
          { kind: "Field", name: { kind: "Name", value: "logoUri" } },
          { kind: "Field", name: { kind: "Name", value: "tosUri" } },
          { kind: "Field", name: { kind: "Name", value: "policyUri" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionPkceOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionConsentOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionLicenseOptional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientFormModal_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "tokenEndpointAuthMethod" } },
          { kind: "Field", name: { kind: "Name", value: "idTokenSignedResponseAlg" } },
          { kind: "Field", name: { kind: "Name", value: "grantTypes" } },
          { kind: "Field", name: { kind: "Name", value: "responseTypes" } },
          { kind: "Field", name: { kind: "Name", value: "scope" } },
          { kind: "Field", name: { kind: "Name", value: "redirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "postLogoutRedirectUris" } },
          { kind: "Field", name: { kind: "Name", value: "logoUri" } },
          { kind: "Field", name: { kind: "Name", value: "tosUri" } },
          { kind: "Field", name: { kind: "Name", value: "policyUri" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionPkceOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionConsentOptional" } },
          { kind: "Field", name: { kind: "Name", value: "tksExtensionLicenseOptional" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthClientDetailPage_QueryQuery,
  AuthClientDetailPage_QueryQueryVariables
>;
export const AuthClientDetailPage_DeleteAuthClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AuthClientDetailPage_DeleteAuthClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAuthClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "nodesDeleted" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthClientDetailPage_DeleteAuthClientsMutation,
  AuthClientDetailPage_DeleteAuthClientsMutationVariables
>;
export const AuthClientDetailPage_UpdateAuthClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AuthClientDetailPage_UpdateAuthClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "update" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AuthClientUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAuthClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: { kind: "Variable", name: { kind: "Name", value: "update" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "authClients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "clientId" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthClientDetailPage_UpdateAuthClientsMutation,
  AuthClientDetailPage_UpdateAuthClientsMutationVariables
>;
export const AuthClientsPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuthClientsPage_Query" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "authClients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AuthClientsPage_AuthClient" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AuthClientsPage_AuthClient" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AuthClient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientName" } },
          { kind: "Field", name: { kind: "Name", value: "tokenEndpointAuthMethod" } },
          { kind: "Field", name: { kind: "Name", value: "grantTypes" } },
          { kind: "Field", name: { kind: "Name", value: "redirectUris" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthClientsPage_QueryQuery, AuthClientsPage_QueryQueryVariables>;
export const AuthClientsPage_DeleteAuthClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AuthClientsPage_DeleteAuthClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAuthClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "nodesDeleted" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthClientsPage_DeleteAuthClientsMutation,
  AuthClientsPage_DeleteAuthClientsMutationVariables
>;
export const PimFederatedClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "pimFederatedClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "FederatedClientWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "federatedClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "issuer" } },
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
                { kind: "Field", name: { kind: "Name", value: "responseTypes" } },
                { kind: "Field", name: { kind: "Name", value: "customIdClaims" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PimFederatedClientsQuery, PimFederatedClientsQueryVariables>;
export const PimDeleteFederatedClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "pimDeleteFederatedClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFederatedClients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clientId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "nodesDeleted" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PimDeleteFederatedClientsMutation,
  PimDeleteFederatedClientsMutationVariables
>;
export const OrganizationDetailPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrganizationDetailPage_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "where" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "OrganizationWhere" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: { kind: "Variable", name: { kind: "Name", value: "where" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "zipCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "region" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "profilesConnection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "federatedClientConnection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProductsTab_Organization" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MembersPanel_Organization" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "GroupsPanel_Organization" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrgFormModal_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductsTab_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "notBefore" } },
                            { kind: "Field", name: { kind: "Name", value: "notAfter" } },
                            { kind: "Field", name: { kind: "Name", value: "licensedModules" } },
                            { kind: "Field", name: { kind: "Name", value: "tecartContractId" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "uuid" } },
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MembersPanel_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                            { kind: "Field", name: { kind: "Name", value: "uri" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GroupsPanel_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgFormModal_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "region" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationDetailPage_QueryQuery,
  OrganizationDetailPage_QueryQueryVariables
>;
export const OrganizationsPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrganizationsPage_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "options" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "OrganizationOptions" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: { kind: "Variable", name: { kind: "Name", value: "options" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrganizationsPage_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationsPage_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "licensedApplicationsConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "clientId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "federatedClientConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationsPage_QueryQuery, OrganizationsPage_QueryQueryVariables>;
export const OverviewPage_OrganizationsQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OverviewPage_OrganizationsQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OverviewPage_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OverviewPage_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "uuid" } }],
      },
    },
  ],
} as unknown as DocumentNode<
  OverviewPage_OrganizationsQueryQuery,
  OverviewPage_OrganizationsQueryQueryVariables
>;
export const OverviewPage_UsersQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OverviewPage_UsersQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "OverviewPage_User" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OverviewPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "emailLower" } },
          { kind: "Field", name: { kind: "Name", value: "newEmail" } },
          { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
          { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "resetPasswordOtpValidUntil" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OverviewPage_UsersQueryQuery, OverviewPage_UsersQueryQueryVariables>;
export const OverviewPage_ProductUsageQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OverviewPage_ProductUsageQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "planung" },
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: {
                        kind: "StringValue",
                        value: "planung-frontend-client",
                        block: false,
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "licensedOrganizationsConnection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "bildungsplattform" },
            name: { kind: "Name", value: "applications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clientId" },
                      value: { kind: "StringValue", value: "bp-frontend-client", block: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "licensedOrganizationsConnection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OverviewPage_ProductUsageQueryQuery,
  OverviewPage_ProductUsageQueryQueryVariables
>;
export const PersonPage_QueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PersonPage_Query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "uuid" },
                      value: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "PersonPage_User" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonPage_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "newEmail" } },
          { kind: "Field", name: { kind: "Name", value: "impersonateOnly" } },
          { kind: "Field", name: { kind: "Name", value: "invitationOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "invitationFrontendUrl" } },
          { kind: "Field", name: { kind: "Name", value: "resetPasswordOtpValidUntil" } },
          { kind: "Field", name: { kind: "Name", value: "passwordChangedAt" } },
          { kind: "Field", name: { kind: "Name", value: "recoveryCodesGeneratedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "twoFactorMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "federatedClient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "issuer" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "listName" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthday" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensedApplicationsConnection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "properties" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "notBefore" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "notAfter" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "licensedModules" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "tecartContractId" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "clientId" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rolesConnection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "properties" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "names" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Organization" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "uuid" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grantedApplications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "clientId" } },
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profilesConnection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersonPage_QueryQuery, PersonPage_QueryQueryVariables>;
